import { AfterViewInit, Component, OnInit, ChangeDetectorRef, Inject, Renderer2, Input, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { faClose, faPlus, faWarning } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from 'src/app/models/claims/individual.model';
import { arrPhyLimitationType, ClaimsmonitorService } from 'src/app/services/Claims-monitor/claimsmonitor.service';
import { NotificationService } from 'src/app/notification.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import * as mammoth from "mammoth";
import * as fs from "fs";
import * as jquery from 'jquery';
import * as CommonFunction from '../../../../app/services/common.function';
import * as commonConstant from '../../../../app/services/common.constant';
import { ClientService } from 'src/app/services/Client/client.service';
import { UserService } from 'src/app/services/Users/manage-user/user.service';
import { DOCUMENT } from '@angular/common';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LINKOUT_FEATURE_ENABLED } from 'src/app/services/linkout/linkout-feature.config';
import { LinkoutService } from 'src/app/services/linkout/linkout.service';
import { environment } from 'src/environments/environment';
import { LayoutSharedService } from 'src/app/services/utilization/layoutshared.service';
import { TeamService } from 'src/app/services/Teams/team.service';

@Component({
  selector: 'app-addnew-claims',
  templateUrl: './addnew-claims.component.html',
  styleUrls: ['./addnew-claims.component.css'],
})

export class AddnewClaimsComponent implements OnInit, AfterViewInit {
  dateregex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/?|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2)(\/?|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/?|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; // /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d+$/;
  keywordRegex: RegExp = /^[^,]+$/;
  linkAnalysisRegex: RegExp = /^[^,]+$/;
  knownAsRegex: RegExp = /^[^,]+$/;
  // claimIdRegex: RegExp = /^[a-zA-Z0-9]{10}$/;  //alphanumericWithExact10Charcter
  // claimIdRegex: RegExp = /^\d{10}$/; //numeric
  // referenceIdRegex: RegExp = /^(?:-)[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*(?:!-)$/; //alphanumericWithMax30Charcter
  nameRegex: RegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ'’\-\.]+(?:\s[A-Za-zÀ-ÖØ-öø-ÿ'’\-\.]+){0,2}$/;
  referenceIdRegex: RegExp = /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*$/; //alphanumericWithMax30Charcter
  arrMonitoring: any[] = [];
  arrReportType: any[] = [];
  availableReportTypesData: string = "";
  selectedTeamAvailableReports: string = "";
  arrPhyLimitation = arrPhyLimitationType;
  arrPhysicalLimitatioin: any[] = [];
  loCurrentUserData: any;
  loCurrentTeamId: any;
  @Input() isBatch!: boolean;
  @Input() isBatchFileExt!: any;
  @Input() fileType!: any;
  faWarning = faWarning;
  batchFile!: File;
  //faceImagFile!: File;
  faceImagFile: File | null = null; // uploaded face image file
  faceImageUrl: string | ArrayBuffer | null = null;
  arrayBuffer: any; // uploaded file byte array data
  stErrorMessage!: string;
  isValidZip: boolean = false;
  isValidAdditionalZip: boolean = false;
  multiPhoneFormSubmit: boolean = false;
  multiEmailFormSubmit: boolean = false;
  multiKeywordFormSubmit: boolean = false;
  multiLinkAnalysisFormSubmit: boolean = false;
  multipleKnownAsFormSubmit: boolean = false;
  multiAddressFormSubmit: boolean = false;
  multiplePhoneForm = this.formBuilder.group({
    phone: ['', [Validators.minLength(10)]],
  });
  multipleEmailForm = this.formBuilder.group({
    email: ['', [Validators.pattern(commonConstant.emailregex)]],
  });
  multipleKeywordForm = this.formBuilder.group({
    keyword: ['', [Validators.pattern(this.keywordRegex)]],
  });
  multipleLinkAnalysisForm = this.formBuilder.group({
    linkAnalysis: ['', [Validators.pattern(this.linkAnalysisRegex)]],
  });
  multipleKnownAsForm = this.formBuilder.group({
    knownAs: ['', [Validators.pattern(this.knownAsRegex)]],
  });
  multipleAddressForm = this.formBuilder.group({
    address: ['', []],
  });
  isClaimEdit!: boolean;
  claimInfo: any;
  /** When set (e.g. link-out flow), sent on create request and used if the dialog is dismissed without submit. */
  @Input() linkOutCorrelationId?: string;
  @Input() linkOutClaimNumber?: string;
  formSubmission = new FormGroup({
    stClient: new FormControl(),
    stExaminer: new FormControl(),
    stUserTeam: new FormControl(),
    stFirstName: new FormControl(),
    stLastName: new FormControl(),
    stCompanyName: new FormControl(),
    stAddress: new FormControl(),
    // stZipcode: new FormControl(),
    stPhoneNumber: new FormControl(),
    stEmail: new FormControl(),
    dtDateofBirth: new FormControl(),
    stBatchName: new FormControl(),
    stOccupation: new FormControl(),
    dtClaimFile: new FormControl(),
    stKeywords: new FormControl(),
    stLinkAnalysis: new FormControl(),
    stKnownAs: new FormControl(),
    stReferenceId: new FormControl(),
    stGender: new FormControl(),
    stNotes: new FormControl(),
    stLicensePlate: new FormControl(),
    stState: new FormControl(),
    stAdditionalAddress: new FormControl()
    // stClaimId: new FormControl()
    //,uiMonitorId: new FormControl()
  });
  submitted = false;
  isBatchsubmitted = false;
  isError: boolean = true;
  monitoringId: any;
  reportTypeId: any = 2;
  reportTypeIdXls: any = '';
  physicalLimitationId: any;
  spaceCount: any;
  isUploadedBatchFile = false;
  validUploadedData!: number;
  totalUploadedData!: number;
  getBatchDataResponse: any[] = []; // to store uploaded census file data
  rowNumber: any;
  stFormName: any;
  batchLabelName:any;
  reviewFormName: any;
  requestText:any;
  phoneValidCount: any[] = [];
  emailValidCount: any[] = [];
  objsave: any;
  isButtonDisabled: boolean = false;
  today: any;
  isChangeDateOfBirth: any;
  isChangeClaimfileDate: any;
  isManuallyDateChange: any;
  isManuallyClaimChange: any;
  isFileExist: boolean = true;

  upFirstname = false;
  downFirstname = false;
  upLastname = false;
  downLastname = false;
  upBirthyear = false;
  downBirthyear = false;
  upAddress = false;
  downAddress= false;
  upPhone = false;
  downPhone = false;
  upEmail = false;
  downEmail = false;
  upKeyword = false;
  downKeyword = false;
  upLinkAnalysis = false;
  downLinkAnalysis = false;
  upPhyLimitation = false;
  downPhyLimitation = false;
  upReferenceID = false;
  downReferenceID = false;
  upZipcode = false;
  downZipcode = false;
  upReporttype = false;
  downReporttype = false;
  upClaimFile = false;
  downClaimFile = false;
  upCheck = false;
  downCheck = false;
  downGender = false;
  upGender = false;
  isAddressEnterSelection = false;
  datePickerConfig: any;
  bsValueDateOfBirth: any;
  bsValueClaimDate: any;
  updateDateofBirthbsValue: any;
  updateClaimFilebsValue: any;
  public addIndividual: Individual = new Individual;
  faPlus = faPlus;
  faClose = faClose;
  multiplePhoneData: any[] = [];
  showPhoneMessage: string = '';
  multipleEmailData: any[] = [];
  showEmailMessage: string = '';
  showMorePhoneText: boolean = false;
  showMoreEmailText: boolean = false;
  multiPhoneType!: string;
  batchPhoneIndex: number = 0;
  showMoreBatchPhoneText: boolean[] = [];
  multiEmailType: string = '';
  multiAddressType: string = '';
  batchAddressIndex: number = 0;
  showMoreBatchAddressText: boolean[] = [];
  batchEmailIndex: number = 0;
  showMoreBatchEmailText: boolean[] = [];
  multipleAddressData: any[] = [];
  showAddressMessage: string = '';
  showMoreAddressText: boolean = false;
  multiKeywordType: string = '';
  batchKeywordIndex: number = 0;
  multipleKeywordData: any[] = [];
  showKeywordMessage: string = '';
  showMoreKeywordText: boolean = false;
  showMoreBatchKeywordText: boolean[] = [];
  isBasicReport: boolean = false;
  isIdentityReport: boolean = false;
  isEnhancedReport: boolean = false;
  isMonitoringReport: boolean = false;
  private keyWordModal!: NgbModalRef;

  multiLinkAnalysisType: string = '';
  batchLinkAnalysisIndex: number = 0;
  multipleLinkAnalysisData: any[] = [];
  showLinkAnalysisMessage: string = '';
  showMoreLinkAnalysisText: boolean = false;
  showMoreBatchLinkAnalysisText: boolean[] = [];
  private linkAnalysisModal!: NgbModalRef;
  isAllowedMultipleLinkAnalysis = true;
  multiKnownAsType: string = '';
  batchKnownAsIndex: number = 0;
  multipleKnownAsData: any[] = [];
  showKnownAsMessage: string = '';
  showMoreKnownAsText: boolean = false;
  showMoreBatchKnownAsText: boolean[] = [];
  private knownAsModal!: NgbModalRef;
  isAllowedMultipleKnownAs = true;
  private phoneModal!: NgbModalRef;
  private emailModal!: NgbModalRef;
  private addressModal!: NgbModalRef;
  tempPhoneNumber: string | null | undefined;
  tempEmailAddress: string | null | undefined;
  formStPhoneNumber: any;
  formStEmail: any;
  formStKeywords: any;
  formStLinkAnalysis: any;
  formStKnownAs: any;
  formStAdditionalAddress: any;
  dateOfBirthInvalid: boolean = false;
  claimFileDateInvalid: boolean = false;
  referenceIdInvalidate: boolean = false;
  isMobile: boolean = false;
  currentUserRole: string = '';
  batchDatePickerConfig: { containerClass: string; };
  listingBodyParameter: any;
  clientsData: any;
  listingUserBodyParameter: any;
  userData: any;
  userteams: any;
  batchEmailWholeData: any[] = [];
  batchPhoneWholeData: any[] = [];
  errorIds: number[] = [];
//   addressSuggestionsMap: { [key: string]: string[] } = {}; // key = id, value = list
// showSuggestionsMap: { [key: string]: boolean } = {};
addressSuggestionsMap: { [index: number]: string[] } = {};
showSuggestionsMap: { [index: number]: boolean } = {};
highlightedAddressSuggestionIndex: number = -1;
highlightedBatchAddressSuggestionIndex: { [id: number]: number } = {};
activeDropdownId: number | null = null;
batchSelectedAddressMap: { [id: number]: string } = {};
batchSuggestionRequestTokenMap: { [id: number]: number } = {};
batchAddressValidationRequestTokenMap: { [id: number]: number } = {};
dropdownPosition = { top: 0, left: 0, width: 200 };

  // Validation patterns to allows only one space
  onlyOneSpaceAllowRegex: RegExp = /^(\S*\s){0,1}\S*$/;
   // Validation patterns to allows multiple spaces
  multipleSpacesRegex: RegExp = /^.*$/; 
  firstNameInvalid: boolean = false;
  lastNameInvalid: boolean = false;
  addressInvalid: boolean = false;
  additionalAddressInvalid: boolean = false;
  /** When true, address was rejected by API (not in suggestions); red line shows but no message text. */
  additionalAddressNotFoundFromApi: boolean = false;
  /** When true, user clicked + with empty input; show red validation line until they type or close. */
  additionalAddressEmptyAddAttempt: boolean = false;
  /** Last address we started adding (to ignore second + click with same value until text changes). */
  private lastAddressAddClicked: string | null = null;
  /** When set, the current input value was selected from dropdown — skip API validation on plus click. */
  private lastSelectedAdditionalAddress: string | null = null;
  /** True while plus/Add is being processed so blur does not start a redundant API call. */
  private addingAddressInProgress = false;
  readonly maxAdditionalAddressCount = 2;
  addressSelected : boolean = false;
  additionalAddressSelected : boolean = false;
  private debounceTimer: any = null;
  genderOptions: any[] = [
    {
      label: "Male",
      value: "M"
    },
    {
      label: "Female",
      value: "F"
    }
  ]
  stateOptions: any[] = [
  { label: "AL", value: "Alabama" },
  { label: "AK", value: "Alaska" },
  { label: "AZ", value: "Arizona" },
  { label: "AR", value: "Arkansas" },
  { label: "CA", value: "California" },
  { label: "CO", value: "Colorado" },
  { label: "CT", value: "Connecticut" },
  { label: "DE", value: "Delaware" },
  { label: "FL", value: "Florida" },
  { label: "GA", value: "Georgia" },
  { label: "HI", value: "Hawaii" },
  { label: "ID", value: "Idaho" },
  { label: "IL", value: "Illinois" },
  { label: "IN", value: "Indiana" },
  { label: "IA", value: "Iowa" },
  { label: "KS", value: "Kansas" },
  { label: "KY", value: "Kentucky" },
  { label: "LA", value: "Louisiana" },
  { label: "ME", value: "Maine" },
  { label: "MD", value: "Maryland" },
  { label: "MA", value: "Massachusetts" },
  { label: "MI", value: "Michigan" },
  { label: "MN", value: "Minnesota" },
  { label: "MS", value: "Mississippi" },
  { label: "MO", value: "Missouri" },
  { label: "MT", value: "Montana" },
  { label: "NE", value: "Nebraska" },
  { label: "NV", value: "Nevada" },
  { label: "NH", value: "New Hampshire" },
  { label: "NJ", value: "New Jersey" },
  { label: "NM", value: "New Mexico" },
  { label: "NY", value: "New York" },
  { label: "NC", value: "North Carolina" },
  { label: "ND", value: "North Dakota" },
  { label: "OH", value: "Ohio" },
  { label: "OK", value: "Oklahoma" },
  { label: "OR", value: "Oregon" },
  { label: "PA", value: "Pennsylvania" },
  { label: "RI", value: "Rhode Island" },
  { label: "SC", value: "South Carolina" },
  { label: "SD", value: "South Dakota" },
  { label: "TN", value: "Tennessee" },
  { label: "TX", value: "Texas" },
  { label: "UT", value: "Utah" },
  { label: "VT", value: "Vermont" },
  { label: "VA", value: "Virginia" },
  { label: "WA", value: "Washington" },
  { label: "WV", value: "West Virginia" },
  { label: "WI", value: "Wisconsin" },
  { label: "WY", value: "Wyoming" }
  ];

  addressSuggestions: string[] = [];
  showSuggestions = false;
  additionalAddressSuggestions: string[] = [];
  showAdditionalAddressSuggestions = false;
  highlightedAdditionalAddressSuggestionIndex: number = -1;
  private suppressNextAdditionalAddressSuggestions = false;
  multiplePhoneMessage = "";
  isAllowedMultiplePhoneNumber = true;
  isPhoneNumberAvaliable = true;
  isPhoneNumberValid = true;
  individualAgeInvalid: boolean = false;
  isInputFocused: boolean = false;
  hasShownLinkAnalysisToaster: boolean = false;
  isLookBackWarningMessageVisible: boolean = false;
  @Input() callback!: (inClaimMonitorId: any, showMessage: boolean, fnCallBack?: () => void) => void;
  private suppressNextSuggestions = false;
  addressColumnPos: { left: number } = { left: 0 };
  scrollPosition: number = 0;
  constructor(
    private _modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private _notificationService: NotificationService,
    private _claimMonitorService: ClaimsmonitorService,
    private _Router: Router,
    private matDialogRef: MatDialogRef<AddnewClaimsComponent>,
    private _clientService: ClientService,
    private _userService: UserService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private sharedData: LayoutSharedService,
    private _teamService: TeamService,
    private _linkoutService: LinkoutService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.datePickerConfig = Object.assign({}, { containerClass: 'theme-green' });
    this.batchDatePickerConfig = Object.assign({}, { containerClass: 'theme-green custom-datepicker' });
  }

  ngOnInit(): void {
    document.body.classList.remove('client-page','team-list-page','add-team-page','add-user-page');
    document.body.classList.add('add-claims');
    this.getReportType();
    if (this.currentUserRole == 'super admin') {
      this.setValidationForSuperAdmin();
      this.payLoadForClientsData();
      this.getClientsData();
      this.payLoadForUsersData();
    }
    else{
      this.getClientById();
    }
    this.bsValueDateOfBirth = "";
    this.bsValueClaimDate = "";
    this.today = new Date();
    document.getElementById("batch-upload-data-info")?.classList.add("d-none");
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    this.loCurrentTeamId = localStorage.getItem('selectedTeamId');
    this.validate();
    this.matDialogRef.disableClose = true;
    this.matDialogRef.beforeClosed().subscribe((result) => {
      const cid = (this.linkOutCorrelationId ?? '').trim();
      if (!LINKOUT_FEATURE_ENABLED || !cid) return;
      if (result === 'RefreshClaimMonitoringList' || result === 'updateClaim') return;
      this._linkoutService
        .notifyLinkoutRejected(cid)
        .pipe(catchError(() => of(null)))
        .subscribe();
    });
    if (this.isBatch) {
      if(this.isBatchFileExt == 'xml')
      {
        this.stFormName = 'Add new XML file request';
        this.batchLabelName = 'XML';
      }
      else if(this.isBatchFileExt == "doc" || this.isBatchFileExt == "docx")
      {
        this.stFormName = 'Add new DOC file request';
        this.batchLabelName = 'DOC';
      }
      else if(this.isBatchFileExt == "xls")
      {
        this.stFormName = 'Add new XLS file request';
        this.batchLabelName = 'XLS';
      }
    }
    else if (this.isClaimEdit) {
      this.stFormName = 'Edit request';
    } else {
      this.stFormName = 'Add new request';
    }
    this.getPhysicalLimitation();
    if (this.isClaimEdit) {
      this.setClaimValueForEdit();
    }

    if (LINKOUT_FEATURE_ENABLED && (this.linkOutClaimNumber ?? '').trim()) {
      this.formSubmission.patchValue({ stReferenceId: (this.linkOutClaimNumber ?? '').trim() });
    }
    this.applyLinkoutReferenceFieldLockIfNeeded();

    this.reportTypeId = this.loCurrentUserData.inReportType;

    this.formSubmission.get('stAddress')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => {
        if (this.suppressNextSuggestions) {
          this.suppressNextSuggestions = false;
          return false;
        }

        const isValid = value && value.length >= 2;
        if (!isValid) {
          this.addressSuggestions = [];
        }

        return isValid;
      })
    )
    .subscribe(value => this.fetchSuggestions(value));

    this.sharedData.userTeams$.subscribe((teams) => {
      this.userteams = teams;
      const selectedTeamId = localStorage.getItem('selectedTeamId'); 
      if (selectedTeamId && this.userteams.length > 0) {
        const selectedTeam = this.userteams.find(
          (team: any) => team.uiTeamId == selectedTeamId
        );
        if (selectedTeam) {
          this.selectedTeamAvailableReports = selectedTeam.stReportTypes;
        }
      }
    });
  }

  // Convenience for easy access to form fields
  get Individualgetter() {
    return this.formSubmission.controls;
  }

  /** Add Request opened from link-out: Reference # must stay fixed (claim number). */
  get isLinkoutReferenceReadOnly(): boolean {
    return LINKOUT_FEATURE_ENABLED && !!(this.linkOutCorrelationId ?? '').toString().trim();
  }

  private getStReferenceIdValueForSubmit(): string | null {
    const c = this.formSubmission.get('stReferenceId');
    const v = c?.value;
    if (v == null || String(v).trim() === '') {
      return null;
    }
    return String(v).trim();
  }

  private applyLinkoutReferenceFieldLockIfNeeded(): void {
    const refCtrl = this.formSubmission.get('stReferenceId');
    if (!refCtrl || !this.isLinkoutReferenceReadOnly) {
      return;
    }
    refCtrl.disable({ emitEvent: false });
  }

  get multiPhoneControlGetter() {
    return this.multiplePhoneForm.controls;
  }

  get multiEmailControlGetter() {
    return this.multipleEmailForm.controls;
  }

  get multiKeywordControlGetter() {
    return this.multipleKeywordForm.controls;
  }
  get multiLinkAnalysisControlGetter() {
    return this.multipleLinkAnalysisForm.controls;
  }
  get multiKnownAsControlGetter() {
    return this.multipleKnownAsForm.controls;
  }
  get multiAddressControlGetter() {
    return this.multipleAddressForm.controls;
  }

  public trimLeadingAndTrailingSpaces(formControl: AbstractControl) {
    if (formControl && formControl.value && typeof formControl.value === 'string') {
      formControl.setValue(formControl.value.trim());
    }
    if (this.formSubmission.controls.stBatchName.invalid) {
      this.spinner.hide();
      this.isBatchsubmitted = true;
      return;
    }
  }

  ngAfterViewInit() {
    this.blurInput();
  }

  ngAfterViewChecked() {
    const elementsWithClass = this.document.querySelectorAll('.disabled-click');
    elementsWithClass.forEach(element => {
      const parentElement = element.parentElement;
      if (parentElement) {
        this.renderer.setStyle(parentElement, 'cursor', 'not-allowed');
      }
      this.renderer.setStyle(element, 'pointer-events', 'none');
      this.renderer.setStyle(element, 'opacity', '0.6');
    });
  }

  blurInput() {
    $('.phoneFocus').focus(function (e) {
      $(this).blur();
    });
    $('.emailFocus').focus(function (e) {
      $(this).blur();
    });
    $('.keywordFocus').focus(function (e) {
      $(this).blur();
    });
    $('.additionalAddressFocus').focus(function (e) {
      $(this).blur();
    });
    $('.knownasFocus').focus(function (e) {
      $(this).blur();
    });
    $('.linkAnalysisFocus').focus(function (e) {
      $(this).blur();
    });
    if (this.isClaimEdit) {
      // $('.zipcodeFocus').focus(function (e) {
      //   $(this).blur();
      // });
      $('.dobFocus').focus(function (e) {
        $(this).blur();
      });
      $('.claimdateFocus').focus(function (e) {
        $(this).blur();
      });
    }
  }

  IsSubmissionChange(objValue: any) {
    if (objValue.target.checked) {
      this.isBatch = true;
      this.stFormName = 'Add new batch request';
      setTimeout(() => {
        this.setbatchdetail();
      }, 800);
    }
    else {
      this.isBatch = false;
      this.stFormName = 'Add new request';
      setTimeout(() => {
        this.blurInput();
      }, 400);
    }
  }

  setbatchdetail() {
    if (this.isUploadedBatchFile) {
      localStorage.setItem('batchValidRequestData', this.validUploadedData.toString());
      localStorage.setItem('batchRequestData', JSON.stringify(this.getBatchDataResponse));
      document.getElementById("batch-upload-data-info")?.classList.remove("d-none");
      document.getElementById("upload-wrapper")?.classList.remove("uploaded");
      document.getElementById("upload-wrapper")?.classList.add("success");
      document.getElementById("upload-file")?.setAttribute('Title', this.batchFile.name);
      if (document.getElementById("file-upload-name") != null) {
        document.getElementById("file-upload-name")!.innerHTML = this.batchFile.name;
      }
    }
  }

  validate() {
    this.formSubmission = this.formBuilder.group({
      stClient: ['', [Validators.required]],
      stExaminer: ['', [Validators.required]],
      stUserTeam: ['', [Validators.required]],
      stFirstName: ['', [Validators.required, Validators.pattern(this.nameRegex)]],
      stLastName: ['', [Validators.required, Validators.pattern(this.nameRegex)]],
      stCompanyName: ['', [Validators.required]],
      stAddress: ['', [Validators.required]],
      // stPhoneNumber: this.formBuilder.array([]),
      stPhoneNumber: [''],
      // stEmail: ['', [Validators.required, Validators.pattern(this.emailregex)]],
      stEmail: [''],
      // stZipcode: ['', [Validators.required]],
      dtDateofBirth: ['', [Validators.required, Validators.maxLength(10)]],
      stBatchName: ['', [Validators.required]],
      stOccupation: ['', [Validators.required]],
      dtClaimFile: ['', [Validators.required, Validators.maxLength(10)]],
      stKeywords: [''],
      stLinkAnalysis: [''],
      stKnownAs: [''],
      stReferenceId: ['', [Validators.required, Validators.pattern(this.referenceIdRegex)]],
      stGender: [''],
      stNotes: [''],
      // stClaimId: ['', [Validators.pattern(this.claimIdRegex)]]
      //,uiMonitorId: ['',[Validators.required]]
      stLicensePlate: [''],
      stState: [''],
      stAdditionalAddress: ['']
    });
  }

  preventSpace(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.preventDefault(); // Prevent the default action for the spacebar
    }
  }

  setValidationForSuperAdmin() {
    this.formSubmission.controls["stClient"].setValidators(Validators.required);
    this.formSubmission.controls["stClient"].updateValueAndValidity();
    this.formSubmission.controls["stExaminer"].setValidators(Validators.required);
    this.formSubmission.controls["stExaminer"].updateValueAndValidity();
    this.formSubmission.controls["stUserTeam"].setValidators(Validators.required);
    this.formSubmission.controls["stUserTeam"].updateValueAndValidity();
  }

  setClaimValueForEdit() {
    let defaultTime = 'T00:00:00.000Z';
    this.formSubmission.patchValue({
      stFirstName: this.claimInfo.stFirstName,
      stLastName: this.claimInfo.stLastName,
      stCompanyName: this.claimInfo.stCompanyName == '-' ? '' : this.claimInfo.stCompanyName,
      stAddress: this.claimInfo.stAddress,
      // stZipcode: this.claimInfo.stZipCode == '-' ? '' : this.claimInfo.stZipCode,
      stPhoneNumber: this.claimInfo.phoneNo == '-' ? '' : this.phoneIndividualChrLimit(this.claimInfo.phoneNo),
      stEmail: this.claimInfo.stEmail == '-' ? '' : this.emailIndividualChrLimit(this.claimInfo.stEmail),
      dtDateofBirth: this.claimInfo.dtDateofBirth ? moment(this.claimInfo.dtDateofBirth).format('YYYY-MM-DD') + defaultTime : null,
      stOccupation: this.claimInfo.stOccupation == '-' ? '' : this.claimInfo.stOccupation,
      dtClaimFile: this.claimInfo.dtClaimFile ? moment(this.claimInfo.dtClaimFile).format('YYYY-MM-DD') + defaultTime : null == '-' ? '' : this.claimInfo.dtClaimFile,
      stKeywords: this.claimInfo.stKeywords == '-' ? '' : this.claimInfo.stKeywords.length >= 20 ? this.claimInfo.stKeywords.substring(0, 20) + '...' : this.claimInfo.stKeywords.substring(0, 20) + '',
      stLinkAnalysis: this.claimInfo.stLinkAnalysis == '-' ? '' : this.claimInfo.stLinkAnalysis.length >= 20 ? this.claimInfo.stLinkAnalysis.substring(0, 20) + '...' : this.claimInfo.stLinkAnalysis.substring(0, 20) + '',
      stKnownAs: this.claimInfo.stKnownAs == '-' ? '' : this.claimInfo.stKnownAs.length >= 20 ? this.claimInfo.stKnownAs.substring(0, 20) + '...' : this.claimInfo.stKnownAs.substring(0, 20) + '',
      stReferenceId: this.claimInfo.stReferenceId,
      stGender: (this.claimInfo.stGender == '-' || this.claimInfo.stGender == null) ? '' : this.claimInfo.stGender,
      stNotes: this.claimInfo.stNotes == '-' ? '' : this.claimInfo.stNotes,      
      // stClaimId: this.claimInfo.stClaimId,
      stLicensePlate: this.claimInfo.stLicensePlate == '-' ? '' : this.claimInfo.stLicensePlate,
      stState: (this.claimInfo.stState == '-' || this.claimInfo.stState == null) ? '' : this.claimInfo.stState
    })
    this.faceImageUrl = this.claimInfo.stFaceImage;
    this.formStPhoneNumber = this.claimInfo.phoneNo == '-' ? '' : this.claimInfo.phoneNo;
    this.formStEmail = this.claimInfo.stEmail == '-' ? '' : this.claimInfo.stEmail;
    this.formStKeywords = this.claimInfo.stKeywords == '-' ? '' : this.claimInfo.stKeywords;
    this.formStLinkAnalysis = this.claimInfo.stLinkAnalysis == '-' ? '' : this.claimInfo.stLinkAnalysis;
    this.formStKnownAs = this.claimInfo.stKnownAs == '-' ? '' : this.claimInfo.stKnownAs;
    this.formStAdditionalAddress = this.claimInfo.stAdditionalAddress == '-' || !this.claimInfo.stAdditionalAddress ? '' : this.claimInfo.stAdditionalAddress;
    if (this.formStAdditionalAddress) {
      this.formSubmission.controls['stAdditionalAddress'].setValue(this.addressIndividualChrLimit(this.formStAdditionalAddress));
    }
    this.bsValueDateOfBirth = this.claimInfo.dtDateofBirth ? new Date(this.claimInfo.dtDateofBirth) : '';
    this.bsValueClaimDate = this.claimInfo.dtClaimFile ? new Date(this.claimInfo.dtClaimFile) : '';
    this.applyLinkoutReferenceFieldLockIfNeeded();
    let phoneNo = this.claimInfo.phoneNo ? this.claimInfo.phoneNo.split(",") : '';
    let Email = this.claimInfo.stEmail ? this.claimInfo.stEmail.split(",") : '';
    let keyword = this.claimInfo.stKeywords ? this.claimInfo.stKeywords.split(",") : '';
    let linkAnalysis = this.claimInfo.stLinkAnalysis ? this.claimInfo.stLinkAnalysis.split(",") : '';
    let knownAs = this.claimInfo.stKnownAs ? this.claimInfo.stKnownAs.split(",") : '';
    if (phoneNo && phoneNo.length > 1) {
      this.showMorePhoneText = true;
    }
    else {
      this.showMorePhoneText = false;
    }
    if (Email && Email.length > 1) {
      this.showMoreEmailText = true;
    }
    else {
      this.showMoreEmailText = false;
    }
    if (keyword && keyword.length > 1) {
      this.showMoreKeywordText = true;
    }
    else {
      this.showMoreKeywordText = false;
    }

    if (linkAnalysis && linkAnalysis.length > 1) {
      this.showMoreLinkAnalysisText = true;
    }
    else {
      this.showMoreLinkAnalysisText = false;
    }

    if (knownAs && knownAs.length > 1) {
      this.showMoreKnownAsText = true;
    }
    else {
      this.showMoreKnownAsText = false;
    }

    if (this.claimInfo.inPhysicalLimitationId && this.claimInfo.inPhysicalLimitationId != '-') {
      let arrPhysicalLimitatioin = ['Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5'];
      let index = arrPhysicalLimitatioin.indexOf(this.claimInfo.inPhysicalLimitationId);
      setTimeout(() => {
        const checkbox = document.getElementById(index + '_' + this.claimInfo.inPhysicalLimitationId) as HTMLInputElement | null;
        if (checkbox != null) {
          checkbox.checked = true;
        }
      }, 500);
      let physicalLimitatioinId = this.claimInfo.inPhysicalLimitationId.split(' ');
      this.physicalLimitationId = Number(physicalLimitatioinId[1]);
    }
    else {
      this.physicalLimitationId = null;
    }
  }

  dateChange(event: any, property: any) {
    if (property == 'dtDateofBirth') {
      this.dateOfBirthInvalid = false;
      if (moment(new Date(event)).format('MM/DD/YYYY') == 'Invalid date') {
        if (event == '') {
          this.formSubmission.get('dtDateofBirth')?.setValue(this.updateDateofBirthbsValue);
        }
        else {
          this.formSubmission.get('dtDateofBirth')?.setValue('');
        }
      }
      else {
        this.formSubmission.get('dtDateofBirth')?.setValue(moment(new Date(event)).format('MM/DD/YYYY'));
      }
      if (event != '') {
        let dob = new Date(event);
        let today = moment(new Date()).format('MM/DD/YYYY');
        let isDatevalid = true;
        this.dobValidation(dob, event, today, isDatevalid);
      }
    }
    if (property == 'dtClaimFile') {
      this.claimFileDateInvalid = false;
      if (moment(new Date(event)).format('MM/DD/YYYY') == 'Invalid date') {
        if (event == '') {
          this.formSubmission.get('dtClaimFile')?.setValue(this.updateClaimFilebsValue);
        }
        else {
          this.formSubmission.get('dtClaimFile')?.setValue('');
        }
      }
      else {
        const claimDate = moment(new Date(event)).format('MM/DD/YYYY'); // Ensure the format is MM/DD/YYYY
        if (!this.checkDateWithinTwentyFourMonths(claimDate)) {
          this.isLookBackWarningMessageVisible = true;
        }
        else {
          this.isLookBackWarningMessageVisible = false;
        }
        this.formSubmission.get('dtClaimFile')?.setValue(moment(new Date(event)).format('MM/DD/YYYY'));
      }
    }
  }

  checkDateWithinTwentyFourMonths(dateToCheck: Date | string): boolean {
    const parsedDate = moment(dateToCheck, 'MM/DD/YYYY', true); // The 'true' flag ensures strict parsing
    if (!parsedDate.isValid()) {
      return false;
    }
    const submissionDate = moment( moment(new Date()).format('MM/DD/YYYY')); 
    const twentyFourMonthsAgo = submissionDate.clone().subtract(24, 'months'); 
    return parsedDate.isSameOrAfter(twentyFourMonthsAgo);
  }
  zipValidation() {
    this.formSubmission.markAllAsTouched();
  
    const stAddressControl = this.formSubmission.get('stAddress');
    const address = this.formSubmission.value.stAddress?.trim() || '';
    const stZipCode = (this.extractZipCode(address) || '').toUpperCase();
  
    // 🇺🇸 USA
    const usZipRegex = /^\d{5}(-\d{4})?$/;
  
    // 🇨🇦 Canada (with or without space)
    const canadaZipRegex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/;
  
    // 🇬🇧 UK (INCLUDING GIR 0AA)
    const ukPostcodeRegex =
      /^(GIR\s?0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/;
  
    const zipIsValid =
      usZipRegex.test(stZipCode) ||
      canadaZipRegex.test(stZipCode) ||
      ukPostcodeRegex.test(stZipCode);
  
    // ─────────────────────────────
    // VALIDATION RESULT
    // ─────────────────────────────
    if (stZipCode.length > 0) {
      if (!zipIsValid) {
        this.stErrorMessage = 'Invalid Zip';
        this.isValidZip = true;
        this.addressInvalid = true;
  
        stAddressControl?.setErrors({
          ...stAddressControl.errors,
          invalidZip: true
        });
        return;
      }
    } else if (address.length > 0) {
      // Address present but ZIP missing
      this.stErrorMessage = 'Invalid Zip';
      this.isValidZip = true;
      this.addressInvalid = true;
  
      stAddressControl?.setErrors({
        ...stAddressControl.errors,
        invalidZip: true
      });
      return;
    }
  
    // ─────────────────────────────
    // CLEAR ZIP ERRORS SAFELY
    // ─────────────────────────────
    this.stErrorMessage = '';
    this.isValidZip = false;
    this.addressInvalid = false;
  
    if (stAddressControl?.errors) {
      const errors = { ...stAddressControl.errors };
      delete errors['invalidZip'];
      delete errors['invalidAddress'];
  
      stAddressControl.setErrors(
        Object.keys(errors).length ? errors : null
      );
    }
  }
  

  /** Normalize address for comparison: trim, lowercase, collapse spaces */
  private normalizeAddressForComparison(addr: string): string {
    if (!addr) return '';
    return addr.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  /**
   * Validates that the typed address is a real address (matches API suggestions).
   * Wrong address with valid zip (e.g. "Test, NY, USA, 10101") should be invalid.
   */
  private validateAddressWithSuggestions(): void {
    const address = this.formSubmission.value.stAddress?.trim();
    if (!address) return;

    const stAddressControl = this.formSubmission.get('stAddress');
    if (stAddressControl?.hasError('invalidZip')) return; // Zip validation already failed

    const zipRegex = /^\d{5}$/;
    const canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z]( [0-9][a-zA-Z][0-9])?$/;
    const ukPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}( [0-9][A-Z]{2})?$/i;
    const stZipCode = this.extractZipCode(address);
    const zipIsValid = zipRegex.test(String(stZipCode)) || canadianZipRegex.test(String(stZipCode)) || ukPostcodeRegex.test(String(stZipCode));
    if (stZipCode.length === 0 || !zipIsValid) return; // Only validate full address when zip format is valid

    this._claimMonitorService.getAddressSuggestions(address).subscribe({
      next: (suggestions: string[]) => {
        const currentValue = this.formSubmission.value.stAddress?.trim();
        if (currentValue !== address) return; // Stale: user changed address

        const normalizedInput = this.normalizeAddressForComparison(currentValue);
        const hasMatch = (suggestions || []).some(s => this.normalizeAddressForComparison(s) === normalizedInput);

        if (!hasMatch) {
          this.addressInvalid = true;
          this.stErrorMessage = 'Address not found. Please select a valid address from the suggestions.';
          stAddressControl?.setErrors({ ...stAddressControl?.errors, invalidAddress: true });
        } else {
          this.addressInvalid = false;
          if (stAddressControl?.hasError('invalidAddress')) {
            const errors = { ...stAddressControl.errors };
            delete errors['invalidAddress'];
            stAddressControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
          }
        }
      },
      error: () => {
        const currentValue = this.formSubmission.value.stAddress?.trim();
        if (currentValue !== address) return;
        this.addressInvalid = true;
        this.stErrorMessage = 'Address could not be verified. Please select from suggestions.';
        stAddressControl?.setErrors({ ...stAddressControl?.errors, invalidAddress: true });
      }
    });
  }

  zipLengthValidation() {
    var stZipCode = this.formSubmission.value.stAddress?.trim();
  if (!stZipCode) {
    return; 
  }
  const zipCodes = this.extractZipCode(stZipCode);
    if (zipCodes.length == 0) {
      this.stErrorMessage = '';
      this.isValidZip = false;
    }
  }

  private extractZipCode(address: string): string {
    if (!address) return '';

    const trimmed = address.trim();
    if (!trimmed) return '';

    const value = trimmed.toUpperCase();
    // Take ONLY the last segment (dynamic commas)
    const lastPart = value.split(',').pop()?.trim() || '';
  
    // ❌ Reject STATE + ZIP (NY 10101, CA 90210)
    if (/^[A-Z]{2}\s+\d{5}(-\d{4})?$/.test(lastPart)) {
      console.log("returning empty string for state + zip");
      return '';
    }
  
    // ✅ US ZIP (numeric only)
    if (/^\d{5}(-\d{4})?$/.test(lastPart)) {
      console.log("returning lastPart for US zip");
      console.log("lastPart", lastPart);
      return lastPart;
    }
  
    // ✅ Canada ZIP
    if (/^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/.test(lastPart)) {
      console.log("returning lastPart for Canada zip");
      console.log("lastPart", lastPart);
      return lastPart;
    }
  
    // ✅ UK ZIP
    if (/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/.test(lastPart)) {
      console.log("returning lastPart for UK zip");
      console.log("lastPart", lastPart);
      return lastPart;
    }
    
    return '';
    
  }

  /**
   * Normalize address for duplicate check so that zip/postcode spacing is ignored
   * (e.g. "SO15 2AE" and "SO152AE" are treated as the same).
   */
  private normalizeAddressForDuplicateCheck(address: string): string {
    if (!address || !address.trim()) return (address || '').trim();
    const trimmed = address.trim();
    const parts = trimmed.split(',');
    if (parts.length === 0) return trimmed;
    const lastPart = parts.pop()!.trim();
    const normalizedZip = lastPart.replace(/\s+/g, '');
    parts.push(normalizedZip);
    return parts.join(',').trim();
  }

  //check Date of birth validation
  getErrorDateofBbirth() {
    return this.formSubmission.get('dtDateofBirth')?.hasError('required') ? '' :
      this.formSubmission.get('dtDateofBirth')?.hasError('pattern') ? 'Invalid' :
        this.formSubmission.get('dtDateofBirth')?.hasError('maxlength') ? 'Invalid' :
          this.formSubmission.get('dtDateofBirth')?.hasError('incorrect') ? 'Invalid' : '';
  }

  //Check claim file date Validation
  getErrorClaimFileDate() {
    return this.formSubmission.get('dtClaimFile')?.hasError('required') ? '' :
      this.formSubmission.get('dtClaimFile')?.hasError('pattern') ? 'Invalid' :
        this.formSubmission.get('dtClaimFile')?.hasError('maxlength') ? 'Invalid' :
          this.formSubmission.get('dtClaimFile')?.hasError('incorrect') ? 'Invalid' : '';
  }

  dateValidate(date: any, property: any) {
    if (date != "") {
      let dob = new Date(date);
      let today = moment(new Date()).format("MM/DD/YYYY");
      let year = date.split("/")[2];
      let isDatevalid = true;

      const regularExpression = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/?|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2)(\/?|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/?|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; // /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d+$/;

      let status = regularExpression.test(String(date).toLowerCase());
      if (!status) {
        isDatevalid = false;
      }
      if (year < 999) {
        isDatevalid = false;
      }
      if (1000 < date && date < 2000) {
        isDatevalid = false;
      }

      if (property == 'dtDateofBirth') {
        this.dobValidation(dob, date, today, isDatevalid);
      }

      if (property == 'dtClaimFile') {
        const claimDate = dob; 
        if (new Date() < new Date(dob) || dob.toString() == "Invalid Date" || !isDatevalid) {
          this.formSubmission.controls['dtClaimFile'].setErrors({ 'incorrect': true });
        }
        else {
          if (date.toString().length == 10 || date.toString().length == 8 || date.toString().length == 9) {
            if(!this.checkDateWithinTwentyFourMonths(claimDate)){
              this.isLookBackWarningMessageVisible = true;
            }
            else
            {
              this.isLookBackWarningMessageVisible = false;
            }
            this.formSubmission.controls['dtClaimFile'].setErrors(null);
            this.claimFileDateInvalid = false;
          }
        }
      }
    }
    else {
      if (property == 'dtDateofBirth') {
        this.bsValueDateOfBirth = '';
      }
      else {
        this.bsValueClaimDate = '';
      }
    }

  }

  dobValidation(dob: Date, date: any, today: any, isDatevalid: boolean) {
    const age = this.calculateAge(date);
    if (age < 18) {
      this.individualAgeInvalid = true;
    }
    else {
      this.individualAgeInvalid = false;
    }
    if (new Date(today) < new Date(date) || dob.toString() == 'Invalid Date' || !isDatevalid) {
      this.formSubmission.controls['dtDateofBirth'].setErrors({
        incorrect: true,
      });
      this.dateOfBirthInvalid = true;
    } else {
      if (
        date.toString().length == 10 ||
        date.toString().length == 8 ||
        date.toString().length == 9
      ) {
        this.formSubmission.controls['dtDateofBirth'].setErrors(null);
        this.dateOfBirthInvalid = false;
      }
    }
  }

  firstnameValidate() {
    if(this.Individualgetter['stFirstName'].hasError('pattern') || this.Individualgetter['stFirstName'].hasError('required') || this.formSubmission.value.stFirstName == " "){
      this.firstNameInvalid = true;
      this.formSubmission.controls['stFirstName'].setErrors({ 'incorrect': true });
    }
    else {
      this.firstNameInvalid = false;
    }
  }

  lastnameValidate() {
    if (this.formSubmission.value.stLastName == " " || this.Individualgetter['stLastName'].hasError('pattern') || this.Individualgetter['stLastName'].hasError('required')) {
      this.lastNameInvalid = true;
      this.formSubmission.controls['stLastName'].setErrors({ 'incorrect': true });
    }
    else {
      this.lastNameInvalid = false;
    }
  }

  addressValidate() {
    const wasSelectedFromSuggestions = this.addressSelected;
    this.addressSelected = false;

    if (!wasSelectedFromSuggestions) {
      this.zipValidation();
      const stAddressControl = this.formSubmission.get('stAddress');
      const address = this.formSubmission.value.stAddress?.trim();
      if (address && address !== ' ' && !stAddressControl?.hasError('invalidZip')) {
        this.validateAddressWithSuggestions();
      }
    }

    if (this.formSubmission.value.stAddress == " ") {
      this.addressInvalid = true;
      this.formSubmission.controls['stAddress'].setErrors({ 'incorrect': true });
    } else if (wasSelectedFromSuggestions) {
      this.addressInvalid = false;
    }
  }

  getAdditionalAddressCount(): number {
    const value = this.formStAdditionalAddress || this.formSubmission?.get('stAdditionalAddress')?.value || '';
    if (!value || typeof value !== 'string') return 0;
    return value.split(';').map((a: string) => a.trim()).filter((a: string) => a).length;
  }

  /**
   * @param forAddAttempt When true, validation messages (Invalid Zip, etc.) are shown.
   * When false (e.g. while typing), messages are not shown so user only sees them on Add click.
   */
  additionalAddressValidate(forAddAttempt = false) {
    if (!this.additionalAddressSelected) {
      this.additionalZipValidation(forAddAttempt);
    }
    this.additionalAddressSelected = false;

    const addressValue = this.multipleAddressForm.value.address?.trim();
    if (addressValue == " ") {
      this.additionalAddressInvalid = true;
      this.multipleAddressForm.controls['address'].setErrors({ 'incorrect': true });
    }
    else {
      // Do not clear invalid state when it was set by API (address not found); keeps red line until user changes text
      if (!this.additionalAddressNotFoundFromApi) {
        this.additionalAddressInvalid = false;
      }
    }
  }

  /**
   * Validates that the typed additional address matches one of the API suggestions
   * (same logic as stAddress validateAddressWithSuggestions).
   */
  private validateAdditionalAddressWithSuggestions(address: string, onResult: (isValid: boolean) => void): void {
    if (!address || !address.trim()) {
      onResult(true);
      return;
    }
    const stZipCode = this.extractZipCode(address);
    const zipRegex = /^\d{5}$/;
    const canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z]( [0-9][a-zA-Z][0-9])?$/;
    const ukPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}( [0-9][A-Z]{2})?$/i;
    const zipIsValid = zipRegex.test(String(stZipCode)) || canadianZipRegex.test(String(stZipCode)) || ukPostcodeRegex.test(String(stZipCode));
    if (stZipCode.length === 0 || !zipIsValid) {
      onResult(true);
      return;
    }
    this._claimMonitorService.getAddressSuggestions(address).subscribe({
      next: (suggestions: string[]) => {
        const normalizedInput = this.normalizeAddressForComparison(address.trim());
        const hasMatch = (suggestions || []).some(s => this.normalizeAddressForComparison(s) === normalizedInput);
        onResult(!!hasMatch);
      },
      error: () => onResult(false)
    });
  }

  /**
   * @param onlySetMessageWhenAdding When true, sets showAddressMessage to 'Invalid Zip' when invalid.
   * When false (typing/keyup/blur), does not show the message so it only appears on Add click.
   * Uses extractZipCode for zip validation; no need to re-validate format here.
   */
  additionalZipValidation(onlySetMessageWhenAdding = false) {
    var address = this.multipleAddressForm.value.address?.trim();
    if (!address) {
      this.showAddressMessage = '';
      this.isValidAdditionalZip = false;
      this.additionalAddressInvalid = false;
      return;
    }

    const stZipCode = this.extractZipCode(address);

    if (stZipCode.length > 0) {
      // extractZipCode already validated format (US/Canada/UK); treat as valid
      this.showAddressMessage = this.showAddressMessage === 'Invalid Zip' ? '' : this.showAddressMessage;
      this.isValidAdditionalZip = false;
      // Do not clear invalid state when it was set by API (address not found); keep red line until user changes text
      if (!this.additionalAddressNotFoundFromApi) {
        this.additionalAddressInvalid = false;
      }
    } else {
      // No valid zip extracted: show invalid state and message when adding
      this.additionalAddressInvalid = true;
      if (address.length > 0) {
        if (onlySetMessageWhenAdding) {
          this.showAddressMessage = 'Invalid Zip';
        } else if (this.showAddressMessage === 'Invalid Zip') {
          this.showAddressMessage = '';
        }
        this.isValidAdditionalZip = true;
      } else {
        this.showAddressMessage = '';
        this.isValidAdditionalZip = false;
      }
    }
  }

  /**
   * Called on blur of the additional address input. Re-runs validation so that when the user
   * corrects an invalid address and leaves the field, the red state clears if the value is now valid.
   */
  onAdditionalAddressBlur(): void {
    if (this.addingAddressInProgress) return;
    const control = this.multipleAddressForm.get('address');
    if (control) {
      control.markAsTouched();
      control.updateValueAndValidity();
    }
    const addressValue = this.multipleAddressForm.value?.address?.trim();
    if (!addressValue) {
      this.additionalAddressInvalid = false;
      this.additionalAddressNotFoundFromApi = false;
      this.isValidAdditionalZip = false;
      this.additionalAddressEmptyAddAttempt = false;
      if (this.showAddressMessage === 'Invalid Zip' || this.showAddressMessage === 'Address already added' ||
          this.showAddressMessage === 'Max two additional address allowed to add') {
        this.showAddressMessage = '';
      }
      this.cdr.detectChanges();
      return;
    }
    this.additionalAddressValidate(true);
    if (this.isValidAdditionalZip || this.additionalAddressInvalid) {
      this.cdr.detectChanges();
      return;
    }
    this.validateAdditionalAddressWithSuggestions(addressValue, (isValid) => {
      // Do not overwrite state if user already changed the value (e.g. selected from dropdown)
      const currentValue = this.multipleAddressForm.value?.address?.trim();
      if (currentValue !== addressValue) return;
      this.additionalAddressNotFoundFromApi = !isValid;
      this.additionalAddressInvalid = !isValid;
      this.cdr.detectChanges();
    });
  }

  // Check referenceId valid
  referenceIdValidate() {
    if (this.isLinkoutReferenceReadOnly) {
      return;
    }
    if (this.Individualgetter['stReferenceId'].hasError('pattern') || this.Individualgetter['stReferenceId'].hasError('required') || this.formSubmission.value.stReferenceId == " ") {
      this.referenceIdInvalidate = true;
      this.formSubmission.controls['stReferenceId'].setErrors({ 'incorrect': true });
    }
    else {
      this.referenceIdInvalidate = false;
    }
  }
    // Check batch referenceId valid
    batchReferenceIdValidate(referenceId: any) {
      return this.referenceIdRegex.test(referenceId);
    }

  trimValue(value: any) {
    return value.trim();
  }

  phoneIndividualChrLimit(individualPhoneData: any) {
    return individualPhoneData.length >= 20 ? individualPhoneData.substring(0, 20) + '...' : individualPhoneData.substring(0, 20) + ''
  }

  phoneBatchChrLimit(batchPhoneData: any) {
    return batchPhoneData.length >= 15 ? batchPhoneData.substring(0, 15) + '...' : batchPhoneData.substring(0, 15) + '';
  }

  requiredPhone(isEnterKeyClicked: boolean) {
    if (this.multiplePhoneData?.length == 0) {
      this.multiplePhoneForm.controls["phone"].setValidators([Validators.required, Validators.minLength(10)]);
      this.multiplePhoneForm.controls["phone"].updateValueAndValidity();
    }
    else {
      this.multiplePhoneForm.controls["phone"].clearValidators();
      this.multiplePhoneForm.controls["phone"].updateValueAndValidity();
      if (this.multiplePhoneForm.controls["phone"].value != null && this.multiplePhoneForm.controls["phone"].value != undefined && this.multiplePhoneForm.controls["phone"].value != '') {
        this.multiplePhoneForm.controls["phone"].setValidators([Validators.minLength(10)]);
        this.multiplePhoneForm.controls["phone"].updateValueAndValidity();
      } else {
        //close model if phone number is valid and enter key is not clicked 
        if (!isEnterKeyClicked && this.isPhoneNumberValid) {
          this.phoneModal.close();
        }
      }
    }
  }

  addPhoneOnEnter() {
    this.addMultiplePhone(true,false);
    return false;
  }

  showMultiplePhoneModel(multiplePhone: any, type: string, index?: number) {
    this.multiPhoneType = type;
    if (index != undefined && index != null) {
      this.batchPhoneIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'phone-popup'
    };
    this.closeMultiplePhoneModel();
    this.phoneModal = this._modalService
      .open(multiplePhone, ngbModalOptions)
    this.phoneModal.result.then(
      (result: any) => {

      },
      (reason: any) => {

      }
    );
  }

  closeMultiplePhoneModel() {
    this.multiPhoneFormSubmit = false;
    this.isAllowedMultiplePhoneNumber = true;
    this.multiplePhoneData = [];
    this.showPhoneMessage = '';
    if (this.multiPhoneType == 'individual') {
      if (this.formSubmission.value.stPhoneNumber) {
        this.multiplePhoneData = this.formStPhoneNumber.split(",");
      }
    }
    else {
      const wholePhone = this.getBatchDataResponse[this.batchPhoneIndex]?.wholePhone;
      if (wholePhone?.length == 10) {
        this.multiplePhoneData[0] = wholePhone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
      }
      else {
        if (wholePhone) {
          let allPhone: any[] = [];
          const arrPhone = wholePhone.split(",");
          arrPhone.forEach((phone: any) => {
            let formatePhone = phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
            allPhone.push(formatePhone);
          })
          this.multiplePhoneData = allPhone;
        }
      }
    }
    this.multiplePhoneForm.reset();
  }

  addMultiplePhone(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean) {
    this.isAllowedMultiplePhoneNumber = true;
    this.isPhoneNumberValid = true;
    this.requiredPhone(isEnterKeyClicked);
    this.multiPhoneFormSubmit = true;
    if (!isSaveButtonClicked) {
      if (!this.multiplePhoneForm.value.phone) {
        this.multiplePhoneForm.get('phone')?.setErrors({ 'invalid': true });
      };
    }

    if (this.multiplePhoneForm.valid) {
      this.multiplePhoneData = this.multiplePhoneData.map(this.trimValue);
      const maskNumberFormat = this.multiplePhoneForm.value.phone?.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
      if (this.multiplePhoneData) {
        let isDuplicate = this.multiplePhoneData.find(x => x === maskNumberFormat) ? true : false;
        if (isDuplicate) {
          this.showPhoneMessage = "Phone number already added";
          return;
        }
        if (this.multiplePhoneForm.value.phone) {
          let isMultipleNo = this.multiplePhoneData.length >= 2 ? true : false;
          if (isMultipleNo) {
            this.isAllowedMultiplePhoneNumber = false;
            this.isPhoneNumberValid = false;
            return;
          }
        }
      }
      if (maskNumberFormat) {
        this.multiplePhoneData.push(maskNumberFormat);
        this.multiplePhoneForm.get('phone')?.setValue(null);
        this.multiPhoneFormSubmit = false;
        this.showPhoneMessage = '';
        this.requiredPhone(isEnterKeyClicked);
      }
    }
    else {
      this.isPhoneNumberValid = false;
    }
  }

  removePhoneNumber(index: number) {
    this.multiplePhoneData.splice(index, 1);
    this.showPhoneMessage = "";
    this.multiPhoneFormSubmit = false;
    if (this.multiplePhoneData.length <= 2) {
      this.isAllowedMultiplePhoneNumber = true;
    }
  }

  RestrctionOnError(event: any) {
    if ((event.key === 'Delete' || event.key === 'Backspace') && event.target.value.length === 0) {
      this.isAllowedMultiplePhoneNumber = true;
    }
  }

  checkDuplicatePhone(event: any, phone: any) {
    if (this.multiplePhoneData.length > 0) {
      let isDuplicate = this.multiplePhoneData.find(x => x === phone) ? true : false;
      if (isDuplicate) {
        this.showPhoneMessage = "Phone number already added";
        this.multiPhoneFormSubmit = true;
      }
      else {
        this.showPhoneMessage = "";
      }
    }
  }

  savePhoneNumber() {
  this.addMultiplePhone(true, true);

  //Ensure getBatchDataResponse is initialized
  if (!this.getBatchDataResponse) {
    this.getBatchDataResponse = [];
  }

  if (this.isAllowedMultiplePhoneNumber) {
    let phoneDataString = this.multiplePhoneData.slice(0, 2).join(", ");
    this.formStPhoneNumber = phoneDataString;

    //Ensure object exists at batchPhoneIndex before using it
    if (!this.getBatchDataResponse[this.batchPhoneIndex]) {
      this.getBatchDataResponse[this.batchPhoneIndex] = {};
    }

    if (this.multiPhoneType === 'individual') {
      this.formSubmission.controls['stPhoneNumber'].setValue(
        this.phoneIndividualChrLimit(phoneDataString)
      );

      this.getBatchDataResponse[this.batchPhoneIndex].Phone = this.phoneBatchChrLimit(phoneDataString);
      this.getBatchDataResponse[this.batchPhoneIndex].wholePhone = phoneDataString;
      this.getBatchDataResponse[this.batchPhoneIndex].formatPhoneNo = phoneDataString;
    } else {
      this.batchPhoneWholeData[this.batchPhoneIndex] = phoneDataString;

      this.getBatchDataResponse[this.batchPhoneIndex].Phone = this.phoneBatchChrLimit(phoneDataString);
      this.getBatchDataResponse[this.batchPhoneIndex].wholePhone = phoneDataString;
      this.getBatchDataResponse[this.batchPhoneIndex].formatPhoneNo = phoneDataString;
    }

    //Check phone validation and close modal
    if ((this.showPhoneMessage === "" && this.tempPhoneNumber?.length === 10) || this.isPhoneNumberValid) {
      this.tempPhoneNumber = null;
      this.phoneModal.close();
    } else {
      const phoneValue = this.multiplePhoneForm.value.phone;
      if (!phoneValue || phoneValue.length === 0) {
        this.phoneModal.close();
      }
    }
  }
}


  emailIndividualChrLimit(individualEmailData: any) {
    return individualEmailData.length >= 20 ? individualEmailData.substring(0, 20) + '...' : individualEmailData.substring(0, 20) + ''
  }

  emailBatchChrLimit(batchEmailData: any) {
    return batchEmailData.length >= 12 ? batchEmailData.substring(0, 7) + '...' : batchEmailData.substring(0, 12) + '';
  }

  requiredEmail(isEnterKeyClicked: boolean) {
    if (this.multipleEmailData?.length == 0) {
      this.multipleEmailForm.controls["email"].setValidators([Validators.required, Validators.pattern(commonConstant.emailregex)]);
      this.multipleEmailForm.controls["email"].updateValueAndValidity();
    }
    else {
      this.multipleEmailForm.controls["email"].clearValidators();
      this.multipleEmailForm.controls["email"].updateValueAndValidity();
      if (this.multipleEmailForm.controls["email"].value != null && this.multipleEmailForm.controls["email"].value != undefined && this.multipleEmailForm.controls["email"].value != '') {
        this.multipleEmailForm.controls["email"].setValidators([Validators.pattern(commonConstant.emailregex)]);
        this.multipleEmailForm.controls["email"].updateValueAndValidity();
      } else {
        if (!isEnterKeyClicked) {
          this.emailModal.close();
        }
      }
    }
  }

  addEmailOnEnter() {
    this.addMultipleEmail(true, false);
    return false;
  }

  showMultipleEmailModel(multipleEmail: any, type: string, index?: number) {
    this.multiEmailType = type;
    if (index != undefined && index != null) {
      this.batchEmailIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'email-popup'
    };
    this.closeMultipleEmailModel();
    this.emailModal = this._modalService
      .open(multipleEmail, ngbModalOptions)
    this.emailModal.result.then(
      (result: any) => {

      },
      (reason: any) => {

      }
    );
  }

  showMultipleAddressModel(multipleAddress: any, type: string, index?: number) {
    this.multiAddressType = type;
    if (index != undefined && index != null) {
      this.batchAddressIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'email-popup'
    };
    this.closeMultipleAddressModel();
    this.addressModal = this._modalService
      .open(multipleAddress, ngbModalOptions)
    
    // Set up address suggestions subscription for additional address
    this.setupAdditionalAddressSuggestions();
    
    this.addressModal.result.then(
      (result: any) => {
        this.cleanupAdditionalAddressSuggestions();
      },
      (reason: any) => {
        this.cleanupAdditionalAddressSuggestions();
      }
    );
  }

  private additionalAddressSubscription: any;
  
  setupAdditionalAddressSuggestions() {
    // Clean up any existing subscription
    if (this.additionalAddressSubscription) {
      this.additionalAddressSubscription.unsubscribe();
    }
    
    this.additionalAddressSuggestions = [];
    this.showAdditionalAddressSuggestions = false;
    this.highlightedAdditionalAddressSuggestionIndex = -1;
    
    // Subscribe to address input changes: switchMap cancels previous API calls, distinctUntilChanged avoids duplicates.
    // API only when length >= 2. Outdated responses ignored by checking current input before updating dropdown.
    this.additionalAddressSubscription = this.multipleAddressForm.get('address')!.valueChanges.pipe(
      distinctUntilChanged(),
      filter((value: string | null): value is string => {
        // When user changes the text, clear "address not found" and "empty add" state so red line hides until next +/Save
        if (this.additionalAddressNotFoundFromApi) {
          this.additionalAddressNotFoundFromApi = false;
          this.additionalAddressInvalid = false;
        }
        if (this.additionalAddressEmptyAddAttempt) {
          this.additionalAddressEmptyAddAttempt = false;
          this.multipleAddressForm.get('address')?.setErrors(null);
          this.multipleAddressForm.get('address')?.updateValueAndValidity();
        }
        this.lastAddressAddClicked = null;
        if (this.suppressNextAdditionalAddressSuggestions) {
          this.suppressNextAdditionalAddressSuggestions = false;
          return false;
        }
        this.lastSelectedAdditionalAddress = null;
        const isValid = value != null && value.length >= 2;
        if (!isValid) {
          this.additionalAddressSuggestions = [];
          this.showAdditionalAddressSuggestions = false;
          return false;
        }
        // Re-run zip validation so corrected text clears Invalid Zip / red state immediately
        this.additionalZipValidation(false);
        this.cdr.detectChanges();
        return true;
      }),
      switchMap((value: string) =>
        this._claimMonitorService.getAddressSuggestions(value).pipe(
          map((data) => ({ value, data }))
        )
      )
    ).subscribe({
      next: ({ value, data }) => {
        const currentInput = this.multipleAddressForm.get('address')?.value?.trim();
        if (currentInput !== value) return;
        this.additionalAddressSuggestions = data || [];
        this.showAdditionalAddressSuggestions = true;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('API error:', err);
        this.additionalAddressSuggestions = [];
        this.showAdditionalAddressSuggestions = false;
        this.cdr.detectChanges();
      }
    });
  }

  cleanupAdditionalAddressSuggestions() {
    if (this.additionalAddressSubscription) {
      this.additionalAddressSubscription.unsubscribe();
      this.additionalAddressSubscription = null;
    }
    this.additionalAddressSuggestions = [];
    this.showAdditionalAddressSuggestions = false;
  }

  fetchAdditionalAddressSuggestions(value: string): void {
    this._claimMonitorService.getAddressSuggestions(value).subscribe({
      next: (data) => {
        this.additionalAddressSuggestions = data || [];
        this.showAdditionalAddressSuggestions = true;
      },
      error: (err) => {
        console.error('API error:', err);
        this.additionalAddressSuggestions = [];
        this.showAdditionalAddressSuggestions = false;
      }
    });
  }

  selectAdditionalAddressSuggestion(suggestion: string): void {
    // Close dropdown immediately so it does not reappear
    this.suppressNextAdditionalAddressSuggestions = true;
    this.showAdditionalAddressSuggestions = false;
    this.additionalAddressSuggestions = [];
    this.highlightedAdditionalAddressSuggestionIndex = -1;
    this.additionalAddressSelected = true;

    const control = this.multipleAddressForm.get('address');
    if (control) {
      control.setValue(suggestion, { emitEvent: false });
      control.setErrors(null);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
    // Selected address is from our API so it is valid — clear all error state so red border goes away immediately
    this.additionalAddressInvalid = false;
    this.additionalAddressNotFoundFromApi = false;
    this.isValidAdditionalZip = false;
    this.showAddressMessage = '';
    // Remember so plus click can add without calling API again
    this.lastSelectedAdditionalAddress = suggestion;
    // Re-run validation so form state is consistent (no-op for a valid selected address)
    this.additionalZipValidation(false);
    this.additionalAddressValidate();
    this.cdr.detectChanges();
  }

  onAdditionalAddressInputKeydown(event: KeyboardEvent) {
    if (!this.showAdditionalAddressSuggestions || !this.additionalAddressSuggestions.length) {
      if (event.key === 'Enter') {
        this.addAddressOnEnter();
      }
      return;
    }
  
    if (event.key === 'ArrowDown') {
      this.highlightedAdditionalAddressSuggestionIndex =
        (this.highlightedAdditionalAddressSuggestionIndex + 1) % this.additionalAddressSuggestions.length;
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.highlightedAdditionalAddressSuggestionIndex =
        (this.highlightedAdditionalAddressSuggestionIndex - 1 + this.additionalAddressSuggestions.length) % this.additionalAddressSuggestions.length;
      event.preventDefault();
    } else if (event.key === 'Enter') {
      if (
        this.highlightedAdditionalAddressSuggestionIndex >= 0 &&
        this.highlightedAdditionalAddressSuggestionIndex < this.additionalAddressSuggestions.length
      ) {
        this.selectAdditionalAddressSuggestion(this.additionalAddressSuggestions[this.highlightedAdditionalAddressSuggestionIndex]);
        event.preventDefault();
      } else {
        this.addAddressOnEnter();
      }
    } else if (event.key === 'Escape') {
      this.showAdditionalAddressSuggestions = false;
      event.preventDefault();
    }
  }

  onAdditionalAddressFocus(): void {
    if (this.additionalAddressSuggestions.length) {
      this.showAdditionalAddressSuggestions = true;
    }
  }

  /**
   * Called on keyup for the additional address input. Re-runs zip validation so that
   * as soon as the user types a valid zip (e.g. "10010" or "New York, NY, USA, 10010"),
   * the red border and "Invalid Zip" clear immediately without waiting for debounce.
   */
  onAdditionalAddressZipCheck(): void {
    // Only re-run zip validation if there is no explicit "Invalid Zip" message
    // shown by +/Enter/Save so we don't clear it on the subsequent keyup event
    if (this.showAddressMessage !== 'Invalid Zip') {
      this.additionalZipValidation(false);
      this.cdr.detectChanges();
    }
  }

  updateAdditionalAddressLabelPosition(value: string | null): void {
    const inputElement = document.getElementById('txtAdditionalAddress') as HTMLInputElement;
    if (inputElement) {
      if (value && value.trim()) {
        inputElement.setAttribute('value', value);
        inputElement.classList.add('focus');
      } else {
        inputElement.removeAttribute('value');
        inputElement.classList.remove('focus');
      }
    }
  }

  closeMultipleAddressModel() {
    this.cleanupAdditionalAddressSuggestions();
    this.multiAddressFormSubmit = false;
    this.multipleAddressData = [];
    this.showAddressMessage = "";
    this.isValidAdditionalZip = false;
    this.additionalAddressInvalid = false;
    this.additionalAddressNotFoundFromApi = false;
    this.additionalAddressEmptyAddAttempt = false;
    this.lastAddressAddClicked = null;
    this.additionalAddressSelected = false;
    this.lastSelectedAdditionalAddress = null;
    this.addingAddressInProgress = false;
    if (this.multiAddressType == 'individual') {
      const hasAddresses = this.formStAdditionalAddress?.trim() || this.formSubmission.value.stAdditionalAddress;
      if (hasAddresses) {
        const source = (this.formStAdditionalAddress || this.formSubmission.value.stAdditionalAddress || '').toString().trim();
        if (source) {
          this.multipleAddressData = source.split(";").map((a: string) => a.trim()).filter((a: string) => a);
        }
      }
    }
    else {
      // Handle batch mode if needed in future
    }
    this.multipleAddressForm.reset();
    if (this.addressModal) {
      this.addressModal.close();
    }
  }

  addMultipleAddress(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean, onAddComplete?: (added: boolean) => void) {
    this.addingAddressInProgress = true;
    // Always clear "Address already added" first so double-click or rapid clicks don't leave stale message
    if (this.showAddressMessage === 'Address already added') {
      this.showAddressMessage = '';
      this.additionalAddressInvalid = false;
      this.cdr.detectChanges();
    }
    const rawAddress = this.multipleAddressForm.value.address;
    const hasAddressInput = rawAddress != null && String(rawAddress).trim() !== '';
    if (!isSaveButtonClicked) {
      this.multiAddressFormSubmit = true;
      if (!hasAddressInput) {
        this.additionalAddressEmptyAddAttempt = true;
        this.multipleAddressForm.get('address')?.setErrors({ 'invalid': true });
        this.cdr.detectChanges();
        this.addingAddressInProgress = false;
        return;
      }
    }
    
    // Validate the address before adding (show messages only when user clicks Add)
    if (hasAddressInput) {
      this.additionalAddressValidate(true);
      
      // First show Invalid Zip if invalid; only then check max count
      if (this.isValidAdditionalZip || this.additionalAddressInvalid) {
        this.addingAddressInProgress = false;
        if (isSaveButtonClicked) onAddComplete?.(false);
        return;
      }
      if (this.multipleAddressData.length >= this.maxAdditionalAddressCount) {
        this.showAddressMessage = "Max two additional address allowed to add";
        this.additionalAddressInvalid = true;
        this.addingAddressInProgress = false;
        if (isSaveButtonClicked) onAddComplete?.(false);
        return;
      }
      const addressToAdd = this.multipleAddressForm.value.address?.trim() || '';
      if (!addressToAdd) {
        this.additionalAddressEmptyAddAttempt = true;
        this.multipleAddressForm.get('address')?.setErrors({ 'invalid': true });
        this.cdr.detectChanges();
        this.addingAddressInProgress = false;
        if (isSaveButtonClicked) onAddComplete?.(false);
        return;
      }
      // Duplicate check before API call so double-click doesn't fire two API calls and overwrite cleared message
      this.multipleAddressData = this.multipleAddressData.map(this.trimValue);
      const normalizedNew = this.normalizeAddressForDuplicateCheck(addressToAdd);
      const isDuplicateAddress = this.multipleAddressData.find(x => this.normalizeAddressForDuplicateCheck(x) === normalizedNew);
      if (isDuplicateAddress) {
        this.showAddressMessage = "Address already added";
        this.multiAddressFormSubmit = true;
        this.cdr.detectChanges();
        this.addingAddressInProgress = false;
        if (isSaveButtonClicked) onAddComplete?.(false);
        return;
      }
      // Ignore second + click with same value until user changes the text (no clearing the input)
      if (addressToAdd === this.lastAddressAddClicked) {
        this.addingAddressInProgress = false;
        if (isSaveButtonClicked) onAddComplete?.(false);
        return;
      }

      const wasSelectedFromDropdown = this.lastSelectedAdditionalAddress != null &&
        this.normalizeAddressForComparison(addressToAdd) === this.normalizeAddressForComparison(this.lastSelectedAdditionalAddress);

      if (wasSelectedFromDropdown) {
        this.lastAddressAddClicked = addressToAdd;
        this.lastSelectedAdditionalAddress = null;
        this.multipleAddressData.push(addressToAdd);
        this.multipleAddressForm.get('address')?.setValue(null);
        this.lastAddressAddClicked = null;
        this.multiAddressFormSubmit = false;
        this.showAddressMessage = "";
        this.isValidAdditionalZip = false;
        this.additionalAddressInvalid = false;
        this.additionalAddressNotFoundFromApi = false;
        this.additionalAddressEmptyAddAttempt = false;
        this.addingAddressInProgress = false;
        this.cdr.detectChanges();
        onAddComplete?.(true);
        return;
      }

      this.lastAddressAddClicked = addressToAdd;
      this.validateAdditionalAddressWithSuggestions(addressToAdd, (isValid) => {
        this.addingAddressInProgress = false;
        if (!isValid) {
          this.additionalAddressNotFoundFromApi = true;
          this.additionalAddressInvalid = true;
          this.multiAddressFormSubmit = true;
          this.lastAddressAddClicked = null;
          this.cdr.detectChanges();
          onAddComplete?.(false);
          return;
        }
        this.lastSelectedAdditionalAddress = null;
        this.multipleAddressData = this.multipleAddressData.map(this.trimValue);
        const normalizedNewMatch = this.normalizeAddressForDuplicateCheck(addressToAdd);
        const isDuplicateAddressMatch = this.multipleAddressData.find(x => this.normalizeAddressForDuplicateCheck(x) === normalizedNewMatch);
        if (isDuplicateAddressMatch) {
          this.showAddressMessage = "Address already added";
          this.multiAddressFormSubmit = true;
          this.lastAddressAddClicked = null;
          this.cdr.detectChanges();
          onAddComplete?.(false);
          return;
        }
        this.multipleAddressData.push(addressToAdd);
        this.multipleAddressForm.get('address')?.setValue(null);
        this.lastAddressAddClicked = null;
        this.multiAddressFormSubmit = false;
        this.showAddressMessage = "";
        this.isValidAdditionalZip = false;
        this.additionalAddressInvalid = false;
        this.additionalAddressNotFoundFromApi = false;
        this.additionalAddressEmptyAddAttempt = false;
        this.cdr.detectChanges();
        onAddComplete?.(true);
      });
      return;
    }
    this.addingAddressInProgress = false;
    if (this.multipleAddressForm.valid) {
      // No address in input
    }
    onAddComplete?.(false);
  }

  removeMultipleAddress(index: number) {
    this.multipleAddressData.splice(index, 1);
    if (this.multipleAddressData.length < this.maxAdditionalAddressCount && this.showAddressMessage === 'Max two additional address allowed to add') {
      this.showAddressMessage = '';
      this.additionalAddressInvalid = false;
    }
    // Clear stale "Address already added" when user removes an address so re-adding doesn't show wrong message
    if (this.showAddressMessage === 'Address already added') {
      this.showAddressMessage = '';
      this.additionalAddressInvalid = false;
    }
  }

  checkDuplicateAddress(event: any, address: any) {
    // Reset the selected flag when user manually types
    if (event.key && event.key !== 'Enter') {
      this.additionalAddressSelected = false;
    }
    
    if (this.multipleAddressData.length > 0) {
      const normalizedInput = this.normalizeAddressForDuplicateCheck(address.trim());
      let isDuplicate = this.multipleAddressData.find(x => this.normalizeAddressForDuplicateCheck(x) === normalizedInput) ? true : false;
      if (isDuplicate) {
        this.showAddressMessage = "Address already added";
        this.multiAddressFormSubmit = true;
      }
      else {
        // Only clear the message if it's a duplicate message, preserve validation messages
        if (this.showAddressMessage === "Address already added") {
          this.showAddressMessage = "";
        }
      }
    }
  }

  onAdditionalAddressPlusMousedown(): void {
    this.addingAddressInProgress = true;
  }
  addAddressOnEnter() {
    this.addMultipleAddress(true, false);
    return false;
  }

  saveAddress() {
    // Check if there's an address in the input field
    if (this.multipleAddressForm.value.address && this.multipleAddressForm.value.address.trim()) {
      // Validate the current input before saving (show Invalid Zip / Max 2 only when saving)
      this.additionalAddressValidate(true);
      
      // If the current input is invalid, prevent saving
      if (this.isValidAdditionalZip || this.additionalAddressInvalid) {
        this.multiAddressFormSubmit = true;
        return;
      }
      if (this.multipleAddressData.length >= this.maxAdditionalAddressCount) {
        this.showAddressMessage = "Max two additional address allowed to add";
        this.multiAddressFormSubmit = true;
        return;
      }
      
      // Try to add the current address (async validation); only close when add succeeds
      this.addMultipleAddress(false, true, (added) => {
        if (!added) return;
        this.doCloseAdditionalAddressModal();
      });
      return;
    }
    
    this.multiAddressFormSubmit = false;
    this.doCloseAdditionalAddressModal();
  }

  private doCloseAdditionalAddressModal(): void {
    let addressDataString = this.multipleAddressData.join("; ");
    this.formStAdditionalAddress = addressDataString;
    if (this.multiAddressType == 'individual') {
      this.formSubmission.controls['stAdditionalAddress'].setValue(this.addressIndividualChrLimit(addressDataString));
      this.cdr.detectChanges();
    }
    else {
      // Handle batch mode if needed in future
    }
    this.addressModal.close();
  }

  addressIndividualChrLimit(addressDataString: string): string {
    if (addressDataString.length > 28) {
      this.showMoreAddressText = true;
      return addressDataString.substring(0, 28) + "...";
    }
    else {
      this.showMoreAddressText = false;
      return addressDataString;
    }
  }

  closeMultipleEmailModel() {
    this.multiEmailFormSubmit = false;
    this.multipleEmailData = [];
    this.showEmailMessage = "";
    if (this.multiEmailType == 'individual') {
      if (this.formSubmission.value.stEmail) {
        this.multipleEmailData = this.formStEmail.split(",");
      }
    }
    else {
      const wholeEmail = this.getBatchDataResponse[this.batchEmailIndex]?.wholeEmail;
      if (wholeEmail) {
        if (wholeEmail.includes(",")) {
          this.multipleEmailData = wholeEmail.split(",");
        }
        else {
          this.multipleEmailData[0] = wholeEmail;
        }
      }
    }
    this.multipleEmailForm.reset();
  }

  addMultipleEmail(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean) {
    this.requiredEmail(isEnterKeyClicked);
    this.multiEmailFormSubmit = true;
    if (!isSaveButtonClicked) {
      if (!this.multipleEmailForm.value.email) {
        this.multipleEmailForm.get('email')?.setErrors({ 'invalid': true });
      };
    }
    this.tempEmailAddress = this.multipleEmailForm.value.email;
    if (this.multipleEmailForm.valid) {
      this.multipleEmailData = this.multipleEmailData.map(this.trimValue);
      if (this.multipleEmailData) {
        let isDuplicateEmail = this.multipleEmailData.find(x => x === this.multipleEmailForm.value.email?.toLowerCase()) ? true : false;
        if (isDuplicateEmail) {
          this.showEmailMessage = "Email already added";
          return;
        }
      }
      if (this.multipleEmailForm.value.email) {
        this.multipleEmailData.push(this.multipleEmailForm.value.email?.toLowerCase());
        this.multipleEmailForm.get('email')?.setValue(null);
        this.multiEmailFormSubmit = false;
        this.showEmailMessage = "";
        this.requiredEmail(isEnterKeyClicked);
      }
    }
  }

  removeMultipleEmail(index: number) {
    this.multipleEmailData.splice(index, 1);
  }

  checkDuplicateEmail(event: any, email: any) {
    if (this.multipleEmailData.length > 0) {
      let isDuplicate = this.multipleEmailData.find(x => x === email.toLowerCase()) ? true : false;
      if (isDuplicate) {
        this.showEmailMessage = "Email already added";
        this.multiEmailFormSubmit = true;
      }
      else {
        this.showEmailMessage = "";
      }
    }
  }

  saveEmailAddress() {
    this.addMultipleEmail(false, true);
    let emailDataString = this.multipleEmailData.join(", ");
    this.formStEmail = emailDataString;
    if (this.multiEmailType == 'individual') {
      this.formSubmission.controls['stEmail'].setValue(this.emailIndividualChrLimit(emailDataString));
      this.getBatchDataResponse[this.batchEmailIndex].Email = this.emailBatchChrLimit(emailDataString);
      this.getBatchDataResponse[this.batchEmailIndex].wholeEmail = emailDataString;
    }
    else {
      this.batchEmailWholeData[this.batchEmailIndex] = emailDataString;
      this.getBatchDataResponse[this.batchEmailIndex].Email = this.emailBatchChrLimit(emailDataString);
      this.getBatchDataResponse[this.batchEmailIndex].wholeEmail = emailDataString;
    }
    let isValidEmail = commonConstant.emailregex.test(String(this.tempEmailAddress))
    if (this.showEmailMessage == "" && isValidEmail) {
      this.tempEmailAddress = null;
      this.emailModal.close();
    }
    else {
      const emailValue = this.multipleEmailForm.value.email;
      if (!emailValue || emailValue.length === 0) {
        this.emailModal.close();
      }
    }
  }

  requiredKeyword(isEnterKeyClicked: boolean) {
    if (this.multipleKeywordData?.length == 0) {
      this.multipleKeywordForm.controls["keyword"].setValidators([Validators.required, Validators.pattern(this.keywordRegex)]);
      this.multipleKeywordForm.controls["keyword"].updateValueAndValidity();
    }
    else {
      this.multipleKeywordForm.controls["keyword"].clearValidators();
      this.multipleKeywordForm.controls["keyword"].updateValueAndValidity();
      if (this.multipleKeywordForm.controls["keyword"].value != null && this.multipleKeywordForm.controls["keyword"].value != undefined && this.multipleKeywordForm.controls["keyword"].value != '') {
        this.multipleKeywordForm.controls["keyword"].setValidators([Validators.pattern(this.keywordRegex)]);
        this.multipleKeywordForm.controls["keyword"].updateValueAndValidity();
      } else {
        if (!isEnterKeyClicked) {
          this.keyWordModal.close();
        }
      }
    }
  }

  addKeywordOnEnter() {
    this.addMultipleKeyword(true, false);
    return false;
  }

  showMultipleKeywordModal(multipleKeyword: any, type: string, index?: number) {
    this.multiKeywordType = type;
    if (index != undefined && index != null) {
      this.batchKeywordIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'keyword-popup'
    };
    this.closeMultipleKeywordModal();
    this.keyWordModal = this._modalService
      .open(multipleKeyword, ngbModalOptions)
    this.keyWordModal.result.then(
      (result: any) => {

      },
      (reason: any) => {

      }
    );
  }

  closeMultipleKeywordModal() {
    this.multiKeywordFormSubmit = false;
    this.multipleKeywordData = [];
    this.showKeywordMessage = '';
    if (this.multiKeywordType == 'newClaim') {
      if (this.formSubmission.value.stKeywords) {
        this.multipleKeywordData = this.formStKeywords.split(",");
      }
    }
    else {
      if (this.getBatchDataResponse[this.batchKeywordIndex].Keyword) {
        this.multipleKeywordData = this.getBatchDataResponse[this.batchKeywordIndex].Keyword.split(",");
      }
    }
    this.multipleKeywordForm.reset();
  }

  addMultipleKeyword(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean) {
    this.requiredKeyword(isEnterKeyClicked);
    this.multiKeywordFormSubmit = true;
    if (!isSaveButtonClicked) {
      if (!this.multipleKeywordForm.value.keyword) {
        this.multipleKeywordForm.get('keyword')?.setErrors({ 'invalid': true });
      };
    }
    if (this.multipleKeywordForm.valid) {
      this.multipleKeywordData = this.multipleKeywordData.map(this.trimValue);
      const trimKeyword = this.multipleKeywordForm.value.keyword?.replace(/\s+/g, ' ').trim();
      if (trimKeyword == '') {
        this.multipleKeywordForm.get('keyword')?.setErrors({ 'invalid': true });
        return;
      }
      if (this.multipleKeywordData) {
        let isDuplicate = this.multipleKeywordData.find(x => x === trimKeyword) ? true : false;
        if (isDuplicate) {
          this.showKeywordMessage = "Keyword already added";
          return;
        }
      }
      if (trimKeyword) {
        this.multipleKeywordData.push(trimKeyword);
        this.multipleKeywordForm.get('keyword')?.setValue(null);
        this.multiKeywordFormSubmit = false;
        this.showKeywordMessage = '';
        this.requiredKeyword(isEnterKeyClicked);
      }
    }
  }

  removeKeyword(index: number) {
    this.multipleKeywordData.splice(index, 1);
  }

  checkDuplicateKeyword(event: any, keyword: any) {
    if (this.multipleKeywordData.length > 0) {
      let isDuplicate = this.multipleKeywordData.find(x => x === keyword) ? true : false;
      if (isDuplicate) {
        this.showKeywordMessage = "Keyword already added";
        this.multiKeywordFormSubmit = true;
      }
      else {
        this.showKeywordMessage = "";
      }
    }
  }

  saveKeyword() {
    this.addMultipleKeyword(false, true);
    let keywordDataString = this.multipleKeywordData.join(", ");
    this.formStKeywords = keywordDataString;
    if (this.multiKeywordType == 'newClaim') {
      this.formSubmission.controls['stKeywords'].setValue(keywordDataString.length >= 20 ? keywordDataString.substring(0, 20) + '...' : keywordDataString.substring(0, 20) + '');
      if (this.multipleKeywordData.length > 1) {
        this.showMoreKeywordText = true;
      }
      else {
        this.showMoreKeywordText = false;
      }
    }
    else {
      this.getBatchDataResponse[this.batchKeywordIndex].Keyword = keywordDataString;
      if (this.multipleKeywordData.length > 1) {
        this.showMoreBatchKeywordText[this.batchKeywordIndex] = true;
      }
      else {
        this.showMoreBatchKeywordText[this.batchKeywordIndex] = false;
      }
    }
    if (this.showKeywordMessage == "" && this.multipleKeywordData.length >= 0) {
      const keywordValue = this.multipleKeywordForm.value.keyword
      if (!keywordValue || keywordValue.length === 0) {
        this.keyWordModal.close();
      }
    }
  }

  // linkAnalysis field operation starts
  requiredKnownAs(isEnterKeyClicked: boolean) {
    if (this.multipleKnownAsData?.length == 0) {
      this.multipleKnownAsForm.controls["knownAs"].setValidators([Validators.required, Validators.pattern(this.knownAsRegex)]);
      this.multipleKnownAsForm.controls["knownAs"].updateValueAndValidity();
    }
    else {
      this.multipleKnownAsForm.controls["knownAs"].clearValidators();
      this.multipleKnownAsForm.controls["knownAs"].updateValueAndValidity();
      if (this.multipleKnownAsForm.controls["knownAs"].value != null && this.multipleKnownAsForm.controls["knownAs"].value != undefined && this.multipleKnownAsForm.controls["knownAs"].value != '') {
        this.multipleKnownAsForm.controls["knownAs"].setValidators([Validators.pattern(this.knownAsRegex)]);
        this.multipleKnownAsForm.controls["knownAs"].updateValueAndValidity();
      } else {
        if (!isEnterKeyClicked) {
          this.knownAsModal.close();
        }
      }
    }
  }

  addKnownAsOnEnter() {
    this.addMultipleKnownAs(true, false);
    return false;
  }

  showMultipleKnownAsModal(multipleKnownAs: any, type: string, index?: number) {
    this.multiKnownAsType = type;
    this.isAllowedMultipleKnownAs = true;
    if (index != undefined && index != null) {
      this.batchKnownAsIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'knownAs-popup'
    };
    this.closeMultipleKnownAsModal();
    this.knownAsModal = this._modalService
      .open(multipleKnownAs, ngbModalOptions)
    this.knownAsModal.result.then(
      (result: any) => {

      },
      (reason: any) => {

      }
    );
  }

  closeMultipleKnownAsModal() {
    this.multipleKnownAsFormSubmit = false;
    this.multipleKnownAsData = [];
    this.showKnownAsMessage = '';
    if (this.multiKnownAsType == 'newClaim') {
      if (this.formSubmission.value.stKnownAs) {
        this.multipleKnownAsData = this.formStKnownAs.split(",");
      }
    }
    else {
      if (this.getBatchDataResponse[this.batchKnownAsIndex].KnownAs) {
        this.multipleKnownAsData = this.getBatchDataResponse[this.batchKnownAsIndex].KnownAs.split(",");
      }
    }
    this.multipleKnownAsForm.reset();
  }

  addMultipleKnownAs(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean) {
    this.requiredKnownAs(isEnterKeyClicked);
    this.multipleKnownAsFormSubmit = true;
    this.isAllowedMultipleKnownAs = true;
    if (!isSaveButtonClicked) {
      if (!this.multipleKnownAsForm.value.knownAs) {
        this.multipleKnownAsForm.get('knownAs')?.setErrors({ 'invalid': true });
      };
    }

    if (this.multipleKnownAsForm.valid) {
      this.multipleKnownAsData = this.multipleKnownAsData.map(this.trimValue);
      const trimKnownAs = this.multipleKnownAsForm.value.knownAs?.replace(/\s+/g, ' ').trim();
      if (trimKnownAs == undefined || trimKnownAs == '') {
        this.multipleKnownAsForm.get('knownAs')?.setErrors({ 'invalid': true });
        return;
      }
      if (this.multipleKnownAsData) {
        let isDuplicate = this.multipleKnownAsData.find(x => x === trimKnownAs) ? true : false;
        if (isDuplicate) {
          this.showKnownAsMessage = "known as already added";
          return;
        }
        if (this.multipleKnownAsForm.value.knownAs) {
          let isMultipleKnownAs = this.multipleKnownAsData.length >= 5 ? true : false;
          if (isMultipleKnownAs) {
            this.isAllowedMultipleKnownAs = false;
            this.multipleKnownAsForm.get('knownAs')?.setErrors({ 'invalid': true });
            return;
          }
        }
      }
      if (trimKnownAs) {
        this.multipleKnownAsData.push(trimKnownAs);
        this.multipleKnownAsForm.get('knownAs')?.setValue(null);
        this.multipleKnownAsFormSubmit = false;
        this.showKnownAsMessage = '';
        this.requiredKnownAs(isEnterKeyClicked);
      }
    }
  }

  removeKnownAs(index: number) {
    this.multipleKnownAsData.splice(index, 1);
  }

  checkDuplicateKnownAs(event: any, KnownAs: any) {
    if (this.multipleKnownAsData.length > 0) {
      let isDuplicate = this.multipleKnownAsData.find(x => x === KnownAs) ? true : false;
      if (isDuplicate) {
        this.showKnownAsMessage = "Known as already added";
        this.multipleKnownAsFormSubmit = true;
      }
      else {
        this.showKnownAsMessage = "";
      }
    }
  }

  saveKnownAs() {
    this.addMultipleKnownAs(false, false);
    let KnownAsDataString = this.multipleKnownAsData.join(", ");
    this.formStKnownAs = KnownAsDataString;
    if (this.multiKnownAsType == 'newClaim') {
      this.formSubmission.controls['stKnownAs'].setValue(KnownAsDataString.length >= 20 ? KnownAsDataString.substring(0, 20) + '...' : KnownAsDataString.substring(0, 20) + '');
      if (this.multipleKnownAsData.length > 1) {
        this.showMoreKnownAsText = true;
      }
      else {
        this.showMoreKnownAsText = false;
      }
    }
    else {
      this.getBatchDataResponse[this.batchKnownAsIndex].KnownAs = KnownAsDataString;
      if (this.multipleKnownAsData.length > 1) {
        this.showMoreBatchKnownAsText[this.batchKnownAsIndex] = true;
      }
      else {
        this.showMoreBatchKnownAsText[this.batchKnownAsIndex] = false;
      }
    }
    if (this.showKnownAsMessage == "" && this.multipleKnownAsData.length >= 0 && this.isAllowedMultipleKnownAs) {
      const knownAsValue = this.multipleKnownAsForm.value.knownAs;
      if (!knownAsValue || knownAsValue.length === 0) {
        this.knownAsModal.close();
      }
    }
  }

  // linkAnalysis field operation starts
  requiredLinkAnalysis(isEnterKeyClicked: boolean) {
    if (this.multipleLinkAnalysisData?.length == 0) {
      this.hasShownLinkAnalysisToaster = false;
      this.multipleLinkAnalysisForm.controls["linkAnalysis"].setValidators([Validators.required, Validators.pattern(this.linkAnalysisRegex)]);
      this.multipleLinkAnalysisForm.controls["linkAnalysis"].updateValueAndValidity();
    }
    else {
      this.multipleLinkAnalysisForm.controls["linkAnalysis"].clearValidators();
      this.multipleLinkAnalysisForm.controls["linkAnalysis"].updateValueAndValidity();
      if (this.multipleLinkAnalysisForm.controls["linkAnalysis"].value != null && this.multipleLinkAnalysisForm.controls["linkAnalysis"].value != undefined && this.multipleLinkAnalysisForm.controls["linkAnalysis"].value != '') {
        this.multipleLinkAnalysisForm.controls["linkAnalysis"].setValidators([Validators.pattern(this.linkAnalysisRegex)]);
        this.multipleLinkAnalysisForm.controls["linkAnalysis"].updateValueAndValidity();
      } else {
        if (!isEnterKeyClicked) {
          this.linkAnalysisModal.close();
        }
      }
    }
  }

  addLinkAnalysisOnEnter() {
    this.addMultipleLinkAnalysis(true, false);
    return false;
  }

  showMultipleLinkAnalysisModal(multipleLinkAnalysis: any, type: string, index?: number) {
    this.multiLinkAnalysisType = type;
    this.isAllowedMultipleLinkAnalysis = true;
    if (index != undefined && index != null) {
      this.batchLinkAnalysisIndex = index;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'linkAnalysis-popup'
    };
    this.closeMultipleLinkAnalysisModal();
    this.linkAnalysisModal = this._modalService
      .open(multipleLinkAnalysis, ngbModalOptions)
    this.linkAnalysisModal.result.then(
      (result: any) => {

      },
      (reason: any) => {

      }
    );
  }

  closeMultipleLinkAnalysisModal() {
    this.multiLinkAnalysisFormSubmit = false;
    this.multipleLinkAnalysisData = [];
    this.showLinkAnalysisMessage = '';
    if (this.multiLinkAnalysisType == 'newClaim') {
      if (this.formSubmission.value.stLinkAnalysis) {
        this.multipleLinkAnalysisData = this.formStLinkAnalysis.split(",");
      }
    }
    else {
      if (this.getBatchDataResponse[this.batchLinkAnalysisIndex].LinkAnalysis) {
        this.multipleLinkAnalysisData = this.getBatchDataResponse[this.batchLinkAnalysisIndex].LinkAnalysis.split(",");
      }
    }
    this.multipleLinkAnalysisForm.reset();
  }

  addMultipleLinkAnalysis(isEnterKeyClicked: boolean, isSaveButtonClicked: boolean) {
    this.requiredLinkAnalysis(isEnterKeyClicked);
    this.multiLinkAnalysisFormSubmit = true;
    this.isAllowedMultipleLinkAnalysis = true;
    if (!isSaveButtonClicked) {
      if (!this.multipleLinkAnalysisForm.value.linkAnalysis) {
        this.multipleLinkAnalysisForm.get('linkAnalysis')?.setErrors({ 'invalid': true });
      };
    }

    if (this.multipleLinkAnalysisForm.valid) {
      this.multipleLinkAnalysisData = this.multipleLinkAnalysisData.map(this.trimValue);
      const trimLinkAnalysis = this.multipleLinkAnalysisForm.value.linkAnalysis?.replace(/\s+/g, ' ').trim();
      if (trimLinkAnalysis == undefined || trimLinkAnalysis == '') {
        this.multipleLinkAnalysisForm.get('linkAnalysis')?.setErrors({ 'invalid': true });
        return;
      }
      if (this.multipleLinkAnalysisData) {
        let isDuplicate = this.multipleLinkAnalysisData.find(x => x === trimLinkAnalysis) ? true : false;
        if (isDuplicate) {
          this.showLinkAnalysisMessage = "Link analysis already added";
          return;
        }
        if (this.multipleLinkAnalysisForm.value.linkAnalysis) {
          let isMultipleLinkAnalysis = this.multipleLinkAnalysisData.length >= 3 ? true : false;
          if (isMultipleLinkAnalysis) {
            this.isAllowedMultipleLinkAnalysis = false;
            this.multipleLinkAnalysisForm.get('linkAnalysis')?.setErrors({ 'invalid': true });
            return;
          }
        }
      }
      if (trimLinkAnalysis) {
        this.multipleLinkAnalysisData.push(trimLinkAnalysis);
        this.multipleLinkAnalysisForm.get('linkAnalysis')?.setValue(null);
        this.multiLinkAnalysisFormSubmit = false;
        this.showLinkAnalysisMessage = '';
        this.requiredLinkAnalysis(isEnterKeyClicked);
      }
    }
  }

  removeLinkAnalysis(index: number) {
    this.multipleLinkAnalysisData.splice(index, 1);
  }

  checkDuplicateLinkAnalysis(event: any, LinkAnalysis: any) {
    if (this.multipleLinkAnalysisData.length > 0) {
      let isDuplicate = this.multipleLinkAnalysisData.find(x => x === LinkAnalysis) ? true : false;
      if (isDuplicate) {
        this.showLinkAnalysisMessage = "Link analysis already added";
        this.multiLinkAnalysisFormSubmit = true;
      }
      else {
        this.showLinkAnalysisMessage = "";
      }
    }
  }

  saveLinkAnalysis() {
    this.addMultipleLinkAnalysis(false, false);
    let LinkAnalysisDataString = this.multipleLinkAnalysisData.join(", ");
    this.formStLinkAnalysis = LinkAnalysisDataString;
    if (this.multiLinkAnalysisType == 'newClaim') {
      this.formSubmission.controls['stLinkAnalysis'].setValue(LinkAnalysisDataString.length >= 20 ? LinkAnalysisDataString.substring(0, 20) + '...' : LinkAnalysisDataString.substring(0, 20) + '');
      if (this.multipleLinkAnalysisData.length > 1) {
        this.showMoreLinkAnalysisText = true;
      }
      else {
        this.showMoreLinkAnalysisText = false;
      }
    }
    else {
      this.getBatchDataResponse[this.batchLinkAnalysisIndex].LinkAnalysis = LinkAnalysisDataString;
      if (this.multipleLinkAnalysisData.length > 1) {
        this.showMoreBatchLinkAnalysisText[this.batchLinkAnalysisIndex] = true;
      }
      else {
        this.showMoreBatchLinkAnalysisText[this.batchLinkAnalysisIndex] = false;
      }
    }
    if (this.reportTypeId == 1 && this.multipleLinkAnalysisData.length == 1 && !this.hasShownLinkAnalysisToaster) {
      this.hasShownLinkAnalysisToaster = true;
      this._notificationService.showInfo("Attention: Report type changed to enhanced to accommodate request for link analysis", "Information");
    }
    if (this.reportTypeId == 1 && this.multipleLinkAnalysisData?.length > 0) {
      this.reportTypeId = 2;
    }
    if (this.showLinkAnalysisMessage == "" && this.multipleLinkAnalysisData.length >= 0 && this.isAllowedMultipleLinkAnalysis) {
      const linkAnalysisValue = this.multipleLinkAnalysisForm.value.linkAnalysis;
      if (!linkAnalysisValue || linkAnalysisValue.length === 0) {
        this.linkAnalysisModal.close();
      }
    }
  }
  // linkAnalysis field operation ends

  showCalendar(property: any) {
    let validdate = '';
    let dateValue = '';
    if (property == "dtDateofBirth") {
      dateValue = this.formSubmission.value.dtDateofBirth;
    }
    if (property == "dtClaimFile") {
      dateValue = this.formSubmission.value.dtClaimFile;
    }

    const regularExpression = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/?|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2)(\/?|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/?|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; // /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d+$/;

    let status = regularExpression.test(String(dateValue).toLowerCase());
    if (!status) {
      validdate = 'Invalid date'
    }

    if (dateValue != undefined) {
      if (dateValue.length >= 8) {
        let addDate = dateValue.split("/");
        if (Number(addDate[0]) <= 0 || Number(addDate[1]) <= 0 || Number(addDate[2]) <= 0 || (Number(addDate[2]) > new Date().getFullYear())) {
          validdate = 'Invalid date'
        }
        if (addDate[0] != undefined) {
          if (addDate[0].length > 2) {
            validdate = 'Invalid date'
          }
        }
        if (addDate[1] != undefined) {
          if (addDate[1].length > 2) {
            validdate = 'Invalid date'
          }
        }
        if (addDate[2] != undefined) {
          if (addDate[2].length != 4) {
            validdate = 'Invalid date'
          }
        }
      }
      if (dateValue.length <= 7) {
        validdate = 'Invalid date'
      }
    }

    if (property == "dtDateofBirth") {
      let date = new Date(dateValue);
      if (date.toString() != "Invalid Date" && validdate != 'Invalid date') {
        this.bsValueDateOfBirth = date;
      }
      else {
        this.bsValueDateOfBirth = '';
        this.updateDateofBirthbsValue = dateValue;
      }
    }

    if (property == "dtClaimFile") {
      let date = new Date(dateValue);
      if (date.toString() != "Invalid Date" && validdate != 'Invalid date') {
        this.bsValueClaimDate = date;
      }
      else {
        this.bsValueClaimDate = '';
        this.updateClaimFilebsValue = dateValue;
      }
    }

  }

  getMonitorIdNamePairs() {
    this._claimMonitorService.getMonitorIdNamePairs().subscribe(
      {
        next: response => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.arrMonitoring = response.data;
              this.spinner.hide();
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, "Error");
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", "Error"); // unknown error
          }
          else {
            this._notificationService.showError(error.error.errorMessage, "Error");
          }
        }
      }
    );
  }

  getReportType() {
    this._claimMonitorService.getReportType().subscribe(
      {
        next: response => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.arrReportType = response.data;
              // this.spinner.hide();
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, "Error");
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", "Error"); // unknown error
          }
          else if (error.status == 401) {
            this._notificationService.showError("Seems like your account has been archived. Please contact Administrator.", "Error"); // unknown error
          }
          else {
            this._notificationService.showError(error.error.errorMessage, "Error");
          }
        }
      }
    );
  }

  getPhysicalLimitation() {
    this.arrPhysicalLimitatioin = [
      {
        description: "No limitation of function capacity; capable of heavy work",
        id: 1,
        name: "Class 1"
      },
      {
        description: "Medium manual activity",
        id: 2,
        name: "Class 2"
      },
      {
        description: "Slight limitation; capable of light work",
        id: 3,
        name: "Class 3"
      },
      {
        description: "Moderate limitation; capable of clerical activity",
        id: 4,
        name: "Class 4"
      },
      {
        description: "Severe limitation; incapable of clerical activity",
        id: 5,
        name: "Class 5"
      },
    ]
    this.cdr.detectChanges();
  }

  whiteSpace(event: any) {
    if (event.charCode == 32 || event.code == 'Space') {
      event.preventDefault();
      return false;
    }
    return;
  }

  numericOnly(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  dateAllowNumericSlash(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && event.keyCode != 47 && !pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  changeMonitoring(index: any, stMonitoring: any) {
    let MonitorName = '';
    if (stMonitoring == '1') {
      MonitorName = 'Weekly';
    }
    else if (stMonitoring == '2') {
      MonitorName = 'Monthly';
    }
    else if (stMonitoring == '3') {
      MonitorName = 'Quarterly';
    }
    else if (stMonitoring == '4') {
      MonitorName = 'Yearly';
    }
    else {
      MonitorName = '';
    }

    this.getBatchDataResponse[index]['Monitoring'] = MonitorName;
  }

  onchangeReportTypeReviewPopup(index: any, ReportrTypeId: any, ReportTypeValue: any) {
    let ReportType = '';
    if (ReportrTypeId == '1') {
      ReportType = 'Basic';
    }
    else if (ReportrTypeId == '2') {
      ReportType = 'Enhanced';
    }
    else if (ReportrTypeId == '3') {
      ReportType = 'Monitoring';
    }
    else if (ReportrTypeId == '4') {
      ReportType = 'Identity';
    }
    else {
      ReportType = '';
    }
    this.getBatchDataResponse[index]['Reporttype'] = ReportType;
    this.changeClaimRequestValues(index, 'Reporttype', ReportType, 'ReporttypeChange');
  }

  onchangePhysicalLimitation(index: any, PhyLimitType: string) {
    let phyLimit = 0;
    if (PhyLimitType == 'Class 1') {
      phyLimit = 1;
    }
    else if (PhyLimitType == 'Class 2') {
      phyLimit = 2;
    }
    else if (PhyLimitType == 'Class 3') {
      phyLimit = 3;
    }
    else if (PhyLimitType == 'Class 4') {
      phyLimit = 4;
    }
    else if (PhyLimitType == 'Class 5') {
      phyLimit = 5;
    }
    else {
      phyLimit = 0;
    }
    this.getBatchDataResponse[index]['Limitation'] = phyLimit;
  }

  onchangeGender(index: any, value: string) {
    this.getBatchDataResponse[index]['Gender'] = value;
    // this.changeClaimRequestValues(index, 'genderType', value, 'genderTypeChange');
  }

  saveBatchRequestRecords(hideModal: boolean) {
    let arrinvalidData: any[] = [];
    let arrInvalidAge: any[] = [];
    this.getBatchDataResponse.forEach((element, index) => {
      let IsDateofbirthCheck = (document.getElementById(index + 'DateofBirthInvalid') as HTMLElement).classList.contains('d-none');
      let IsClaimfileDateCheck = (document.getElementById(index + 'ClaimfileDateInvalid') as HTMLElement).classList.contains('d-none');
      // let IsZipcodeCheck = (document.getElementById(index + 'ZipCodevalid') as HTMLElement).classList.contains('d-none');
      //let isFirstNameValid = (document.getElementById(index + 'firstNameValid') as HTMLElement).classList.contains('d-none');
      //let isLastNameValid = (document.getElementById(index + 'lastNameValid') as HTMLElement).classList.contains('d-none');
      let isAgeValid = (document.getElementById(index + 'DateofBirth') as HTMLElement).classList.contains('invalid-age');
      //let IsValidClaimId = (document.getElementById(index + 'ReferenceIdvalid') as HTMLElement).classList.contains('d-none');

      //if (!IsDateofbirthCheck || !IsClaimfileDateCheck || !IsZipcodeCheck || !isFirstNameValid) {
      // if (!IsDateofbirthCheck || !IsClaimfileDateCheck || !IsZipcodeCheck) {
      //   arrinvalidData[index] = true;
      // }

      if (isAgeValid) {
        arrInvalidAge[index] = true;
      }

      if (!isAgeValid) {
        this.getBatchDataResponse[index]['invalidAge'] = false;
      }

      if (element.Gender == undefined) {
        this.getBatchDataResponse[index]['Gender'] = "";
      }

      if (element.Notes == undefined) {
        this.getBatchDataResponse[index]['Notes'] = "";
      }

      if(element.LicensePlate == undefined){
        this.getBatchDataResponse[index]['LicensePlate'] = "";
      }

      if (element.DateofBirth == undefined) {
        this.getBatchDataResponse[index]['DateofBirth'] = "";
      }

      if (IsDateofbirthCheck && element.DateofBirth != "") {
        this.getBatchDataResponse[index]['DateofBirth'] = moment(element.DateofBirth).format("MM/DD/YYYY");
      }

      if (element.dtClaimFile == undefined) {
        this.getBatchDataResponse[index]['dtClaimFile'] = "";
      }
      if (IsClaimfileDateCheck && element.dtClaimFile != "") {
        this.getBatchDataResponse[index]['dtClaimFile'] = moment(element.dtClaimFile).format("MM/DD/YYYY");
      }
      element.Phone = element.wholePhone;
       element.Email = element.wholeEmail;
    })

    let arrphone = this.phoneValidCount.filter(x => x == true).length;
    let arremail = this.emailValidCount.filter(x => x == true).length;
    let arrinvalidAll = arrinvalidData.filter(x => x == true).length;
    let arrInvalidAgeAll = arrInvalidAge.filter(x => x == true).length;

    if (arrphone != 0 || arrinvalidAll != 0 || arremail != 0) {
      this._notificationService.showError("Please fill invalid data.", 'Error');
      return false;
    }
    if (arrInvalidAgeAll > 0) {
      this._notificationService.showError("The age based on the date of birth provided must be at least 18 years.", 'Error');
      return;
    }
    localStorage.setItem('batchRequestData', JSON.stringify(this.getBatchDataResponse));
    localStorage.setItem('batchValidRequestData', this.validUploadedData.toString());
    if (hideModal == true)
      this.hideModal();
    return false;
  }

  savesubmitBatchRequestRecords(event :any) {
    this.saveBatchRequestRecords(false);
    this.onSubmit(event);

    return;
  }

  requiredFile() {
    if (this.getBatchDataResponse.length == 0) {
      this.addInvalidClassForFile();
    }
  }

  addInvalidClassForFile() {
    document.getElementById("upload-wrapper")?.classList.add("is-invalid-file");
    document.getElementById("file-uploading-start")?.classList.add("text-invalid");
    document.getElementById("file-browse")?.classList.add("text-invalid");
  }

  removeInvalidClassForFile() {
    document.getElementById("upload-wrapper")?.classList.remove("is-invalid-file");
    document.getElementById("file-uploading-start")?.classList.remove("text-invalid");
    document.getElementById("file-browse")?.classList.remove("text-invalid");
  }

  addInvalidClassForFaceImagFile() {    
    document.getElementById("upload-face-image-wrapper")?.classList.add("is-invalid-file");
    document.getElementById("face-image-file-uploading-start")?.classList.add("text-invalid");
    document.getElementById("face-image-file-browse")?.classList.add("text-invalid");
  }

  removeInvalidClassFaceImagForFile() {
    document.getElementById("upload-face-image-wrapper")?.classList.remove("is-invalid-file");
    document.getElementById("face-image-file-uploading-start")?.classList.remove("text-invalid");
    document.getElementById("face-image-file-browse")?.classList.remove("text-invalid");
  }

  // Function to count duplicates based on specified fields
  checkForDuplicates(arr: any) {
    const countMap: any = {};
    for (const item of arr) {
      const key = `${item.stFirstName.toLowerCase()}|${item.stLastName?.toLowerCase()}|${item.dtDateofBirth}|${item.stAddress}`;
      if (countMap[key]) {
        return 1;  // Return 1 as soon as a duplicate is found
      } else {
        countMap[key] = 1;
      }
    }
    return false;  // Return false if no duplicates are found
  }

  private splitFullName(fullName: string): { firstName: string; lastName: string } {
    if (!fullName) {
      return { firstName: '', lastName: '' };
    }
 
    const [firstName, ...lastNameParts] = fullName.trim().split(' ');
    const lastName = lastNameParts.join(' ');
 
    return { firstName, lastName };
  }

  // Function to check available report type  for report type selection
checkAvailableReportType(): boolean {
  if (!this.availableReportTypesData) {
      return true;
  }
const sourceReports =
  this.selectedTeamAvailableReports && this.selectedTeamAvailableReports.trim() !== ""
    ? this.selectedTeamAvailableReports
    : this.availableReportTypesData;
    this.setReportFlags(sourceReports);
  const allowedReportTypes = (sourceReports || "")
      .split(',')
      .map(x => Number(x.trim()))
      .filter(x => !Number.isNaN(x));
      
  if (allowedReportTypes.length === 0) {
      return true;
  }

  let allValid = true;
  for (const item of this.getBatchDataResponse) {
      let reportTypeId: number;
      switch (item.Reporttype) {
          case 'Basic': reportTypeId = 1; break;
          case 'Enhanced': reportTypeId = 2; break;
          case 'Monitoring': reportTypeId = 3; break;
          case 'Identity': reportTypeId = 4; break;
          default: reportTypeId = this.reportTypeId ;
      }

      const isValidReportType = allowedReportTypes.includes(reportTypeId);
      
      if (!isValidReportType) {
          // Reset to "Select"
          if(item.inStatus == false){
            item.Reporttype = "";
            item.isInvalidReportType = true;
            allValid = false;
          }
          else{
            item.Reporttype = "";
            item.inStatus = false;
            item.isInvalidReportType = true;
            allValid = false;
            if (this.validUploadedData < 5) {
              this.validUploadedData++;         
            }
          }   
      } else {
          if (item.inStatus !== false) {
              item.inStatus = true;
          }
          item.isInvalidReportType = false;
      }
  }
  return allValid;
}

  async onSubmit(target: any) {
    try {
      this.isError = false;

      if (this.isError == false) {
        let defaultTime = 'T00:00:00.000Z';
        if (!this.isBatch) {
          if (this.formSubmission.value.stFirstName == " ") {
            this.formSubmission.controls['stFirstName'].setErrors({ 'incorrect': true });
          }
          // else if (this.formSubmission.value.stLastName == " ") {
          //   this.formSubmission.controls['stLastName'].setErrors({ 'incorrect': true });
          // }
          else if (this.getStReferenceIdValueForSubmit() === ' ') {
            //this.referenceIdInvalidate = true;
            this.formSubmission.controls['stReferenceId'].setErrors({ 'incorrect': true });
          }
          const refCtrl = this.formSubmission.get('stReferenceId');
          const refInvalid =
            !this.isLinkoutReferenceReadOnly &&
            (refCtrl?.invalid || refCtrl?.hasError('pattern'));
          if (this.formSubmission.controls.stFirstName.invalid || this.formSubmission.controls.stLastName.invalid ||
            this.formSubmission.controls.stAddress.invalid || this.formSubmission.controls.dtDateofBirth.invalid ||
             /*this.formSubmission.controls.stZipcode.invalid ||*/ this.formSubmission.controls.dtClaimFile.invalid ||
            refInvalid || this.isValidZip) {
            this.submitted = true;

            if (!this.isLinkoutReferenceReadOnly && this.formSubmission.get('stReferenceId')?.hasError('pattern')) {
              return;
            }
            return;
          }

          if (this.individualAgeInvalid) {
            this._notificationService.showError("The age based on the date of birth provided must be at least 18 years.", 'Error');
            return;
          }
          const additionalAddressCount = this.getAdditionalAddressCount();
          if (additionalAddressCount > this.maxAdditionalAddressCount) {
            this._notificationService.showError("Maximum 2 additional addresses allowed.", 'Error');
            this.submitted = true;
            return;
          }
          if (this.currentUserRole == 'super admin') {
            if (this.formSubmission.controls.stClient.invalid || this.formSubmission.controls.stExaminer.invalid || (this.formSubmission.controls.stUserTeam.invalid && this.userteams?.length > 0)) {
              this.submitted = true;
              return;
            }
          }
          this.spinner.show();
          this.addIndividual.uiClientId = this.formSubmission.value.stClient ? this.formSubmission.value.stClient : this.loCurrentUserData.clientId;
          if (this.currentUserRole == 'super admin') {
            this.addIndividual.uiTeamId = this.formSubmission.value.stUserTeam ? this.formSubmission.value.stUserTeam : '00000000-0000-0000-0000-000000000000';
          }
          else {
            this.addIndividual.uiTeamId = this.loCurrentTeamId ?? '00000000-0000-0000-0000-000000000000'; // selectedTeamId
          }
          this.addIndividual.isBatch = this.isBatch;
          this.addIndividual.stSubmissionFileName = null;
          // this.addIndividual.stBatchName = "";
          this.addIndividual.uiCreatedBy = this.formSubmission.value.stExaminer ? this.formSubmission.value.stExaminer : this.loCurrentUserData.userId; // Query
          this.addIndividual.stTimeZone = CommonFunction.GetTimeZone();
          this.addIndividual.fFaceImage = this.faceImageUrl?.toString() ?? "";   
          let arrformSubmission = [];
          if (this.physicalLimitationId == null || typeof (this.physicalLimitationId) == undefined) {
            this.physicalLimitationId = 0;
          }
          //const { firstName, lastName } = this.splitFullName(this.formSubmission.value.stFirstName.replace(/\s+/g, ' ').trim());
          arrformSubmission.push({
            stFirstName: this.formSubmission.value.stFirstName.replace(/\s+/g, ' ').trim(),
            stLastName: this.formSubmission.value.stLastName.replace(/\s+/g, ' ').trim(),
            inBirthYear: new Date(this.formSubmission.value.dtDateofBirth).getFullYear().toString(),
            stAddress: this.formSubmission.value.stAddress,
            // stZipCode: this.formSubmission.value.stZipcode,
            stPhoneNumber: this.formStPhoneNumber, //.split(","),
            stEmail: this.formStEmail, //.split(","),
            stCompanyName: ((this.formSubmission.value.stCompanyName.length === 0 || !this.formSubmission.value.stCompanyName.trim()) ? "" : this.formSubmission.value.stCompanyName),
            stOccupation: ((this.formSubmission.value.stOccupation.length === 0 || !this.formSubmission.value.stOccupation.trim()) ? "" : this.formSubmission.value.stOccupation),
            //inAge: String(Number(date.getFullYear() - this.formSubmission.value.inYearofBirth)),
            inPhysicalLimitationId: this.physicalLimitationId,
            inMonitorId: Number(3),// default monthly // Number(this.MonitoringId),
            inReportTypeId: Number(this.reportTypeId),
            isCompleted: true,
            inIteration: Number(1),
            dtClaimFile: moment(this.formSubmission.value.dtClaimFile).format('YYYY-MM-DD') + defaultTime,
            dtDateofBirth: moment(this.formSubmission.value.dtDateofBirth).format('YYYY-MM-DD') + defaultTime,
            stKnownAs: this.formStKnownAs,
            stKeywords: this.formStKeywords,
            stLinkAnalysis: this.formStLinkAnalysis,
            stReferenceId: this.getStReferenceIdValueForSubmit(),
            stGender: this.formSubmission.value.stGender == '' || this.formSubmission.value.stGender == undefined ? '' : this.formSubmission.value.stGender,
            stNotes: this.formSubmission.value.stNotes == '' || this.formSubmission.value.stNotes == undefined ? null : this.formSubmission.value.stNotes,
            flgIsScheduledClaim: this.reportTypeId == 3 ? false : null,
            // stClaimId: this.formSubmission.value.stClaimId ? this.formSubmission.value.stClaimId : null,
            stLicensePlate: this.formSubmission.value.stLicensePlate == '' || this.formSubmission.value.stLicensePlate == undefined ? null : this.formSubmission.value.stLicensePlate,
            stState: this.formSubmission.value.stState == '' || this.formSubmission.value.stState == undefined ? null : this.formSubmission.value.stState,
            stAdditionalAddress: this.formStAdditionalAddress ? this.formStAdditionalAddress : null,
          });
          this.addIndividual.lstClaimRequestSubmissions = arrformSubmission;
          const linkCid = LINKOUT_FEATURE_ENABLED ? (this.linkOutCorrelationId ?? '').trim() : '';
          this.addIndividual.correlationId = linkCid ? linkCid : null;

          if (this.reportTypeId != "" && this.reportTypeId != null && this.reportTypeId != undefined) {
            if (this.isClaimEdit) {
              this.updateClaim();             
            }
            else {
              this.formSubmit(this.addIndividual);
            }
          }
          else {
            this.spinner.hide();
            this._notificationService.showWarning("Please select Report type.", 'Warning'); // unknown error
          }
          // if (this.MonitoringId != "" && this.MonitoringId != null && this.MonitoringId != undefined){
          //     this.formsubmit(this.addIndividual);
          // }
          // else{
          //   this.spinner.hide();
          //   this._notificationService.showWarning("Please select monitoring.", 'Warning'); // unknown error
          // }
        }
        else {
          if (this.formSubmission.controls.stBatchName.invalid) {
            this.isBatchsubmitted = true;
            this.requiredFile();
            this.hideModal();
            return;
          }
          if (this.currentUserRole == 'super admin') {
            if (this.formSubmission.controls.stClient.invalid || this.formSubmission.controls.stExaminer.invalid || (this.formSubmission.controls.stUserTeam.invalid && this.userteams?.length > 0)) {
              this.isBatchsubmitted = true;
              return;
            }
          }
          this.spinner.show();
          if (this.getBatchDataResponse.length == 0) {
            this.requiredFile();
            this.isUploadedBatchFile = false;
            this.spinner.hide();
            return true;
          }
          if ((this.totalUploadedData - this.validUploadedData) <= 0) {
            this._notificationService.showError("Required atleast one record with complete claims data.", 'Error');
            this.spinner.hide();
            return true;
          }

          this.addIndividual.uiClientId = this.formSubmission.value.stClient ? this.formSubmission.value.stClient : this.loCurrentUserData.clientId;
          if (this.currentUserRole == 'super admin') {
            this.addIndividual.uiTeamId = this.formSubmission.value.stUserTeam ? this.formSubmission.value.stUserTeam : '00000000-0000-0000-0000-000000000000'
          }
          else {
            this.addIndividual.uiTeamId = this.loCurrentTeamId ?? '00000000-0000-0000-0000-000000000000'; // selectedTeamId
          }
          this.addIndividual.isBatch = this.isBatch;
          this.addIndividual.stSubmissionFileName = this.batchFile.name;
          this.addIndividual.stBatchName = this.formSubmission.value.stBatchName;
          this.addIndividual.uiCreatedBy = this.formSubmission.value.stExaminer ? this.formSubmission.value.stExaminer : this.loCurrentUserData.userId; // Query
          this.addIndividual.stTimeZone = CommonFunction.GetTimeZone();      
          this.addIndividual.fFaceImage = "";         
          let arrformSubmission: any[] = [];
          this.getBatchDataResponse.forEach(element => {
            let inMonitoringId: any;
            let inReportTypeId: any;
            let inPhysicalLimitationId: any;

            if (element.Monitoring == 'Weekly') {
              inMonitoringId = 1;
            }
            else if (element.Monitoring == 'Monthly') {
              inMonitoringId = 2;
            }
            else if (element.Monitoring == 'Quarterly') {
              inMonitoringId = 3;
            }
            else if (element.Monitoring == 'Yearly') {
              inMonitoringId = 4;
            }
            else {
              inMonitoringId = 0;
            }

            if (element.Reporttype == 'Basic') {
              inReportTypeId = 1;
            }
            else if (element.Reporttype == 'Enhanced') {
              inReportTypeId = 2;
            }
            else if (element.Reporttype == 'Monitoring') {
              inReportTypeId = 3;
            }
            else if (element.Reporttype == 'Identity') {
              inReportTypeId = 4;
            }
            else {
              inReportTypeId = 2;
            }
            //const { firstName, lastName } = this.splitFullName(element.Firstname.replace(/\s+/g, ' ').trim());

            arrformSubmission.push({
              stFirstName: element.Firstname.replace(/\s+/g, ' ').trim(),
              stLastName: element.Lastname?.replace(/\s+/g, ' ').trim(),
              stCompanyName: ((element.Company.length === 0 || !element.Company.trim()) ? "" : element.Company),
              inBirthYear: element.DateofBirth == '' || element.DateofBirth == undefined ? '' : (new Date(element.DateofBirth).getFullYear()).toString(),
              stPhoneNumber: element.Phone, //.split(","),
              stEmail: element.Email, //.split(","),
              stAddress: element.Address,
              // stZipCode: element.Zip,
              stOccupation: ((element.Occupation.length === 0 || !element.Occupation.trim()) ? "" : element.Occupation),
              inMonitorId: Number(inMonitoringId),
              inPhysicalLimitationId: Number(element.Limitation),
              inReportTypeId: Number(inReportTypeId),
              isCompleted: element.inStatus,
              inIteration: Number(1),
              dtClaimFile: element.dtClaimFile == '' || element.dtClaimFile == undefined ? null : moment(element.dtClaimFile).format('YYYY-MM-DD') + defaultTime,
              dtDateofBirth: element.DateofBirth == '' || element.DateofBirth == undefined ? null : moment(element.DateofBirth).format('YYYY-MM-DD') + defaultTime,
              stKnownAs: element.Knownas,
              stKeywords: element.Keyword,
              stLinkAnalysis: element.LinkAnalysis,
              stReferenceId: element.ReferenceId == '' || element.ReferenceId == undefined ? null : element.ReferenceId,
              stGender: element.Gender == '' || element.Gender == undefined ? "" : element.Gender,
              stNotes: element.Notes == '' || element.Notes == undefined ? null : element.Notes,
              flgIsScheduledClaim: this.reportTypeId == 3 ? true : null,
              stLicensePlate: element.LicensePlate == '' || element.LicensePlate == undefined ? null : element.LicensePlate,
              stState: element.State == '' || element.State == undefined ? null : element.State,
              stAdditionalAddress: element.AdditionalAddress == '' || element.AdditionalAddress == undefined ? null : element.AdditionalAddress,
            });
          });
          const duplicateCounts = this.checkForDuplicates(arrformSubmission);
          if (duplicateCounts) {
            this.spinner.hide();
            return this._notificationService.showError("Duplicate entries detected. Each entry must have a unique combination of name, zip code, and date of birth.", "Error");
          }

         
          const linkCidBatch = LINKOUT_FEATURE_ENABLED ? (this.linkOutCorrelationId ?? '').trim() : '';
          this.addIndividual.correlationId = linkCidBatch ? linkCidBatch : null;
          this.addIndividual.lstClaimRequestSubmissions = arrformSubmission;
          this.formSubmit(this.addIndividual);
        }
      }
    }
    catch (error) {
      console.log(error);
      this.spinner.hide();
    }
    return
  }

  async formSubmit(data: any) {
    if (!this.isButtonDisabled) { 
      this.isButtonDisabled = true;
    }

    const isLinkoutSubmit =
      LINKOUT_FEATURE_ENABLED && !!(this.linkOutCorrelationId ?? '').toString().trim();
    const submit$ = isLinkoutSubmit
      ? this._claimMonitorService.linkoutSubmit(data)
      : this._claimMonitorService.addIndividualClaim(data);

    submit$.subscribe(
      {
        next: response => {
          if (!response) {
            this.isButtonDisabled = false;
            this.spinner.hide();
            return;
          }
          this.isButtonDisabled = false;
          this.spinner.hide();

          if (isLinkoutSubmit) {
            const linkoutData = response as { url?: string; Url?: string; subscriptionId?: string; SubscriptionId?: string };
            const rawUrl = (linkoutData?.url ?? linkoutData?.Url ?? '').toString().trim();
            this.hideModal();
            this._notificationService.showSuccess('Request submitted.', 'Success');
            this.matDialogRef.close('RefreshClaimMonitoringList');
            // if (rawUrl) {
            //   const target = /^https?:\/\//i.test(rawUrl)
            //     ? rawUrl
            //     : `${window.location.origin}${rawUrl.startsWith('/') ? rawUrl : '/' + rawUrl}`;
            //   window.location.href = target;
            //   return;
            // }
            // No redirect URL returned — log the Verisk user out after 5 seconds
            setTimeout(() => {
              this._Router.navigate(['requests']);
            }, 5000);
            return;
          }

          this._notificationService.showSuccess(response, "Success");
          if (this.currentUserRole != 'super admin') {
            this._Router.navigate(['requests']);
          }
          this.hideModal();
          this.matDialogRef.close("RefreshClaimMonitoringList");
        },
        error: (error) => {
          this.isButtonDisabled = false;
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, "Error");
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", "Error"); // unknown error
          }
          else if (error.status == 401) {
            this._notificationService.showError("Seems like your account has been archived. Please contact Administrator.", "Error"); // unknown error
          }
          else {
            if (error.error && error.error.stErrorMessage && error.error.stErrorMessage.trim() !== '') {
              this._notificationService.showError(error.error.stErrorMessage, "Error");   
              if (data.isBatch == true){
                this.errorIds = error.error.errorIds;
                this.processErrorIds(this.errorIds);
              }
            }
            else if (error.error && error.error.errorMessage) {
              this._notificationService.showError(error.error.errorMessage, "Error");
            }
            else {
              this._notificationService.showError("An unexpected error occurred. Please try again.", "Error");
            }
          }
        }
      }
    );
  }

  processErrorIds(ids: number[]): void {
    this.validUploadedData = 0;
    ids.forEach((id) => {
      this.validUploadedData = (this.validUploadedData + 1);
      this.getBatchDataResponse[id]['inStatus'] = false;

      this.getBatchDataResponse.sort(function (a, b) { return (b.inStatus > a.inStatus) ? -1 : ((a.inStatus > b.inStatus) ? 1 : 0); });

    });
  }

  updateClaim() {
    let defaultTime = 'T00:00:00.000Z';
    if (this.physicalLimitationId == null || typeof (this.physicalLimitationId) == undefined) {
      this.physicalLimitationId = 0;
    }

    let inputLicensePlate = this.formSubmission.value.stLicensePlate?.trim();
    let inputLicenseState = this.formSubmission.value.stState;
    let licensePlate = '';
    let licenseState = '';

    if (!inputLicensePlate || inputLicensePlate === '') {
      licensePlate = this.claimInfo.stLicensePlate;
      licenseState = this.claimInfo.stState;
    } else {
      let parts = inputLicensePlate.split(' ').filter((p: string) => p); // fixed
      if (parts.length > 1) {
        licenseState = parts.pop()!;
        licensePlate = parts.join(' ');
      } else {
        licensePlate = inputLicensePlate;
        licenseState = inputLicenseState;
      }
    }
    const updatePayload = {
      inClaimMonitorId: this.claimInfo.inClaimMonitorId,
      inClaimIterationId: this.claimInfo.inClaimIterationId,
      fFaceImage: this.faceImagFile,
      //lstUpdateClaimRequestSubmission: [{
      uiClientId: this.claimInfo.uiClientId,
      uiTeamId: this.loCurrentTeamId ?? '00000000-0000-0000-0000-000000000000',
      stFirstName: this.formSubmission.value.stFirstName.replace(/\s+/g, ' ').trim(),
      stLastName: this.formSubmission.value.stLastName.replace(/\s+/g, ' ').trim(),//this.formSubmission.value.stLastName,
      inBirthYear: new Date(this.formSubmission.value.dtDateofBirth).getFullYear().toString(),
      // stZipCode: this.formSubmission.value.stZipcode,
      phoneNo: this.formStPhoneNumber,
      stEmail: this.formStEmail,
      stGender: this.formSubmission.value.stGender == '' || this.formSubmission.value.stGender == undefined ? "" : this.formSubmission.value.stGender,
      stCompanyName: ((this.formSubmission.value.stCompanyName.length === 0 || !this.formSubmission.value.stCompanyName.trim()) ? "" : this.formSubmission.value.stCompanyName),
      stOccupation: ((this.formSubmission.value.stOccupation.length === 0 || !this.formSubmission.value.stOccupation.trim()) ? "" : this.formSubmission.value.stOccupation),
      inPhysicalLimitationId: this.physicalLimitationId,
      dtClaimFile: moment(this.formSubmission.value.dtClaimFile).format('YYYY-MM-DD') + defaultTime,
      dtDateofBirth: moment(this.formSubmission.value.dtDateofBirth).format('YYYY-MM-DD') + defaultTime,
      stKnownAs: this.formStKnownAs,
      stKeywords: this.formStKeywords,
      stLinkAnalysis: this.formStLinkAnalysis,
      stAdditionalAddress: this.formStAdditionalAddress ? this.formStAdditionalAddress : null,
      uiUpdatedBy: this.loCurrentUserData.userId,
      stReferenceId: (() => {
        const ref = this.getStReferenceIdValueForSubmit();
        return ref == null ? this.claimInfo.stReferenceId : ref;
      })(),
      stNotes: this.formSubmission.value.stNotes == '' || this.formSubmission.value.stNotes == undefined ? this.claimInfo.stNotes : this.formSubmission.value.stNotes,
      stFaceImage: this.faceImagFile == null ? this.faceImageUrl : '',
      stAddress : this.formSubmission.value.stAddress,
        stLicensePlate: licensePlate,
        stState: licenseState,
      //}]
    };
    if (!this.isButtonDisabled) {
      this.isButtonDisabled = true;
    }
    this._claimMonitorService.updateClaim(updatePayload).subscribe(
      {
        next: response => {
          if (!!response) {
            const fnCallBack =  () => {
              this._notificationService.showSuccess(response.data, "Success");
              this.spinner.hide();
              this._Router.navigate(['requests']);
              this.matDialogRef.close("updateClaim");
              this.isButtonDisabled = false;
            }
            this.callback(this.claimInfo.inClaimMonitorId, false, fnCallBack);
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.isButtonDisabled = false;
          if (error.status == 0) {
            this._notificationService.showError(error.message, "Error");
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", "Error"); // unknown error
          }
          else if (error.status == 401) {
            this._notificationService.showError("Seems like your account has been archived. Please contact Administrator.", "Error"); // unknown error
          }
          else {
            this._notificationService.showError(error.error.errorMessage, "Error");
          }
        }
      }
    );
  }

  checkCharLength(data: any, event: any) {
    if (data.length > 100) {
      event.preventDefault();
    }
  }

  onDateChange(event: any, id: any, property: any) {
    if (event != undefined) {
      if (property == "dtClaimFile") {
        if (event == 'Invalid Date') {
          $("#" + id + "dtClaimFile").val("");
          document.getElementById(id + 'dtClaimFile')?.classList.add("invalid-input");
          document.getElementById(id + 'ClaimfileDateInvalid')?.classList.remove("d-none");
          this.getBatchDataResponse[id][property] = "";
          this.changeClaimRequestValues(id, property, "", 'claimInvalid');
        }
        else {
          if (this.isManuallyClaimChange) {
            $("#" + id + "dtClaimFile").val(this.isChangeClaimfileDate);
            document.getElementById(id + 'dtClaimFile')?.classList.add("invalid-input");
            document.getElementById(id + 'ClaimfileDateInvalid')?.classList.remove("d-none");
            this.getBatchDataResponse[id][property] = moment(event).format('MM/DD/YYYY');
            this.changeClaimRequestValues(id, property, event, 'claimManuallyChange');
          }
          else {
            document.getElementById(id + 'dtClaimFile')?.classList.remove("invalid-input");
            document.getElementById(id + 'ClaimfileDateInvalid')?.classList.add("d-none");
            this.getBatchDataResponse[id][property] = moment(event).format('MM/DD/YYYY');
            this.changeClaimRequestValues(id, property, event, 'claimCalendarChange');
          }

        }
      }

      if (property == "DateofBirth") {
        if (event == 'Invalid Date') {
          $("#" + id + "DateofBirth").val("");
          document.getElementById(id + 'DateofBirth')?.classList.add("invalid-input");
          document.getElementById(id + 'DateofBirthInvalid')?.classList.remove("d-none");
          this.getBatchDataResponse[id][property] = "";
          this.changeClaimRequestValues(id, property, "", 'dobInvalid');

        }
        else {
          if (this.isManuallyDateChange) {
            $("#" + id + "DateofBirth").val(this.isChangeDateOfBirth);
            document.getElementById(id + 'DateofBirth')?.classList.add("invalid-input");
            document.getElementById(id + 'DateofBirthInvalid')?.classList.remove("d-none");
            this.getBatchDataResponse[id][property] = this.isChangeDateOfBirth;
            this.changeClaimRequestValues(id, property, event, 'dobManuallyChange');
          }
          else {
            document.getElementById(id + 'DateofBirth')?.classList.remove("invalid-input");
            document.getElementById(id + 'DateofBirthInvalid')?.classList.add("d-none");
            this.getBatchDataResponse[id][property] = moment(event).format('MM/DD/YYYY');
            this.changeClaimRequestValues(id, property, event, 'dobCalendarChange');
          }

        }
      }

    }

  }
  checkChange(event: any, Id: any, key: any, index: any) {
    let array = ['Weekly', 'Monthly', 'Quarterly', 'Yearly']
    for (let i = 0; i < array.length; i++) {
      const checkbox = document.getElementById(i + '_' + array[i]) as HTMLInputElement | null;
      if (checkbox != null) {
        checkbox.checked = false;
      }
    }

    const checkbox = document.getElementById(index + '_' + key) as HTMLInputElement | null;

    if (checkbox != null) {
      checkbox.checked = true;
    }
    this.monitoringId = Id;
  }

  changeReportType(event: any) {
    this.reportTypeId = event.target.value;
  }

  disableReportType(): boolean {
    return this.multipleLinkAnalysisData?.length > 0;
  }

  changePhysicalLimitation(event: any, Id: any, key: any, index: any) {
    if (event.target.checked) {
      let arrPhysicalLimitatioin = ['Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5'];
      for (let i = 0; i < arrPhysicalLimitatioin.length; i++) {
        const checkbox = document.getElementById(i + '_' + arrPhysicalLimitatioin[i]) as HTMLInputElement | null;
        if (checkbox != null) {
          checkbox.checked = false;
        }
      }
      const checkbox = document.getElementById(index + '_' + key) as HTMLInputElement | null;
      if (checkbox != null) {
        checkbox.checked = true;
      }
      this.physicalLimitationId = Id;
    }
    else {
      this.physicalLimitationId = null;
    }
  }

  onlyNumbers(str: any) {
    return /^[0-9]+$/.test(str);
  }

  physicallimitationValidation(str: any) {
    return /^[0-5]+$/.test(str);
  }

  extractElementDataFromHtml(doc: Document,searchParam: string): string {
    let valueText = "";
    const searchedText = Array.from(doc.getElementsByTagName('td')).find((td, index) => {
      return td.innerText.trim() === searchParam;
    });

    if (searchedText) {
      const parentRow = searchedText.closest('tr') as HTMLElement;
      const sibilingRow  = parentRow.nextSibling as HTMLElement;
       const tdElements = Array.from(parentRow.querySelectorAll(':scope > td'));
       const searchElementIndex = tdElements.indexOf(searchedText);
      
       const tdSibilingElements = Array.from(sibilingRow?.querySelectorAll(':scope > td'));
       const valueHtmlText = tdSibilingElements[searchElementIndex] as HTMLElement;
       valueText = (valueHtmlText as HTMLElement).innerText.trim();      
    } else {
      valueText = "";
    }
    return  valueText;
  }

  validateFile(event: any) {
    if (this.availableReportTypesData === '') {
    this.isFileExist = false;
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  this.isFileExist = true;
  return true;
}

  async addfile(event: any) {   
    await this.getTeamById();
    if (event.target.files.length > 0) {
      this.batchFile = event.target.files[0];
      this.removeInvalidClassForFile();
      document.getElementById("file-upload-name")!.innerHTML = '';
      document.getElementById("upload-wrapper")?.classList.add("uploaded");
      document.getElementById("upload-wrapper")?.classList.remove("success");
      document.getElementById("batch-upload-data-info")?.classList.add("d-none");
      this.totalUploadedData = 0;
      this.validUploadedData = 0;
      if (this.checkfile(this.batchFile)) {
        this.spinner.show();
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(this.batchFile);
        fileReader.onload = async (e) => {
          this.getBatchDataResponse = [];
          this.arrayBuffer = fileReader.result;
          var data = new Uint8Array(this.arrayBuffer);
          var arraylist: any[];
          if(this.isBatchFileExt == 'xml')
            {
      
                var xml_content = "";
                for (var i = 0; i < data.length; i++) {xml_content += String.fromCharCode(data[i]); }          
                var parser = new DOMParser();
                let xmlDoc = parser.parseFromString(xml_content, 'text/xml'); 
                var claims = xmlDoc.getElementsByTagName("JURISReferral");
              
                
                var arrXml = [];
                for (let i = 0; i < claims.length; i++) {
                  const claimant = claims[i].getElementsByTagName("Claimant")[0];
                  const claimantContactInfo = claims[i].getElementsByTagName("ClaimantContactInfo")[0];
                  const claimantDetail = claims[i].getElementsByTagName("ClaimantDetail")[0];
                  const caseData = claims[i].getElementsByTagName("Case")[0];
                  let claimData: any = {};
                  const addressParts = [
                    claimantContactInfo.getElementsByTagName("Address1")[0]?.textContent,
                    claimantContactInfo.getElementsByTagName("Address2")[0]?.textContent,
                    claimantContactInfo.getElementsByTagName("City")[0]?.textContent,
                    claimantContactInfo.getElementsByTagName("State")[0]?.textContent,
                    claimantContactInfo.getElementsByTagName("ZipCode")[0]?.textContent
                  ];
                  const address = addressParts
                    .filter(part => part && part.trim() !== "") // Remove empty/undefined/null
                    .join(", ");
                  //claimData.Fullname = claimant.getElementsByTagName("FirstName")[0]?.textContent +" "+ claimant.getElementsByTagName("LastName")[0]?.textContent || '';
                  claimData.Firstname = claimant.getElementsByTagName("FirstName")[0]?.textContent;
                  claimData.Lastname = claimant.getElementsByTagName("LastName")[0]?.textContent;
                  claimData.Dateofbirth = claimant.getElementsByTagName("DOB")[0]?.textContent || '';
                  claimData.Address = address;
                  // claimData.Zip = claimantContactInfo.getElementsByTagName("ZipCode")[0]?.textContent || '';
                  claimData.Gender = claimant.getElementsByTagName("Gender")[0]?.textContent || '';
                  claimData.Reporttype = this.reportTypeId === 1 ? 'Basic' :
                       this.reportTypeId === 2 ? 'Enhanced' :
                       this.reportTypeId === 3 ? 'Monitoring' :
                       this.reportTypeId === 4 ? 'Identity' : '';
           
                  claimData.LookbackDate = caseData.getElementsByTagName("DateOfInjury")[0]?.textContent || '';;
                  claimData.Phone = claimantContactInfo.getElementsByTagName("HomePhone")[0]?.textContent || '';
                   claimData.Email = claimantContactInfo.getElementsByTagName("Email")[0]?.textContent || '';
                  claimData.Company = '';
                  claimData.Occupation = claimantDetail.getElementsByTagName("Occupation")[0]?.textContent || '';
                  claimData.Limitation = '3';
                  claimData.Knownas = '';
                  claimData.Keyword = '';
                  claimData.Linkanalysis ='';
                  claimData.ReferenceId = caseData.getElementsByTagName("PolicyNumber")[0]?.textContent || '';
                  claimData.Notes = caseData.getElementsByTagName("EventDescription")[0]?.textContent || '';
                  let fullPlate = claimantContactInfo.getElementsByTagName("LicensePlate")[0]?.textContent?.trim() || '';
                  let plateParts = fullPlate.split(' ').filter((p: string) => p);
                  if (plateParts.length > 1) {
                    claimData.State = plateParts.pop()!; 
                    claimData.LicensePlate = plateParts.join(' '); 
                  } else {
                    claimData.LicensePlate = fullPlate;
                    claimData.State = '';
                  }
                  arrXml.push(claimData);
                }
                 arraylist = arrXml;
            }
            else if (this.isBatchFileExt == "doc" || this.isBatchFileExt == "docx") {
              const result = await mammoth.convertToHtml({ arrayBuffer: data.buffer});            
               const parser = new DOMParser();
               const doc = parser.parseFromString(result.value, 'text/html');
               let claimData: any = {};
               var arrXml = [];
               //claimData.Fullname = this.extractElementDataFromHtml(doc,"First Name") +' '+ this.extractElementDataFromHtml(doc,"Last Name") || '';
               claimData.Firstname = this.extractElementDataFromHtml(doc,"First Name"); 
               claimData.Lastname = this.extractElementDataFromHtml(doc,"Last Name");
               claimData.Dateofbirth = this.extractElementDataFromHtml(doc,"DOB") || '';
               claimData.Address = this.extractElementDataFromHtml(doc, "Current Address") || '';
               //claimData.Zip =  this.extractElementDataFromHtml(doc, "Current Address")?.split(',').pop()?.trim()?.split(' ')[1] || '';
               claimData.Gender = this.extractElementDataFromHtml(doc,"Gender") == undefined || this.extractElementDataFromHtml(doc,"Gender") == "" ? "" : this.extractElementDataFromHtml(doc,"Gender") == "Male" ? 'M' : 'F';
              //  claimData.Reporttype =  '';
               claimData.Reporttype = this.reportTypeId === 1 ? 'Basic' :
                       this.reportTypeId === 2 ? 'Enhanced' :
                       this.reportTypeId === 3 ? 'Monitoring' :
                       this.reportTypeId === 4 ? 'Identity' : '';
               claimData.LookbackDate = this.extractElementDataFromHtml(doc,"Date of Loss") || '';
               claimData.Phone = this.extractElementDataFromHtml(doc,"Home Phone #").toString().replace(/[^\d]/g, '') || '';
               claimData.Email = this.extractElementDataFromHtml(doc,"Email") || '';
               claimData.Company = '';
               claimData.Occupation = this.extractElementDataFromHtml(doc,"Occupation") || '';
               claimData.Limitation = '3';
               claimData.Knownas = '';
               claimData.Keyword = '';
               claimData.Linkanalysis = '';
               claimData.ReferenceId = this.extractElementDataFromHtml(doc,"Claim #") || '';;
               claimData.Notes = this.extractElementDataFromHtml(doc,"Event Desc") || '';
               let fullPlate = this.extractElementDataFromHtml(doc, "LicensePlate")?.trim() || '';
              let plateParts = fullPlate.split(' ').filter((p: string) => p);
              if (plateParts.length > 1) {
                claimData.State = plateParts.pop()!;
                claimData.LicensePlate = plateParts.join(' '); 
              } else {
                claimData.LicensePlate = fullPlate;
                claimData.State = '';
              }
               arrXml.push(claimData);
               arraylist = arrXml;
            }
            else if(this.isBatchFileExt == "xls")
            {
              var arr = new Array();
              for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);

              var bstr = arr.join("");
              var workbook = XLSX.read(bstr, { type: "binary" });

              var first_sheet_name = workbook.SheetNames[0];
              var second_sheet_name = workbook.SheetNames[1];
              var worksheet = workbook.Sheets[first_sheet_name];
              arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: false, defval: '' });
              if(this.reportTypeIdXls !== null && this.reportTypeIdXls !== undefined)
              {
                var reportType = this.reportTypeIdXls === 1 ? 'Basic' :
                 this.reportTypeIdXls === 2 ? 'Enhanced' :
                 this.reportTypeIdXls === 3 ? 'Monitoring' :
                 this.reportTypeIdXls === 4 ? 'Identity' : '';

                  arraylist.forEach(function(claimData) {
                    if (!claimData.Reporttype || claimData.Reporttype.trim() === '') {
                      claimData.Reporttype = reportType;
                    }
                    let fullPlate = (claimData.LicensePlate || '').trim();
                  let plateParts = fullPlate.split(' ').filter((p: string) => p);
                  if (plateParts.length > 1) {
                    claimData.State = plateParts.pop(); 
                    claimData.LicensePlate = plateParts.join(' '); 
                  } else {
                    claimData.State = '';
                    claimData.LicensePlate = fullPlate;
                  }
                  });
              }
            }
            else
            {
              arraylist=[];
            }
          if (arraylist.length > 0) {
            const propertiesToCheck = ['Firstname', 'Lastname', 'Dateofbirth', 'Address', 'Reporttype', 'LookbackDate', 'Phone', 'Email', 'Company', 'Occupation', 'Limitation', 'Knownas', 'Keyword', 'Linkanalysis', 'ReferenceId', 'Notes', 'LicensePlate'];
            if (propertiesToCheck.some(prop => arraylist[0][prop] === undefined)) {
              this.isUploadedBatchFile = false;
              this.addInvalidClassForFile();
            }
            else {
              var inMissingDataCount = 0;
              this.totalUploadedData = (arraylist.length)
              arraylist.forEach((element: any, index) => {
                var isValid = true;
                let zipcode = '';
                let FinalMissingCount = false;
                /*if ((element.Reporttype == 'Basic' && element.Linkanalysis.length > 0) || element.Reporttype == '') {
                  element.Reporttype = 'Enhanced';
                } */
                if(element.Firstname == "" || element.Firstname == undefined || !this.nameRegex.test(element.Firstname)){
                  this.rowNumber = "a";
                  isValid = false;
                  FinalMissingCount = true;
                }
                else if(element.Lastname == "" || element.Lastname == undefined || !this.nameRegex.test(element.Lastname)){
                  this.rowNumber = "b";
                  isValid = false;
                  FinalMissingCount = true;
                }
                // if (element.Fullname == "" || element.Fullname == undefined) {
                //   this.rowNumber = "a";
                //   isValid = false;
                //   FinalMissingCount = true;
                // }
                // else if(element.Fullname.trim().split(' ').length < 2){
                //   this.rowNumber = "a";
                //   isValid = false;
                //   FinalMissingCount = true;
                // }
                else if (element.Dateofbirth == "" || element.Dateofbirth == undefined || element.Dateofbirth == null) {
                  this.rowNumber = "c";
                  isValid = false;
                  FinalMissingCount = true;
                }
                else if (element.Address == "" || element.Address == undefined || element.Address == null) {
                  this.rowNumber = "d";
                  isValid = false;
                  FinalMissingCount = true;
                }
                // else if (element.Zip == "" || element.Zip == undefined || element.Zip == null) {
                //   this.rowNumber = "e";
                //   isValid = false;
                //   FinalMissingCount = true;
                // }
                else if (element.LookbackDate == "" || element.LookbackDate == undefined || element.LookbackDate == null) {
                  this.rowNumber = "e";
                  isValid = false;
                  FinalMissingCount = true;
                }
                else if (element.LookbackDate == "" || element.LookbackDate == undefined || element.LookbackDate == null) {
                  this.rowNumber = "f";
                  isValid = false;
                  FinalMissingCount = true;
                }
                // else if (element.Gender.toLowerCase() != 'm' && element.Gender.toLowerCase() != 'f') {
                //   isValid = false;
                //   FinalMissingCount = true;
                // }
                else if (element.Reporttype == "" || element.Reporttype == undefined || element.Reporttype == null || element.Reporttype == 'Enhance') {
                  this.rowNumber = "g";
                  isValid = false;
                  FinalMissingCount = true;
                }
                else if (element.ReferenceId == "" || element.ReferenceId == undefined || element.ReferenceId == null) {
                  this.rowNumber = "h";
                  isValid = false;
                  FinalMissingCount = true;
                }
                // else if (element.Keyword == "" || element.Keyword == undefined || element.Keyword == null || element.Keyword == 'Enhance') {
                //   // this.rowNumber = "f";
                //   isValid = false;
                //   FinalMissingCount = true;
                // }
                else {
                  if (element.Reporttype == 'Basic' || element.Reporttype == 'Enhanced' || element.Reporttype == 'Monitoring' || element.Reporttype == 'Identity') {
                    isValid = true;
                  }
                  else {
                    this.rowNumber = "i";
                    isValid = false;
                    FinalMissingCount = true;
                  }
                  this.rowNumber = "j";
                }
                let formattedPhoneNo = '';
                let PhoneNo = element.Phone == undefined ? '' : element.Phone;
                if (PhoneNo != '') {
                  let pNo1 = element.Phone.slice(0, 3);
                  let pNo2 = element.Phone.slice(3, 6);
                  let pNo3 = element.Phone.slice(6, 12);
                  formattedPhoneNo = '(' + pNo1 + ')' + ' ' + pNo2 + '-' + pNo3;
                }

                if (element.Dateofbirth != null) {
                  element.Dateofbirth = element.Dateofbirth == undefined ? element.Dateofbirth : element.Dateofbirth.replace("-", "/").replace("-", "/");
                }
                if (element.LookbackDate != null) {
                  element.LookbackDate = element.LookbackDate == undefined ? element.LookbackDate : element.LookbackDate.replace("-", "/").replace("-", "/");
                }

                let todaydate = moment(new Date()).format("MM/DD/YYYY");
                let dob = moment(new Date(element.Dateofbirth)).format("MM/DD/YYYY");
                let claimdate = moment(new Date(element.LookbackDate)).format("MM/DD/YYYY")
                if (dob != undefined) {
                  element.invalidAge = false;
                  const birthDate = new Date(dob);
                  const age = this.calculateAge(birthDate);
                  if (new Date(todaydate) < new Date(dob)) {
                    element.Dateofbirth = '';
                    isValid = false;
                    FinalMissingCount = true;
                  }
                  else if (dob == 'Invalid Date' || dob == 'Invalid date') {
                    element.Dateofbirth = '';
                    isValid = false;
                    FinalMissingCount = true;
                  }
                  else if (age < 18) {
                    isValid = false;
                    FinalMissingCount = true;
                    element.invalidAge = true;
                  }
                } else {
                  element.Dateofbirth = '';
                }
                if (element.LookbackDate != undefined) {
                  if (new Date(todaydate) < new Date(claimdate)) {
                    element.LookbackDate = '';
                    isValid = false;
                    FinalMissingCount = true;
                  }
                  else if (claimdate == 'Invalid Date' || claimdate == 'Invalid date') {
                    element.LookbackDate = '';
                    isValid = false;
                    FinalMissingCount = true;
                  }
                } else {
                  element.LookbackDate = '';
                }
                if (element.Address != undefined) {
                  const stZipCode = this.extractZipCode(element.Address);
                  console.log("stZipCode", stZipCode);

                  if (!stZipCode) {
                    isValid = false;
                    FinalMissingCount = true;
                  } else {
                    zipcode = stZipCode; // ✅ REQUIRED
                  }
                }

                // if (element.Zip != undefined) {
                //   let Zip = element.Zip.replace(';', ',').split(',')[0];
                //   element.Zip = Zip;
                //   var canadianZipRegex = /^[A-Z][0-9][A-Z][ ][0-9][A-Z][0-9]$/;
                //   var zipRegex = /^\d{5}$/;
                //   let canadianZipIsValid = canadianZipRegex.test(String(element.Zip));
                //   let zipIsValid = zipRegex.test(String(element.Zip));
                //   if ((!canadianZipIsValid && !zipIsValid)) {
                //     element.Zip = '';
                //     isValid = false;
                //     FinalMissingCount = true;
                //   }
                // }

                //   element.Phone = Phone;
                //   let PhnoDataValid = this.onlyNumbers(element.Phone);
                //   if (element.Phone.length != 10 || !PhnoDataValid) {
                //     element.Phone = '';
                //     // isValid = false;
                //     // FinalMissingCount = true;
                //   }
                // }

                if (element.Phone != undefined) {
                  let splitPhone = element.Phone.split(",");
                  if (splitPhone.length > 2) {
                    splitPhone = splitPhone?.slice(0, 2);
                  }
                  let validatedPhone: any[] = [];
                  splitPhone.forEach((validatePhone: any) => {
                    let trimValidatePhone = validatePhone.trim();
                    let phoneValidate = this.onlyNumbers(trimValidatePhone);
                    if (phoneValidate && trimValidatePhone.length == 10) {
                      let formatPhone = trimValidatePhone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');
                      validatedPhone.push(formatPhone);
                    }
                  });
                  element.Phone = validatedPhone;
                  element.Phone = [...new Set(element.Phone)];
                  element.wholePhone =  element.Phone.toString();
                  this.batchPhoneWholeData[index] = element.Phone.toString();
                }

                if (element.Reporttype != undefined) {
                  let Reporttype = element.Reporttype.replace(';', ',').split(',')[0];
                  element.Reporttype = Reporttype;
                }

                // if (element.Email != undefined) {
                //   let Email = element.Email.replace(';', ',').split(',')[0];
                //   element.Email = Email;
                //   const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                //   let status = regularExpression.test(String(Email).toLowerCase());
                //   if (!status) {
                //     element.Email = '';
                //     isValid = false;
                //     FinalMissingCount = true;
                //   }
                // }

                if (element.Email != undefined) {
                  let splitEmail = element.Email.split(",");
                  let validatedEmail: any[] = [];
                  splitEmail.forEach((validationEmail: any) => {
                    let trimValidateEmail = validationEmail.trim();
                    let lowerCaseEmail = trimValidateEmail.toLowerCase();
                    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let status = regularExpression.test(String(lowerCaseEmail).toLowerCase());
                    if (status) {
                      validatedEmail.push(lowerCaseEmail);
                    }
                  });
                  element.Email = validatedEmail;
                  element.Email = [...new Set(element.Email)];
                  element.wholeEmail = element.Email.toString();
                  this.batchEmailWholeData[index] = element.Email.toString();
                }

                if (element.Keyword != undefined) {
                  let splitKeyword = element.Keyword.split(",");
                  let validatedKeyword: any[] = [];
                  splitKeyword.forEach((validationKeyword: any) => {
                    let trimValidateKeyword = validationKeyword.trim();
                    if (trimValidateKeyword != '') {
                      validatedKeyword.push(trimValidateKeyword);
                    }
                  });
                  element.Keyword = validatedKeyword;
                  element.Keyword = [...new Set(element.Keyword)];
                  if (element.Keyword.length > 1) {
                    this.showMoreBatchKeywordText[index] = true;
                  }
                  else {
                    this.showMoreBatchKeywordText[index] = false;
                  }
                }

                if (element.Linkanalysis != undefined) {
                  let splitLinkAnalysis = element.Linkanalysis.split(",");
                  let validatedLinkAnalysis: any[] = [];
                  splitLinkAnalysis.forEach((validationLinkAnalysis: any, index: any) => {
                    let trimValidateLinkAnalysis = validationLinkAnalysis.trim();
                    if (trimValidateLinkAnalysis != '' && index < 3 && !validatedLinkAnalysis.includes(trimValidateLinkAnalysis)) {
                      validatedLinkAnalysis.push(trimValidateLinkAnalysis);
                    }
                  });
                  element.Linkanalysis = validatedLinkAnalysis;
                  element.Linkanalysis = [...new Set(element.Linkanalysis)];
                  if (element.Linkanalysis.length > 1) {
                    this.showMoreBatchLinkAnalysisText[index] = true;
                  }
                  else {
                    this.showMoreBatchLinkAnalysisText[index] = false;
                  }
                }

                if (element.Knownas != undefined) {
                  let splitKnownas = element.Knownas.split(",");
                  let validatedKnownas: any[] = [];
                  splitKnownas.forEach((validationKnownas: any, index: any) => {
                    let trimValidateKnownas = validationKnownas.trim();
                    if (trimValidateKnownas != '' && index < 5 && !validatedKnownas.includes(trimValidateKnownas)) {
                      validatedKnownas.push(trimValidateKnownas);
                    }
                  });
                  element.Knownas = validatedKnownas;
                  element.Knownas = [...new Set(element.Knownas)];
                  if (element.Knownas.length > 1) {
                    this.showMoreBatchKnownAsText[index] = true;
                  }
                  else {
                    this.showMoreBatchKnownAsText[index] = false;
                  }
                }

                if (element.ReferenceId != undefined) {
                  let referenceidIsValid = this.referenceIdRegex.test(String(element.ReferenceId));
                  if (!referenceidIsValid || element.ReferenceId == '') {
                    element.ReferenceId = '';
                    isValid = false;
                    FinalMissingCount = true;
                  }
                }

                if (FinalMissingCount == true) {
                  inMissingDataCount = inMissingDataCount + 1;
                }
                if (element.Limitation != undefined) {
                  var Limitation = this.physicallimitationValidation(element.Limitation)
                  if (!Limitation) {
                    element.Limitation = 0;
                  }
                }

                this.getBatchDataResponse.push({
                  Firstname: element.Firstname == undefined ? '' : element.Firstname,
                  Lastname: element.Lastname == undefined ? '' : element.Lastname,
                  Address: element.Address == undefined ? '' : element.Address,
                  DateofBirth: (element.Dateofbirth == '') ? '' : moment(new Date(element.Dateofbirth)).format("MM/DD/YYYY"),
                  invalidAge: element.invalidAge,
                  Zip: zipcode == undefined ? '' : zipcode, // element.Zip == undefined ? '' : element.Zip,
                  formatPhoneNo: formattedPhoneNo,
                  // Phone: element.Phone == undefined ? '' : element.Phone.slice(0, 10),
                  // Phone: element.Phone == undefined ? '' : this.phoneBatchChrLimit(this.batchPhoneWholeData[index]),
                  Phone: element.Phone == undefined ? '' : this.batchPhoneWholeData[index],
                  wholePhone: element.wholePhone,
                  Email: element.Email == undefined ? '' : this.batchEmailWholeData[index],
                  wholeEmail: element.wholeEmail,
                  Company: element.Company == undefined ? '' : element.Company.toString().slice(0, 40),
                  Occupation: element.Occupation == undefined ? '' : element.Occupation.toString().slice(0, 40),
                  Reporttype: element.Reporttype == undefined ? '' : element.Reporttype,
                  Limitation: element.Limitation == undefined ? '' : element.Limitation,
                  Monitoring: 'Monthly', //element.Monitoring,
                  inStatus: isValid,
                  dtClaimFile: (element.LookbackDate == '') ? '' : moment(new Date(element.LookbackDate)).format("MM/DD/YYYY"),
                  Keyword: element.Keyword == undefined ? '' : element.Keyword.join(", "),
                  LinkAnalysis: element.Linkanalysis == undefined ? '' : element.Linkanalysis.join(", "),
                  Knownas: element.Knownas == undefined ? '' : element.Knownas.join(", "),
                  // Claimid: element.Claimid == undefined ? null : element.Claimid,
                  ReferenceId: element.ReferenceId == undefined ? null : element.ReferenceId,
                  Gender: element.Gender == undefined ? null : this.genderValidator(element.Gender),
                  Notes: element.Notes == undefined ? null : element.Notes,
                  LicensePlate: element.LicensePlate == undefined ? null : element.LicensePlate,
                  State: element.State == undefined ? null : element.State,
                  // ZipCodeValidationMsg : ZipCodeValidationMsg
                })
              });
              this.getBatchDataResponse.sort(function (a, b) { return (b.inStatus > a.inStatus) ? -1 : ((a.inStatus > b.inStatus) ? 1 : 0); });
              // //this.getBatchDataResponse.sort((b, a) => b.RowNumbers.localeCompare(a.RowNumbers));
              // this.validUploadedData = (Number(this.TotaluploadedData)) - Number(inMissingDataCount);
              this.validUploadedData = Number(inMissingDataCount);
              this.isUploadedBatchFile = true;
              if(this.getBatchDataResponse.length > 0){
                this.checkAvailableReportType();
              }
              localStorage.setItem('batchValidRequestData', this.validUploadedData.toString());
              localStorage.setItem('batchRequestData', JSON.stringify(this.getBatchDataResponse));
              document.getElementById("batch-upload-data-info")?.classList.remove("d-none");
              document.getElementById("upload-wrapper")?.classList.remove("uploaded");
              document.getElementById("upload-wrapper")?.classList.add("success");
              this.checkAvailableReportType();
              if (this.isBatch == true && this.isUploadedBatchFile == true) {
                document.getElementById("upload-file")?.setAttribute('Title', this.batchFile.name);
              }
            }
          }
          else {
            this.isUploadedBatchFile = false;
            this.addInvalidClassForFile();
          }
          this.spinner.hide();
        }
      }
      else {
        this.isUploadedBatchFile = false;
        this.addInvalidClassForFile();
      }
    }
  }

  fileValidate(file: File){
    const validFileTypes = ['image/jpeg','image/jpg', 'image/png', 'image/webp', 'image/gif'];
    if(!validFileTypes.includes(file.type)){
      return false;
    }
    return true;
  }

  addFaceImageFile(event: any) {
    if (event.target.files.length > 0) {      
      const file: File = event.target.files[0];
      this.removeInvalidClassFaceImagForFile();
      document.getElementById("face-image-file-upload-name")!.innerHTML = '';      
      if (this.fileValidate(file)) {
        this.spinner.show();
        this.faceImagFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.faceImageUrl = e.target?.result as string;
          document.getElementById("upload-face-image")?.setAttribute('Title', file.name);  
        };
        reader.readAsDataURL(file); 
        this.spinner.hide();
      }else {        
        this.addInvalidClassForFaceImagFile();
      }
    }
  }
  removeFaceImage() {
    this.faceImagFile = null;
    this.faceImageUrl = '';
  }

  genderValidator(value: string) {
    const validValues = ['m', 'f'];
    if (validValues.includes(value.toLowerCase())) {
      return value.toUpperCase();
    }
    return null;
  }

  checkfile(file: any) {
    var validExts:any[];
    if(this.isBatchFileExt == "xls")
    {  
      validExts = new Array(".xlsx", ".xls");
    }
    else if(this.isBatchFileExt == "xml"){
      validExts = new Array(".xml");
    }
    else if (this.isBatchFileExt == "doc") {
      validExts = new Array(".doc", ".docx");
    }
    else
    {
      validExts = new Array(".xlsx", ".xls",".xml", ".doc", ".docx");
    } 
    var fileExt = this.batchFile.name;
    var fileName = this.batchFile.name.split('.').slice(0, -1).join('.');
    fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
    if (validExts.indexOf(fileExt) < 0) {
      return false;
    }
    else {
      var shortname = fileName.substring(0, 20) + " ...";
      document.getElementById("file-upload-name")!.innerHTML = shortname + fileExt;
      return true;
    }
  }

  checkFaceImageFile() {        
    var validExts = new Array(".jpg", ".jpeg", ".png");
    var fileExt = this.faceImagFile?.name;
    var fileName = this.faceImagFile?.name.split('.').slice(0, -1).join('.');
    fileExt = fileExt?.substring(fileExt?.lastIndexOf('.'));
    //if (validExts.indexOf(fileExt) < 0) {
    if (Number(fileExt) < 0) {
      return false;
    }
    else {
      var shortname = fileName?.substring(0, 20) + " ...";
      document.getElementById("face-image-file-upload-name")!.innerHTML = shortname + fileExt;
      return true;
    }
  }

  showModal(content: any) {
    this._modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result: any) => {

        },
        (reason: any) => {

        }
      );
  }

  showModalReviewPopup(content: any) {
    this.getBatchDataResponse.forEach((element: any, index: number) => {
      if (element.wholePhone) {
        element.Phone = this.phoneBatchChrLimit(element.wholePhone)
      }
      if (element.wholeEmail) {
        element.Email = this.emailBatchChrLimit(element.wholeEmail);
      }
    })
    if(this.isBatchFileExt == 'xml')
      {
        this.reviewFormName = 'XML file';
        this.requestText = 'request';
      }
      else if(this.isBatchFileExt == "doc" || this.isBatchFileExt == "docx")
      {
        this.reviewFormName = 'Doc file';
        this.requestText = 'request';
      }
      else if(this.isBatchFileExt == "xls")
      {
        this.reviewFormName = 'batch';
        this.requestText = 'requests';
      }
    setTimeout(() => {
      this._modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: false, keyboard: false, windowClass: 'review-popup-wrapper' })
        .result.then(
          (result) => {
            // this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            // console.log(reason);
            // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }, 1000);
    setTimeout(() => {
      this.blurInput();
    }, 1500)
  }

  selectBatchSuggestion(id: number, suggestion: string) {
    this.getBatchDataResponse[id].Address = suggestion;
    this.batchSelectedAddressMap[id] = this.normalizeAddressForComparison(suggestion);
    this.batchAddressValidationRequestTokenMap[id] = (this.batchAddressValidationRequestTokenMap[id] || 0) + 1;
    this.showSuggestionsMap[id] = false;
    if (this.activeDropdownId === id) {
      this.activeDropdownId = null;
    }
    this.validateBatchZipCode(id, suggestion);
    this.addressValidityMap[id] = true;
    this.setAddressValidity(id, true);
    setTimeout(() => {
      this.updateBatchRowStatus(id);
      const inputEl = document.getElementById(`${id}Address`) as HTMLInputElement;
      inputEl?.dispatchEvent(new Event('blur'));
    }, 0);
  }

  fetchAddressSuggestions(input: string): Promise<string[]> {
    // Replace this mock logic with real API call
    const mock = ['123 Main Street', '45 Park Lane', '89 Broadway']
      .filter(addr => addr.toLowerCase().includes(input.toLowerCase()));
    return Promise.resolve(mock);
  }
  addressValidityMap: { [id: number]: boolean } = {};

  private validateAddressRow(id: number, address: string, eventName?: string): boolean {
    const zip = this.extractZipCode(address);
  
    const usZipRegex = /^\d{5}(-\d{4})?$/;
    const canadaZipRegex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i;
    const ukPostcodeRegex = /^(GIR\s?0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i;
  
    const isValid =
      !!zip &&
      (usZipRegex.test(zip) ||
       canadaZipRegex.test(zip) ||
       ukPostcodeRegex.test(zip));

    console.log('[Batch Address Validate] validateAddressRow', {
      id,
      eventName,
      address,
      extractedZip: zip,
      isValid
    });
  
    // 🔒 store per-row state
    this.addressValidityMap[id] = isValid;
  
    // 🔒 update UI for THIS ROW ONLY
    const el = document.getElementById(id + 'addressValid');
    if (el) {
      isValid ? el.classList.add('d-none') : el.classList.remove('d-none');
    }
  
    // optional API call
    if (eventName === 'blur' && isValid) {
      this.validateBatchAddressWithSuggestions(id, address.trim());
    }
  
    return isValid;
  }

  private setAddressValidity(id: number, isValid: boolean) {
    const el = document.getElementById(id + 'addressValid');
    if (!el) return;
  
    if (isValid) {
      el.classList.add('d-none');
    } else {
      el.classList.remove('d-none');
    }
  }

  // Tick mark function
  changeClaimRequestValues(id: number, property: string, event: any, eventName: any) {
    var editField:any = ""
    this.objsave = false;
      const inputValue = event.target?.value?.trim();

    if (eventName === 'addressKeyup') {
       const skipKeys = ['Control', 'Shift', 'Alt', 'Meta', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    if (event.ctrlKey || event.metaKey || skipKeys.includes(event.key)) {
      return;
    }
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (inputValue && inputValue.length >= 2) {
        if (this.isAddressEnterSelection) {
          this.isAddressEnterSelection = false;
          return;
        }
        this.batchSelectedAddressMap[id] = '';
        const requestToken = (this.batchSuggestionRequestTokenMap[id] || 0) + 1;
        this.batchSuggestionRequestTokenMap[id] = requestToken;
        this._claimMonitorService.getAddressSuggestions(inputValue).subscribe({
          next: (data) => {
            const currentAddress = (this.getBatchDataResponse[id]?.Address ?? '').trim();
            if (this.batchSuggestionRequestTokenMap[id] !== requestToken || currentAddress !== inputValue.trim()) {
              return;
            }
            this.addressSuggestionsMap[id] = data || [];
          
            // 🔴 STEP 1: reset dropdown completely
            this.showSuggestionsMap[id] = false;
            this.activeDropdownId = null;
          
            // 🔴 STEP 2: wait for DOM to settle, then show again
            requestAnimationFrame(() => {
              this.activeDropdownId = id;
              this.showSuggestionsMap[id] = true;
          
              // 🔴 STEP 3: after dropdown is in DOM, position it
              requestAnimationFrame(() => {
                this.updateDropdownPosition(id);
              });
            });
          }, 
          error: (err) => {
            const currentAddress = (this.getBatchDataResponse[id]?.Address ?? '').trim();
            if (this.batchSuggestionRequestTokenMap[id] !== requestToken || currentAddress !== inputValue.trim()) {
              return;
            }
            console.error('API error:', err);
            this.addressSuggestionsMap[id] = [];
            this.showSuggestionsMap[id] = false;
            if (this.activeDropdownId === id) {
              this.activeDropdownId = null;
            }
          }
        });
      } else {
        // Clear suggestions if less than 3 characters
        this.addressSuggestionsMap[id] = [];
        this.showSuggestionsMap[id] = false;
        if (this.activeDropdownId === id) {
          this.activeDropdownId = null;
        }
      }
      this.onScroll(null);
    },)
  }

    if (eventName === 'blur') {
      setTimeout(() => {
        this.showSuggestionsMap[id] = false;
        if (this.activeDropdownId === id) {
          this.activeDropdownId = null;
        }
      }, 200);
    }
    if (property == "Reporttype" || property == "dtClaimFile" || property == 'DateofBirth' || property == 'genderType') {
      editField = event;
    }
    else if (property == "Zip") {
      editField = event.target.value;
    }
    else if (property == "Firstname") {
      editField = event.target.value;
    }
    else if (property == "Lastname") {
      editField = event.target.value;
    }
    else if (property == "Address") {
      editField = event.target.value;
    }
    else {
      editField = event.target.value.replace(/\s/g, "");
    }
    var CalimFileDate = (property == "dtClaimFile" && (eventName == 'oncloseDatePicker')) ? moment(editField).format("MM/DD/YYYY") : document.getElementById(id + "dtClaimFile") == null ? '' : (<HTMLInputElement>document.getElementById(id + "dtClaimFile")).value;
    var DateofBirth = (property == "DateofBirth" && (eventName == 'oncloseDatePicker')) ? moment(editField).format("MM/DD/YYYY") : document.getElementById(id + "DateofBirth") == null ? '' : (<HTMLInputElement>document.getElementById(id + "DateofBirth")).value;
    var FirstName = document.getElementById(id + "Firstname") == null ? '' : (<HTMLInputElement>document.getElementById(id + "Firstname")).value;
    var LastName = document.getElementById(id + "Lastname") == null ? '' : (<HTMLInputElement>document.getElementById(id + "Lastname")).value;
    var Address = document.getElementById(id + "Address") == null ? '' : (<HTMLInputElement>document.getElementById(id + "Address")).value;
    // var ZipCode = document.getElementById(id + "Zipcode") == null ? '' : (<HTMLInputElement>document.getElementById(id + "Zipcode")).value;
    var ReferenceId = document.getElementById(id + "ReferenceId") == null ? '' : (<HTMLInputElement>document.getElementById(id + "ReferenceId")).value;
    var inStatus = this.getBatchDataResponse[id]['inStatus'];
    var ReportType = (<HTMLInputElement>document.getElementById(id + "ddlReportType")).value;
    let genderType = (<HTMLInputElement>document.getElementById(id + "genderType")).value;
    let Datestatus = moment(DateofBirth).format("DD/MM/YYYY");
    let ClaimFileDateStatus = moment(CalimFileDate).format("DD/MM/YYYY");
    let IsDateofbirthCheck = (document.getElementById(id + 'DateofBirthInvalid') as HTMLElement).classList.contains('d-none');
    let isAgeValid = !(document.getElementById(id + 'DateofBirth') as HTMLElement).classList.contains('invalid-age');
    let IsClaimfileDateCheck = (document.getElementById(id + 'ClaimfileDateInvalid') as HTMLElement).classList.contains('d-none');
    // let IsValidZipCode = (document.getElementById(id + 'ZipCodevalid') as HTMLElement).classList.contains('d-none');
    let isFirstNameValid = (document.getElementById(id + 'firstNameValid') as HTMLElement).classList.contains('d-none');
    let isLastNameValid = (document.getElementById(id + 'lastNameValid') as HTMLElement).classList.contains('d-none');
    // Use validated address state so status doesn't flip to tick when clicking Reference/Report type etc.
    // (addressValid span starts with d-none in template, so reading from DOM was incorrectly true until Address blur.)
    let isAddressValid = (property === 'Address') ? (document.getElementById(id + 'addressValid') as HTMLElement)?.classList.contains('d-none') : this.validateAddressRow(id, Address);
    let isReferenceIdValid = (document.getElementById(id + 'referenceIdValid') as HTMLElement).classList.contains('d-none');
    // let IsValidClaimId = (document.getElementById(id + 'ClaimIDvalid') as HTMLElement).classList.contains('d-none');
    if (property == "Firstname") {
      // const isValidFirstName = this.batchfullNameValidate(editField);
      isFirstNameValid = this.nameRegex.test(String(editField)) && editField.trim().length > 0;
      let lastNameValue = LastName !== undefined ? LastName : '';
      let isLastNameValidForCheck = this.nameRegex.test(String(lastNameValue)) && lastNameValue.trim().length > 0;
      if (editField.length > 0 && isFirstNameValid) {
        document.getElementById(id + 'firstNameValid')?.classList.add("d-none");
        document.getElementById(id + 'Firstname')?.classList.remove("invalid-input");
      } else {
        document.getElementById(id + 'Firstname')?.classList.add("invalid-input");
        document.getElementById(id + 'firstNameValid')?.classList.remove("d-none");
        isFirstNameValid = false;
      }

      // Always update inStatus for batch row
      if (editField.trim() === "" || !isFirstNameValid || lastNameValue.trim() === "" || !isLastNameValidForCheck || DateofBirth === "" || Address === "" || CalimFileDate === "" || ReferenceId === "" || ReportType === "" || IsDateofbirthCheck === false || isAddressValid === false || isAgeValid === false || IsClaimfileDateCheck === false || isReferenceIdValid === false) {
        if(inStatus == true)
          this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      } else {
        if(inStatus == false)
        {
          this.validUploadedData = Math.max(0, this.validUploadedData - 1);
          
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
    }

    if (property == "Lastname") {
      isLastNameValid = this.nameRegex.test(String(editField)) && editField.trim().length > 0;
      let firstNameValue = FirstName !== undefined ? FirstName : '';
      let isFirstNameValidForCheck = this.nameRegex.test(String(firstNameValue)) && firstNameValue.trim().length > 0;
      if (editField.length > 0 && isLastNameValid) {
        document.getElementById(id + 'lastNameValid')?.classList.add("d-none");
        document.getElementById(id + 'Lastname')?.classList.remove("invalid-input");
      } else {
        document.getElementById(id + 'Lastname')?.classList.add("invalid-input");
        document.getElementById(id + 'lastNameValid')?.classList.remove("d-none");
        isLastNameValid = false;
      }

      // Always update inStatus for batch row
      if (editField.trim() === "" || !isLastNameValid || firstNameValue.trim() === "" || !isFirstNameValidForCheck || DateofBirth === "" || Address === "" || CalimFileDate === "" || ReferenceId === "" || ReportType === "" || IsDateofbirthCheck === false || isAddressValid === false || isAgeValid === false || IsClaimfileDateCheck === false || isReferenceIdValid === false) {
        if(inStatus == true)
          this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      } else {
        if(inStatus == false){
          this.validUploadedData = Math.max(0, this.validUploadedData - 1);
          
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
    }

    if (property == "DateofBirth") {
        const date = editField?.target?.value || editField;
        const age = this.calculateAge(new Date(date));
        const regularExpression = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/?|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2)(\/?|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/?|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        let status = regularExpression.test(String(DateofBirth).toLowerCase());
        if (age < 18 || isNaN(age) || !status) {
          document.getElementById(id + 'DateofBirth')?.classList.add("invalid-age");
          document.getElementById(id + 'DateofBirthInvalid')?.classList.remove("d-none");
          if (this.getBatchDataResponse[id]['inStatus']) {
            this.validUploadedData = (this.validUploadedData + 1);            
          }
          this.getBatchDataResponse[id]['inStatus'] = false;
        } else {
            document.getElementById(id + 'DateofBirth')?.classList.remove("invalid-age");
            document.getElementById(id + 'DateofBirthInvalid')?.classList.add("d-none");
            if ((editField != "" && FirstName != "" && LastName != "" && Address != "" && CalimFileDate != "" /*&& ZipCode != ""*/
               &&  ReferenceId != "" && ReportType != "" && Datestatus != 'Invalid date' && IsDateofbirthCheck == true && isAddressValid == true
                && IsClaimfileDateCheck == true && /*IsValidZipCode == true &&*/ isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true) && (inStatus == false)) {
              if (!this.getBatchDataResponse[id]['inStatus']) {
                this.validUploadedData = Math.max(0, this.validUploadedData - 1);
                
             }
              this.getBatchDataResponse[id]['inStatus'] = true;
            }
        }
    }

    if (property == "genderType") {
      if ((editField == "" || FirstName == "" || LastName == "" || DateofBirth == "" || Address == "" || CalimFileDate == "" /*|| ZipCode == ""*/ || ReferenceId == "" 
        || ReportType == "" || IsDateofbirthCheck == false || isAddressValid == false || isAgeValid == false || IsClaimfileDateCheck == false /*|| IsValidZipCode == false */
        || isFirstNameValid == false || isLastNameValid == false || isReferenceIdValid == false)) {
        if(inStatus == true)
        this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      }
      else if ((editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && Address != "" && CalimFileDate != "" /*&& ZipCode != "" */
        && ReferenceId != "" && ReportType != "" && IsDateofbirthCheck == true && isAddressValid == true && isAgeValid == true && IsClaimfileDateCheck == true /*&& IsValidZipCode == true*/
         && isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
        if(inStatus == false){
        this.validUploadedData = Math.max(0, this.validUploadedData - 1);
        
      }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
      this.getBatchDataResponse.sort(function (a, b) { return (b.inStatus > a.inStatus) ? -1 : ((a.inStatus > b.inStatus) ? 1 : 0); });
    }

    if (property == "ReferenceId") {
      const isValidReferenceId = this.batchReferenceIdValidate(editField);
      if(isValidReferenceId == true){
        document.getElementById(id + 'referenceIdValid')?.classList.add("d-none");
        document.getElementById(id + 'ReferenceId')?.classList.remove("invalid-input");
      }
      else{
        document.getElementById(id + 'ReferenceId')?.classList.add("invalid-input");
        document.getElementById(id + 'referenceIdValid')?.classList.remove("d-none");
      }
      isReferenceIdValid = (document.getElementById(id + 'referenceIdValid') as HTMLElement).classList.contains('d-none'); 
    
      if ((editField == "" || FirstName == "" || LastName == "" || DateofBirth == "" || Address == "" || CalimFileDate == "" /*|| ZipCode == ""*/ 
        || ReportType == "" || IsDateofbirthCheck == false || isAddressValid == false  || isAgeValid == false || IsClaimfileDateCheck == false /*|| IsValidZipCode == false */
        || isFirstNameValid == false || isLastNameValid == false || isReferenceIdValid == false)) {
        if(inStatus == true)
        this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      }
      else if ((editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && Address != "" && CalimFileDate != "" /*&& ZipCode != ""*/ 
        && ReportType != "" && IsDateofbirthCheck == true && isAddressValid == true && isAgeValid == true && IsClaimfileDateCheck == true /*&& IsValidZipCode == true*/
         && isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
        if(inStatus == false){
        this.validUploadedData = Math.max(0, this.validUploadedData - 1);
        
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
    }

    if (property === "Address") {
      const editField = event.target.value;
      // ✅ SINGLE SOURCE OF TRUTH
      const isAddressValid = this.validateAddressRow(
        id,
        editField,
        eventName
      );
      // ✅ Update row status using ONLY row-specific state
      const shouldBeInvalid =
        editField.trim() === '' ||
        FirstName === '' ||
        LastName === '' ||
        DateofBirth === '' ||
        CalimFileDate === '' ||
        ReferenceId === '' ||
        ReportType === '' ||
        IsDateofbirthCheck === false ||
        isAddressValid === false ||
        isAgeValid === false ||
        IsClaimfileDateCheck === false ||
        isFirstNameValid === false ||
        isLastNameValid === false ||
        isReferenceIdValid === false;
    
      if (shouldBeInvalid) {
        if (this.getBatchDataResponse[id]['inStatus'] === true) {
          this.validUploadedData++;
        }
        this.getBatchDataResponse[id]['inStatus'] = false;
      } else {
        if (this.getBatchDataResponse[id]['inStatus'] === false) {
          this.validUploadedData = Math.max(0, this.validUploadedData - 1);
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
    
      return; // 🔒 VERY IMPORTANT – stop further execution
    }


    if (property == "Reporttype") {
      if ((editField == "" || FirstName == "" || LastName == "" || DateofBirth == "" || Address == "" || CalimFileDate == "" /*|| ZipCode == ""*/
        || ReferenceId == "" || IsDateofbirthCheck == false || isAddressValid == false || isAgeValid == false || IsClaimfileDateCheck == false /*|| IsValidZipCode == false*/
         || isFirstNameValid == false || isLastNameValid == false || isReferenceIdValid == false)) {
        if(inStatus == true)
        this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      }
      else if ((editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && Address != "" && CalimFileDate != "" /*&& ZipCode != ""*/
         &&  ReferenceId != "" && IsDateofbirthCheck == true && isAddressValid == true && isAgeValid == true && IsClaimfileDateCheck == true /*&& IsValidZipCode == true*/
          && isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
        if(inStatus == false){
        this.validUploadedData = Math.max(0, this.validUploadedData - 1);
        
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
      this.getBatchDataResponse.sort(function (a, b) { return (b.inStatus > a.inStatus) ? -1 : ((a.inStatus > b.inStatus) ? 1 : 0); });
      // Run address validation when report type changes so row check/cross reflects address validity
      const addr = (Address || this.getBatchDataResponse[id]?.Address || '').toString().trim();
      if (addr) {
        const zipRegex = /^\d{5}$/;
        const canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z]( [0-9][a-zA-Z][0-9])?$/;
        const ukPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}( [0-9][A-Z]{2})?$/i;
        const stZipCode = this.extractZipCode(addr);
        const zipValid = zipRegex.test(stZipCode) || canadianZipRegex.test(stZipCode) || ukPostcodeRegex.test(stZipCode);
        if (stZipCode.length > 0 && zipValid) {
          this.validateBatchAddressWithSuggestions(id, addr);
        }
      }
    }

    if (property == "dtClaimFile") {
      if (editField) {
        const date = editField?.target?.value ? editField?.target?.value : editField;
        let validdate = moment(date).format("MM/DD/YYYY");
        let today = moment(new Date()).format("MM/DD/YYYY");
        const regularExpression = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/?|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2)(\/?|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/?|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
        let status = regularExpression.test(String(CalimFileDate).toLowerCase());
        if (new Date(today.toString()) < new Date(validdate.toString()) || !status) {
          document.getElementById(id + 'dtClaimFile')?.classList.add("invalid-input");
          document.getElementById(id + 'ClaimfileDateInvalid')?.classList.remove("d-none");
            if (!(editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && Address != "" /*&& ZipCode != ""*/
               &&  ReferenceId != "" && ReportType != "" && ClaimFileDateStatus != 'Invalid date' && IsDateofbirthCheck == true 
               && isAddressValid == true && isAgeValid == true && IsClaimfileDateCheck == true && /*IsValidZipCode == true &&*/
                isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
              if (this.getBatchDataResponse[id]['inStatus']) {
                this.validUploadedData = (this.validUploadedData + 1);
              } 
              this.getBatchDataResponse[id]['inStatus'] = false;
            }
        } else {
          if ((editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && Address != "" /*&& ZipCode != "" */
            &&  ReferenceId != "" && ReportType != "" && ClaimFileDateStatus != 'Invalid date' && IsDateofbirthCheck == true 
            && isAddressValid == true && isAgeValid == true && /*IsValidZipCode == true &&*/ isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
            if (!this.getBatchDataResponse[id]['inStatus']) {
              this.validUploadedData = Math.max(0, this.validUploadedData - 1);
              
            }
            this.getBatchDataResponse[id]['inStatus'] = true;
            document.getElementById(id + 'dtClaimFile')?.classList.remove("invalid-input");
            document.getElementById(id + 'ClaimfileDateInvalid')?.classList.add("d-none");
          }
        }
      }
    }
    if (property == "Zipcode" || property == "Zip") {
      // IsValidZipCode = (document.getElementById(id + 'ZipCodevalid') as HTMLElement).classList.contains('d-none');
      if ((editField == "" || FirstName == "" || LastName == "" || DateofBirth == "" || CalimFileDate == "" || ReferenceId == "" || ReportType == "" /*|| IsValidZipCode == false */
        || IsDateofbirthCheck == false || isAddressValid == false || isAgeValid == false || IsClaimfileDateCheck == false || isFirstNameValid == false || isLastNameValid == false || isReferenceIdValid == false)) {
        if(inStatus == true)
        this.validUploadedData = (this.validUploadedData + 1);
        this.getBatchDataResponse[id]['inStatus'] = false;
      }
      else if ((editField != "" && FirstName != "" && LastName != "" && DateofBirth != "" && CalimFileDate != "" &&  ReferenceId != "" && ReportType != "" /*&& IsValidZipCode == true */
        && IsDateofbirthCheck == true && isAddressValid == true && isAgeValid == true && IsClaimfileDateCheck == true && isFirstNameValid == true && isLastNameValid == true && isReferenceIdValid == true)) {
        if(inStatus == false){
        this.validUploadedData = Math.max(0, this.validUploadedData - 1);
        
        }
        this.getBatchDataResponse[id]['inStatus'] = true;
      }
    }
  }

  onInputChange(event: any, id: any, datepickerRef: any) {
    const value = event.target.value;
  
    if (!value || value.trim() === '') {
      // Also clear the datepicker's selected date
      datepickerRef.bsValue = null;
    }
  }
  closeAddressDropdown() {
    this.activeDropdownId = null;
    this.showSuggestions = false;
    this.showAdditionalAddressSuggestions = false;
  }

  /**
   * Returns true if focus is inside any address input or its suggestion dropdown
   * (main form Address, batch Address, or Additional address modal).
   */
  private isFocusInsideAnyAddressArea(): boolean {
    const el = this.document?.activeElement as HTMLElement;
    if (!el) return false;
    return !!(
      el.closest('.address-input') ||
      el.closest('.addr-dd-root') ||
      el.closest('.additional-address-input') ||
      el.closest('.additional-address-suggestions') ||
      el.id === 'txtAddress' ||
      el.id === 'txtAdditionalAddress' ||
      el.closest('.suggestion-box')
    );
  }

  /**
   * Call from blur of any address/additional-address input.
   * After a short delay, closes dropdowns if focus has left all address areas.
   */
  onAddressOrAdditionalAddressBlur(): void {
    setTimeout(() => {
      if (!this.isFocusInsideAnyAddressArea()) {
        this.closeAddressDropdown();
      }
    }, 0);
  }
  

  onDateFieldblur(id: number, property: string, event: any, datepickerRef:any) {
    const currentDate = moment(this.getBatchDataResponse[id][property]).format('MM/DD/YYYY')
    if ((!datepickerRef?.isOpen || currentDate != event?.target?.value ) && event?.target?.value !== 'Invalid date') {
      this.changeClaimRequestValues(id, property, event, 'blur');
    }
  }


  checkLength(id: number, property: string, event: any, length: number) {
    const editField = event.target.value;

    if (event.key == 'Enter' || event.keyCode == 13) {
      return false;
    }
    if (editField.length >= length)
      return false;

    if (property == "Phone") {
      let editphone = event.target.value.replace(/\s/g, "");
      if (editphone.length == 12) {
        document.getElementById(id + 'Phonevalid')?.classList.add("d-none");
        this.phoneValidCount[id] = false;
      }
    }

    if (property == "Email") {
      const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let status = regularExpression.test(String(editField).toLowerCase());
      if (status) {
        document.getElementById(id + 'Emailvalid')?.classList.add("d-none");
        this.emailValidCount[id] = false;
      }
    }
    return true;
  }

  // batchzipValidation(id: number, event: any) {
  //   // var stZipCode = (document.getElementById(id + 'Zipcode') as HTMLInputElement)?.value;
  //   // var zipRegex = /^\d{5}$/;
  //   // var canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$/;
  //   // let zipIsValid = zipRegex.test(String(stZipCode));
  //   // let canadianZipIsValid = canadianZipRegex.test(String(stZipCode));
  //   // if (stZipCode.length > 0) {
  //   //   if (!zipIsValid && !canadianZipIsValid) {
  //   //     document.getElementById(id + 'Zipcode')?.classList.add("invalid-input");
  //   //     document.getElementById(id + 'ZipCodevalid')?.classList.remove("d-none");
  //   //   } else {
  //   //     document.getElementById(id + 'Zipcode')?.classList.remove("invalid-input");
  //   //     document.getElementById(id + 'ZipCodevalid')?.classList.add("d-none");
  //   //   }
  //   // } else {
  //   //   document.getElementById(id + 'Zipcode')?.classList.remove("invalid-input");
  //   //   document.getElementById(id + 'ZipCodevalid')?.classList.add("d-none");
  //   // }
  // }

  private validateBatchZipCode(id: number, address: string): void {
    const zipRegex = /^\d{5}$/;
    // Canadian: accepts full format or partial (3 chars)
    var canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z]( [0-9][a-zA-Z][0-9])?$/;
    // UK: accepts full format or partial (2-4 chars)
    var ukPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}( [0-9][A-Z]{2})?$/i;
    const stZipCode = this.extractZipCode(address.trim());
    
    const zipIsValid = zipRegex.test(stZipCode);
    const canadianZipIsValid = canadianZipRegex.test(stZipCode);
    const ukPostcodeIsValid = ukPostcodeRegex.test(stZipCode);
    
    const errorElement = document.getElementById(id + 'addressValid');
    
    if (stZipCode.length > 0) {
        if (!zipIsValid && !canadianZipIsValid && !ukPostcodeIsValid) {
            errorElement?.classList.remove('d-none');
        } else {
            errorElement?.classList.add('d-none');
        }
    } else {
        errorElement?.classList.add('d-none');
    }
  }

  /**
   * Validates that the batch row address is a real address (matches API suggestions).
   * Wrong address with valid zip (e.g. "Test, NY, USA, 10101") should be invalid.
   */
  private validateBatchAddressWithSuggestions(id: number, address: string): void {
    const trimmed = address?.trim();
    if (!trimmed) return;
    const normalizedTrimmed = this.normalizeAddressForComparison(trimmed);

    const zipRegex = /^\d{5}$/;
    const canadianZipRegex = /^[a-zA-Z][0-9][a-zA-Z]( [0-9][a-zA-Z][0-9])?$/;
    const ukPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}( [0-9][A-Z]{2})?$/i;
    const stZipCode = this.extractZipCode(trimmed);
    const zipValid = zipRegex.test(stZipCode) || canadianZipRegex.test(stZipCode) || ukPostcodeRegex.test(stZipCode);
    if (stZipCode.length === 0 || !zipValid) return;

    if (this.batchSelectedAddressMap[id] && this.batchSelectedAddressMap[id] === normalizedTrimmed) {
      console.log('[Batch Address Validate] validateBatchAddressWithSuggestions:skip-selected-suggestion', {
        id,
        address: trimmed
      });
      this.addressValidityMap[id] = true;
      this.setAddressValidity(id, true);
      this.updateBatchRowStatus(id);
      return;
    }

    console.log('[Batch Address Validate] validateBatchAddressWithSuggestions:start', {
      id,
      address: trimmed,
      extractedZip: stZipCode,
      zipValid
    });

    const errorElement = document.getElementById(id + 'addressValid');
    const inputElement = document.getElementById(id + 'Address');

    if (!errorElement && !inputElement) {
      console.log('[Batch Address Validate] validateBatchAddressWithSuggestions:skip-dom-missing', {
        id,
        address: trimmed
      });
      return;
    }

    const requestToken = (this.batchAddressValidationRequestTokenMap[id] || 0) + 1;
    this.batchAddressValidationRequestTokenMap[id] = requestToken;

    this._claimMonitorService.getAddressSuggestions(trimmed).subscribe({
      next: (suggestions: string[]) => {
        const currentAddress = (this.getBatchDataResponse[id]?.Address ?? (inputElement as HTMLInputElement)?.value ?? '').trim();
        const normalizedCurrentAddress = this.normalizeAddressForComparison(currentAddress);
        if (this.batchAddressValidationRequestTokenMap[id] !== requestToken || normalizedCurrentAddress !== normalizedTrimmed) return;

        const hasMatch = (suggestions || []).some(s => this.normalizeAddressForComparison(s) === normalizedCurrentAddress);
        this.addressValidityMap[id] = hasMatch;
        this.setAddressValidity(id, hasMatch);
        console.log('[Batch Address Validate] validateBatchAddressWithSuggestions:result', {
          id,
          address: currentAddress,
          suggestionsCount: suggestions?.length ?? 0,
          hasMatch,
          errorElementHidden: errorElement?.classList.contains('d-none')
        });
        this.updateBatchRowStatus(id);
      },
      error: () => {
        const currentAddress = (this.getBatchDataResponse[id]?.Address ?? (inputElement as HTMLInputElement)?.value ?? '').trim();
        const normalizedCurrentAddress = this.normalizeAddressForComparison(currentAddress);
        if (this.batchAddressValidationRequestTokenMap[id] !== requestToken || normalizedCurrentAddress !== normalizedTrimmed) return;
        console.log('[Batch Address Validate] validateBatchAddressWithSuggestions:error', {
          id,
          address: currentAddress
        });
        this.addressValidityMap[id] = false;
        errorElement?.classList.remove('d-none');
        this.updateBatchRowStatus(id);
      }
    });
  }

  /** Recomputes and sets inStatus and validUploadedData for a single batch row from DOM. */
  private updateBatchRowStatus(id: number): void {
    const row = this.getBatchDataResponse[id];
    if (!row) return;

    const addressInput = document.getElementById(id + 'Address') as HTMLInputElement | null;
    const firstNameInput = document.getElementById(id + 'Firstname') as HTMLInputElement | null;
    const lastNameInput = document.getElementById(id + 'Lastname') as HTMLInputElement | null;
    const dobInput = document.getElementById(id + 'DateofBirth') as HTMLInputElement | null;
    const claimFileInput = document.getElementById(id + 'dtClaimFile') as HTMLInputElement | null;
    const referenceIdInput = document.getElementById(id + 'ReferenceId') as HTMLInputElement | null;
    const reportTypeInput = document.getElementById(id + 'ddlReportType') as HTMLInputElement | null;
    const dobInvalidEl = document.getElementById(id + 'DateofBirthInvalid') as HTMLElement | null;
    const claimFileInvalidEl = document.getElementById(id + 'ClaimfileDateInvalid') as HTMLElement | null;
    const firstNameInvalidEl = document.getElementById(id + 'firstNameValid') as HTMLElement | null;
    const lastNameInvalidEl = document.getElementById(id + 'lastNameValid') as HTMLElement | null;
    const referenceIdInvalidEl = document.getElementById(id + 'referenceIdValid') as HTMLElement | null;

    // When review modal is closed, these elements are not present.
    // Avoid recomputing row status from missing DOM and accidentally flipping valid rows to invalid.
    if (
      !addressInput ||
      !firstNameInput ||
      !lastNameInput ||
      !dobInput ||
      !claimFileInput ||
      !referenceIdInput ||
      !reportTypeInput ||
      !dobInvalidEl ||
      !claimFileInvalidEl ||
      !firstNameInvalidEl ||
      !lastNameInvalidEl ||
      !referenceIdInvalidEl
    ) {
      return;
    }

    const Address = addressInput?.value ?? row.Address ?? '';
    const FirstName = firstNameInput?.value ?? row.Firstname ?? '';
    const LastName = lastNameInput?.value ?? row.Lastname ?? '';
    const DateofBirth = dobInput?.value ?? row.DateofBirth ?? '';
    const CalimFileDate = claimFileInput?.value ?? row.dtClaimFile ?? '';
    const ReferenceId = referenceIdInput?.value ?? row.ReferenceId ?? '';
    const ReportType = reportTypeInput?.value ?? row.Reporttype ?? '';
    const IsDateofbirthCheck = dobInvalidEl?.classList.contains('d-none') ?? false;
    const isAgeValid = !(dobInput?.classList.contains('invalid-age') ?? false);
    const IsClaimfileDateCheck = claimFileInvalidEl?.classList.contains('d-none') ?? false;
    const isAddressValid = this.validateAddressRow(id, Address);
    const isFirstNameValid = firstNameInvalidEl?.classList.contains('d-none') ?? false;
    const isLastNameValid = lastNameInvalidEl?.classList.contains('d-none') ?? false;
    const isReferenceIdValid = referenceIdInvalidEl?.classList.contains('d-none') ?? false;

    const inStatus = !!row.inStatus;
    const allValid = !!(
      Address && FirstName && LastName && DateofBirth && CalimFileDate && ReferenceId && ReportType &&
      IsDateofbirthCheck && isAgeValid && IsClaimfileDateCheck && isAddressValid &&
      isFirstNameValid && isLastNameValid && isReferenceIdValid
    );

    const missingElements = [
      !addressInput ? `${id}Address` : null,
      !firstNameInput ? `${id}Firstname` : null,
      !lastNameInput ? `${id}Lastname` : null,
      !dobInput ? `${id}DateofBirth` : null,
      !claimFileInput ? `${id}dtClaimFile` : null,
      !referenceIdInput ? `${id}ReferenceId` : null,
      !reportTypeInput ? `${id}ddlReportType` : null,
      !dobInvalidEl ? `${id}DateofBirthInvalid` : null,
      !claimFileInvalidEl ? `${id}ClaimfileDateInvalid` : null,
      !firstNameInvalidEl ? `${id}firstNameValid` : null,
      !lastNameInvalidEl ? `${id}lastNameValid` : null,
      !referenceIdInvalidEl ? `${id}referenceIdValid` : null
    ].filter(Boolean);

    const invalidFields = [
      !Address ? 'Address empty' : null,
      Address && !isAddressValid ? 'Address invalid' : null,
      !FirstName ? 'FirstName empty' : null,
      FirstName && !isFirstNameValid ? 'FirstName invalid' : null,
      !LastName ? 'LastName empty' : null,
      LastName && !isLastNameValid ? 'LastName invalid' : null,
      !DateofBirth ? 'DateofBirth empty' : null,
      DateofBirth && !IsDateofbirthCheck ? 'DateofBirth invalid' : null,
      !isAgeValid ? 'Age invalid' : null,
      !CalimFileDate ? 'ClaimFileDate empty' : null,
      CalimFileDate && !IsClaimfileDateCheck ? 'ClaimFileDate invalid' : null,
      !ReferenceId ? 'ReferenceId empty' : null,
      ReferenceId && !isReferenceIdValid ? 'ReferenceId invalid' : null,
      !ReportType ? 'ReportType empty' : null
    ].filter(Boolean);

    console.log('[Batch Address Validate] updateBatchRowStatus', {
      id,
      Address,
      isAddressValid,
      IsDateofbirthCheck,
      isAgeValid,
      IsClaimfileDateCheck,
      isFirstNameValid,
      isLastNameValid,
      isReferenceIdValid,
      inStatusBefore: inStatus,
      allValid,
      missingElements,
      invalidFields
    });

    if (allValid) {
      if (!inStatus) this.validUploadedData = Math.max(0, this.validUploadedData - 1);
      row.inStatus = true;
    } else {
      if (inStatus) this.validUploadedData = this.validUploadedData + 1;
      row.inStatus = false;
    }
  }

  batchNameValidation(id: number, name: string, validationName: string) {    
    let stName = (document.getElementById(id + name) as HTMLInputElement)?.value;
    let stNameIsValid = this.nameRegex.test(String(stName));
    if (stName.length > 0) {
      if (!stNameIsValid || stName == " ") {
        document.getElementById(id + name)?.classList.add("invalid-input");
        document.getElementById(id + validationName)?.classList.remove("d-none");
      }
      // else if (stName.trim().split(' ').length < 2) {
      //   document.getElementById(id + name)?.classList.add("invalid-input");
      //   document.getElementById(id + validationName)?.classList.remove("d-none");
      // }
      else {
        document.getElementById(id + name)?.classList.remove("invalid-input");
        document.getElementById(id + validationName)?.classList.add("d-none");
      }
    }
  }

    batchAddressValidation(id: number, address: string, validationAddress: string) {    
    let stAddress = (document.getElementById(id + address) as HTMLInputElement)?.value;
    let stAddressIsValid = this.multipleSpacesRegex.test(String(stAddress));
    if (stAddress.length > 0) {
      if (!stAddressIsValid || stAddress == " ") {
        document.getElementById(id + address)?.classList.add("invalid-input");
        document.getElementById(id + validationAddress)?.classList.remove("d-none");
      }
      else if (stAddress.trim().split(' ').length < 2) {
        document.getElementById(id + address)?.classList.add("invalid-input");
        document.getElementById(id + validationAddress)?.classList.remove("d-none");
      }
      else {
        document.getElementById(id + address)?.classList.remove("invalid-input");
        document.getElementById(id + validationAddress)?.classList.add("d-none");
      }
    }
  }
  
  isValidFullName(name: string): boolean {
    if (!name || name.trim() === '') {
      return false; // Invalid if empty
    }
  
    const nameParts = name.trim().split(/\s+/); // Split by spaces
    return nameParts.length == 1; // Valid if there are at least two parts
  }
  setDynamicClassesForFullName(name: string, id: number, type: 'firstname' | 'lastname' = 'firstname'): string {
    const elementId = type === 'firstname' ? `${id}firstNameValid` : `${id}lastNameValid`;
    if (!name || name.trim() === '') {
      document.getElementById(elementId)?.classList.remove("d-none");
      return 'search span-text InputBlank blank-fullname-input-width'; // Empty input classes
    }
    // Use class-level regex validation for both first and last name
    const isValid = this.nameRegex.test(name);
    if (isValid) {
      document.getElementById(elementId)?.classList.add("d-none");
      return 'search-no-border span-text InputData input-width w-100P'; // Valid input classes
    } else {
      document.getElementById(elementId)?.classList.remove("d-none");
      return 'search-no-border span-text InputData input-width invalid-input w-100P'; // Invalid input classes
    }
  }

    setDynamicClassesForAddress(address: string, id: number): string {
    if (!address || address.trim() === '') {
      document.getElementById(id + "addressValid")?.classList.remove("d-none");
      return 'search span-text InputBlank blank-fullname-input-width'; // Empty input classes
    }
  
    const isValid = this.isValidFullName(address);
    if(isValid){
      document.getElementById(id + "addressValid")?.classList.add("d-none");
      return 'search-no-border span-text InputData input-width w-100P' // Valid input classes
    }
    else{
      document.getElementById(id + "addressValid")?.classList.remove("d-none");
      return 'search-no-border span-text InputData input-width invalid-input w-100P'; // Invalid input classes
    }
  }
  
  referenceIdValidation(id: number, event: any) {
    var referenceId = (document.getElementById(id + 'ReferenceId') as HTMLInputElement)?.value;
    let referenceIdIsValid = this.referenceIdRegex.test(String(referenceId));
    if (referenceId.length > 0) {
      if (!referenceIdIsValid) {
        document.getElementById(id + 'ReferenceId')?.classList.add("invalid-input");
        document.getElementById(id + 'ReferenceIdvalid')?.classList.remove("d-none");
      }
      // else if(stClaimId.length == 0) {
      //   document.getElementById(id + 'ReferenceIdvalid')?.classList.add("d-none");
      // }
      else {
        document.getElementById(id + 'ReferenceId')?.classList.remove("invalid-input");
        document.getElementById(id + 'ReferenceIdvalid')?.classList.add("d-none");
      }
    } else {
      document.getElementById(id + 'ReferenceId')?.classList.add("invalid-input");
      document.getElementById(id + 'ReferenceIdvalid')?.classList.remove("d-none");
    }
  }

  // Blank black box when record remove
  updateList(id: number, property: string, event: any) {
    var editField = "";
    if (property == "Phone") {
      editField = event.target.value.replace(/\s/g, "");
      if (editField != '') {
        if (editField.length < 13) {
          document.getElementById(id + 'Phonevalid')?.classList.remove("d-none");
          this.phoneValidCount[id] = true;
        }
        else {
          document.getElementById(id + 'Phonevalid')?.classList.add("d-none");
          this.phoneValidCount[id] = false;
        }
      }
    }
    else if (property == "Zip") {
      editField = event.target.value;
    }
    else if (property == "Firstname") {
      editField = event.target.value;
    }
    else if(property == "Lastname"){
      editField = event.target.value;
    }
    else if(property == "Address"){
      editField = event.target.value;
    }
    else {
      editField = event.target.value.replace(/\s/g, ""); //event.target.textContent.replace(/\s/g, "");
    }

    if (property == 'Email') {
      if (editField != '') {
        const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let status = regularExpression.test(String(editField).toLowerCase());
        if (status) {
          document.getElementById(id + 'Emailvalid')?.classList.add("d-none");
          this.emailValidCount[id] = false;
        }
        else {
          document.getElementById(id + 'Emailvalid')?.classList.remove("d-none");
          this.emailValidCount[id] = true;
        }
      }
    }


    this.getBatchDataResponse[id][property] = editField;

    if (document.getElementById(id + property) != null) {
      document.getElementById(id + property)!.innerText = editField;
    }

    if (property == "Phone") {
      if (editField != '') {
        document.getElementById(id + property)?.classList.remove("search");
        document.getElementById(id + property)?.classList.remove("phoneInputBlank");
        document.getElementById(id + property)?.classList.add("search-no-border");
        document.getElementById(id + property)?.classList.add("phoneInputData");
        document.getElementById(id + property)?.classList.add("dollor-before");
      }
      else {
        document.getElementById(id + property)?.classList.remove("search-no-border");
        document.getElementById(id + property)?.classList.remove("phoneInputData");
        document.getElementById(id + property)?.classList.remove("dollor-before");
        document.getElementById(id + property)?.classList.add("search");
        document.getElementById(id + property)?.classList.add("phoneInputBlank");
      }
    }

    if (editField != '') {
      document.getElementById(id + property)?.classList.remove("search");
      document.getElementById(id + property)?.classList.remove("InputBlank");
      document.getElementById(id + property)?.classList.add("search-no-border");
      document.getElementById(id + property)?.classList.add("InputData");
      document.getElementById(id + property)?.classList.add("dollor-before");
    }
    else {
      document.getElementById(id + property)?.classList.remove("search-no-border");
      document.getElementById(id + property)?.classList.remove("InputData");
      document.getElementById(id + property)?.classList.remove("dollor-before");
      document.getElementById(id + property)?.classList.add("search");
      document.getElementById(id + property)?.classList.add("InputBlank");
    }
    // check if age value updated


    // for (var i = 0; i != this.getBatchDataResponse.length; i++) {

    //   if (this.getBatchDataResponse[i].FirstName == "" || this.getBatchDataResponse[i].FirstName == undefined) {
    //     this.getBatchDataResponse[i].FirstName = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].LastName == "" || this.getBatchDataResponse[i].LastName == undefined) {
    //     this.getBatchDataResponse[i].LastName = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].CompanyName == "" || this.getBatchDataResponse[i].CompanyName == undefined || this.getBatchDataResponse[i].CompanyName == null) {
    //     this.getBatchDataResponse[i].CompanyName = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].Age == "" || this.getBatchDataResponse[i].Age == undefined || this.getBatchDataResponse[i].Age == null) {
    //     this.getBatchDataResponse[i].Age = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].PhoneNo == "" || this.getBatchDataResponse[i].PhoneNo == undefined || this.getBatchDataResponse[i].PhoneNo == null) {
    //     this.getBatchDataResponse[i].PhoneNo = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].Email == "" || this.getBatchDataResponse[i].Email == undefined || this.getBatchDataResponse[i].Email == null) {
    //     this.getBatchDataResponse[i].Email = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].ZipCode == "" || this.getBatchDataResponse[i].ZipCode == undefined || this.getBatchDataResponse[i].ZipCode == null) {
    //     this.getBatchDataResponse[i].ZipCode = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].Monitoring == "" || this.getBatchDataResponse[i].Monitoring == undefined || this.getBatchDataResponse[i].Monitoring == null) {
    //     this.getBatchDataResponse[i].Monitoring = editField;
    //   }
    //   else if (this.getBatchDataResponse[i].Occupation == "" || this.getBatchDataResponse[i].Occupation == undefined || this.getBatchDataResponse[i].Occupation == null) {
    //     this.getBatchDataResponse[i].Occupation = editField;
    //   }

    // }

    this.getBatchDataResponse.sort(function (a, b) { return (b.inStatus > a.inStatus) ? -1 : ((a.inStatus > b.inStatus) ? 1 : 0); });
  }

  sort(field: string, order: any): void {
    this.upFirstname = false;
    this.downFirstname = false;
    this.upLastname = false;
    this.downLastname = false;
    this.upBirthyear = false;
    this.downBirthyear = false;
    this.upAddress = false;
    this.downAddress= false;
    this.upPhone = false;
    this.downPhone = false;
    this.upEmail = false;
    this.downEmail = false;
    this.upKeyword = false;
    this.downKeyword = false;
    this.upLinkAnalysis = false;
    this.downLinkAnalysis = false;
    this.upPhyLimitation = false;
    this.downPhyLimitation = false;
    this.upReferenceID = false;
    this.downReferenceID = false;
    this.upZipcode = false;
    this.downZipcode = false;
    this.upReporttype = false;
    this.downReporttype = false;
    this.upClaimFile = false;
    this.downClaimFile = false;
    this.upCheck = false;
    this.downCheck = false;
    this.upGender = false;
    this.downGender = false;

    if (field == 'Firstname') {
      if (order == 'asc') {
        this.upFirstname = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Firstname < b.Firstname) ? -1 : ((b.Firstname < a.Firstname) ? 1 : 0); })
      } else {
        this.downFirstname = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Firstname > b.Firstname) ? -1 : ((b.Firstname > a.Firstname) ? 1 : 0); })
      }

    }
    else if (field == 'Lastname') {
      if (order == 'asc') {
        this.upLastname = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Lastname < b.Lastname) ? -1 : ((b.Lastname < a.Lastname) ? 1 : 0); })
      } else {
        this.downLastname = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Lastname > b.Lastname) ? -1 : ((b.Lastname > a.Lastname) ? 1 : 0); })
      }
    } 
    else if (field == 'Dateofbirth') {
      if (order == 'asc') {
        this.upBirthyear = true;
        this.getBatchDataResponse.sort(function (a, b) {
          return (new Date(a.DateofBirth == '' ? new Date() : a.DateofBirth) < new Date(b.DateofBirth == '' ? new Date() : b.DateofBirth)) ? -1 : ((new Date(b.DateofBirth == '' ? new Date() : b.DateofBirth) < new Date(a.DateofBirth == '' ? new Date() : a.DateofBirth)) ? 1 : 0);
        })
      } else {
        this.downBirthyear = true;
        this.getBatchDataResponse.sort(function (a, b) {
          return (new Date(a.DateofBirth == '' ? new Date() : a.DateofBirth) > new Date(b.DateofBirth == '' ? new Date() : b.DateofBirth)) ? -1 : ((new Date(b.DateofBirth == '' ? new Date() : b.DateofBirth) > new Date(a.DateofBirth == '' ? new Date() : a.DateofBirth)) ? 1 : 0);
        })
      }
    }
    else if (field == 'Address') {
      if (order == 'asc') {
        this.upAddress = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Address < b.Address) ? -1 : ((b.Address < a.Address) ? 1 : 0); })
      } else {
        this.downAddress = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Address > b.Address) ? -1 : ((b.Address > a.Address) ? 1 : 0); })
      }
    }
    else if (field == 'Phone') {
      if (order == 'asc') {
        this.upPhone = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Phone < b.Phone) ? -1 : ((b.Phone < a.Phone) ? 1 : 0); })
      } else {
        this.downPhone = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Phone > b.Phone) ? -1 : ((b.Phone > a.Phone) ? 1 : 0); })
      }
    } else if (field == 'Email') {
      if (order == 'asc') {
        this.upEmail = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Email < b.Email) ? -1 : ((b.Email < a.Email) ? 1 : 0); })
      } else {
        this.downEmail = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Email > b.Email) ? -1 : ((b.Email > a.Email) ? 1 : 0); })
      }
    } else if (field == 'Keyword') {
      if (order == 'asc') {
        this.upKeyword = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Keyword < b.Keyword) ? -1 : ((b.Keyword < a.Keyword) ? 1 : 0); })
      } else {
        this.downKeyword = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Keyword > b.Keyword) ? -1 : ((b.Keyword > a.Keyword) ? 1 : 0); })
      }
    } else if (field == 'LinkAnalysis') {
      if (order == 'asc') {
        this.upLinkAnalysis = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.LinkAnalysis < b.LinkAnalysis) ? -1 : ((b.LinkAnalysis < a.LinkAnalysis) ? 1 : 0); })
      } else {
        this.downLinkAnalysis = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.LinkAnalysis > b.LinkAnalysis) ? -1 : ((b.LinkAnalysis > a.LinkAnalysis) ? 1 : 0); })
      }
    } else if (field == 'Limitation') {
      if (order == 'asc') {
        this.upPhyLimitation = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Limitation < b.Limitation) ? -1 : ((b.Limitation < a.Limitation) ? 1 : 0); })
      } else {
        this.downPhyLimitation = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Limitation > b.Limitation) ? -1 : ((b.Limitation > a.Limitation) ? 1 : 0); })
      }
    } else if (field == 'Gender') {
      if (order == 'asc') {
        this.upGender = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Gender < b.Gender) ? -1 : ((b.Gender < a.Gender) ? 1 : 0); })
      } else {
        this.downGender = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Gender > b.Gender) ? -1 : ((b.Gender > a.Gender) ? 1 : 0); })
      }
    } else if (field == 'ReferenceId') {
      if (order == 'asc') {
        this.upReferenceID = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.ReferenceId < b.ReferenceId) ? -1 : ((b.ReferenceId < a.ReferenceId) ? 1 : 0); })
      } else {
        this.downReferenceID = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.ReferenceId > b.ReferenceId) ? -1 : ((b.ReferenceId > a.ReferenceId) ? 1 : 0); })
      }
    } 
    // else if (field == 'Zip') {
    //   if (order == 'asc') {
    //     this.upZipcode = true;
    //     this.getBatchDataResponse.sort(function (a, b) { return (a.Zip < b.Zip) ? -1 : ((b.Zip < a.Zip) ? 1 : 0); })
    //   } else {
    //     this.downZipcode = true;
    //     this.getBatchDataResponse.sort(function (a, b) { return (a.Zip > b.Zip) ? -1 : ((b.Zip > a.Zip) ? 1 : 0); })
    //   }
    // }
    else if (field == 'inStatus') {
      if (order == 'asc') {
        this.upCheck = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.inStatus < b.inStatus) ? -1 : ((b.inStatus < a.inStatus) ? 1 : 0); })
      } else {
        this.downCheck = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.inStatus > b.inStatus) ? -1 : ((b.inStatus > a.inStatus) ? 1 : 0); })
      }
    }
    else if (field == 'Reporttype') {
      if (order == 'asc') {
        this.upReporttype = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Reporttype < b.Reporttype) ? -1 : ((b.Reporttype < a.Reporttype) ? 1 : 0); })
      } else {
        this.downReporttype = true;
        this.getBatchDataResponse.sort(function (a, b) { return (a.Reporttype > b.Reporttype) ? -1 : ((b.Reporttype > a.Reporttype) ? 1 : 0); })
      }
    }
    else if (field == 'ClaimFile') {
      if (order == 'asc') {
        this.upClaimFile = true;
        this.getBatchDataResponse.sort(function (a, b) {
          return (new Date(a.dtClaimFile == '' ? new Date() : a.dtClaimFile) < new Date(b.dtClaimFile == '' ? new Date() : b.dtClaimFile)) ? -1 : ((new Date(b.dtClaimFile == '' ? new Date() : b.dtClaimFile) < new Date(a.dtClaimFile == '' ? new Date() : a.dtClaimFile)) ? 1 : 0);
        })
      } else {
        this.downClaimFile = true;
        this.getBatchDataResponse.sort(function (a, b) {
          return (new Date(a.dtClaimFile == '' ? new Date() : a.dtClaimFile) > new Date(b.dtClaimFile == '' ? new Date() : b.dtClaimFile)) ? -1 : ((new Date(b.dtClaimFile == '' ? new Date() : b.dtClaimFile) > new Date(a.dtClaimFile == '' ? new Date() : a.dtClaimFile)) ? 1 : 0);
        })
      }
    }
  }

  downloadSample() {
    if(this.isBatchFileExt == "xls")
      {
        window.open('/assets/images/request.xlsx', '_blank');
      }
      else if(this.isBatchFileExt == "xml")
      {
        const link = this.document.createElement('a');
        link.href ='/assets/images/request.xml';
        link.download = 'request.xml';
        this.document.body.appendChild(link);
        link.click();
        this.document.body.removeChild(link);
      }
      else
      {
        const link = this.document.createElement('a');
        link.href ='/assets/images/request.docx';
        link.download = 'request.docx';
        this.document.body.appendChild(link);
        link.click();
        this.document.body.removeChild(link);
      }
  }

  // Hide Modal
  hideModal() {
    this._modalService.dismissAll("");
  }

  cancelFunction() {
    this.matDialogRef.close();
  }

  cancelSaveBatchRequestRecords() {
    // this.IsUploadedBatchFile = false;
    this.phoneValidCount = [];
    this.emailValidCount = [];
    this.isManuallyDateChange = false;
    this.isManuallyClaimChange = false;
    this._modalService.dismissAll("");
    var data = JSON.parse(localStorage.getItem('batchRequestData') || '{}');
    data.forEach((element: any, index: any) => {
      if (element.DateofBirth != undefined) {
        if (new Date(element.DateofBirth).toString() == 'Invalid Date') {
          element.DateofBirth = '';
        }
      }
      if (element.dtClaimFile != undefined) {
        if (new Date(element.dtClaimFile).toString() == 'Invalid Date') {
          element.dtClaimFile = '';
        }
      }
    })
    this.getBatchDataResponse = data;
    this.validUploadedData = Number(localStorage.getItem('batchValidRequestData'));
    const sourceReports =
  this.selectedTeamAvailableReports && this.selectedTeamAvailableReports.trim() !== ""
    ? this.selectedTeamAvailableReports
    : this.availableReportTypesData;
    this.setReportFlags(sourceReports);
    if(this.getBatchDataResponse.length > 0){
      this.setReportFlags(sourceReports);
      this.checkAvailableReportType();
    }
    this.hideModal();
  }

  payLoadForClientsData() {
    this.listingBodyParameter = commonConstant.listingBodyParameterClients;
    this.listingBodyParameter.clientId = null;
    this.listingBodyParameter.stSearchText = '';
    this.listingBodyParameter.stSortColumn = 'dtUpdatedOn';
    this.listingBodyParameter.stSortOrder = 'DESC';
    this.listingBodyParameter.inLimit = 10000;
  }

  getClientById() {
    let data = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    let modal = {
      TimeZone: CommonFunction.GetTimeZone(),
      clientId: data.clientId,
      stSearchText: "",
      stSortColumn: "stClient",
      stSortOrder: "asc",
      inOffset: 0,
      inLimit: 0
    };
    this.spinner.show();
    this._clientService.getClientById(modal).subscribe(
      {
        next: (response) => {
          if (!!response) {
            const selectedClient = response.data.resultSet[0].stReportTypes
            this.availableReportTypesData = selectedClient || ""; // e.g., "1,2,3"
            this.setReportFlags(selectedClient);
            this.loCurrentTeamId = localStorage.getItem('selectedTeamId');
            const reportType = this.loCurrentTeamId == null ? data?.teamDetails?.[0]?.inReportType :  data?.teamDetails?.find((o: { uiTeamId: any; }) => o.uiTeamId == this.loCurrentTeamId)?.inReportType;;
            this.reportTypeId = (reportType !== 0 && reportType != null) ? reportType : response?.data?.resultSet?.[0]?.inReportType;
            this.reportTypeIdXls = this.reportTypeId;
            localStorage.setItem('inReportType', JSON.stringify(this.reportTypeId));
            this.spinner.hide();
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          }
        }
      }
    );
  }

  getTeamById(): Promise<any> {
    const teamId = localStorage.getItem('selectedTeamId');
    if (!teamId) {
      return Promise.resolve(false); 
    }
    const clientId = JSON.parse(localStorage.getItem('currentUserData') || '{}')?.clientId;
  
    const modal = {
      TeamId: teamId,
      uiClientID: clientId,
      inOffset: 0,
      inLimit: 0,
      stSearchText: "",
      stSortColumn: "stTeam",
      stSortOrder: "asc"
    };

    return this._teamService.getteamByTeamId(modal).toPromise().then((response: any) => {
      this.reportTypeId = response.inReportType;
      this.reportTypeIdXls = response.inReportType;
    });
  }


  // To get all client list except Inactive & Expire
  getClientsData() {
    this.userteams = [];
    this.formSubmission.get('stUserTeam')?.setValue('');
    // this.spinner.show();
    this.listingBodyParameter.TimeZone = CommonFunction.GetTimeZone();
    this._clientService.getActiveClients(this.listingBodyParameter.TimeZone).subscribe(
      {
        next: (response) => {
          if (response.getActiveClientsList.length > 0) {
            this.clientsData = response.getActiveClientsList;
            this.clientsData.sort((a: any, b: any) => a.stClient.localeCompare(b.stClient, 'en-US', { caseFirst: 'upper' }));
            this.spinner.hide();
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error != undefined) {
            if (error.status == 401) {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              this._Router.navigate(['login']);
            }
            else if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error');
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
          }
        }
      }
    );
  }

  payLoadForUsersData() {
    this.listingUserBodyParameter = {
      inLimit: 10000,
      inOffset: 0,
      stSearchText: "",
      stSortColumn: "dtCreatedOn",
      stSortOrder: "desc"
    }
  }

  //To disable the Report type 
  setReportFlags(availableReportTypes: string) {
    this.isBasicReport = false;
    this.isIdentityReport = false;
    this.isEnhancedReport = false;
    this.isMonitoringReport = false;

    const sourceReports =
  this.selectedTeamAvailableReports && this.selectedTeamAvailableReports.trim() !== ""
    ? this.selectedTeamAvailableReports
    : this.availableReportTypesData;
    if (sourceReports) {
        const reportTypes = sourceReports.split(',').map(item => parseInt(item.trim()));
        reportTypes.forEach(type => {
            switch(type) {
                case 1:
                    this.isBasicReport = true;
                    break;
                case 2:
                    this.isEnhancedReport = true; 
                    break;
                case 3:
                    this.isMonitoringReport = true;
                    break;
                case 4:
                    this.isIdentityReport = true;
                    break;
            }
        });
    }
}

  // To get user list of user against their client
  onChangeClient(event: any) {
    this.spinner.show();
    this.formSubmission.get('stExaminer')?.setValue('');
    this.userData = [];
    this.formSubmission.get('stUserTeam')?.setValue('');
    this.userteams = [];
    this.selectedTeamAvailableReports = "";
    this.listingUserBodyParameter.TimeZone = CommonFunction.GetTimeZone();
    this.listingUserBodyParameter.uiCLientId = event.target.value;
    this.reportTypeId = this.clientsData.find((o: { uiClientId: any; })=>o.uiClientId==event.target.value)?.inReportType;
    this.reportTypeIdXls = this.reportTypeId;
    const selectedClient = this.clientsData.find((o: { uiClientId: any; }) => o.uiClientId == event.target.value)?.stReportTypes;
    this.availableReportTypesData = selectedClient || ""; // e.g., "1,2,3"
    this.setReportFlags(selectedClient);
    this.isFileExist = true;
    /*if(this.getBatchDataResponse.length == 0 && this.isBatch){
      this.isFileExist = false;
      event.target.value = "";
      this.spinner.hide();
      return;
    } */
    if(this.getBatchDataResponse.length > 0){
      this.setReportFlags(selectedClient);
      this.checkAvailableReportType();
    }

    this._userService.getUsers(this.listingUserBodyParameter).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.userData = response.data?.resultSet;
              if (response.data) {
                this.userData = response.data?.resultSet.filter((user: any) => {
                  return (user.userType != 'Report Reviewer' && user.userType != 'API User' && user.userType != 'Approver') && user.status == 'Active';
                });
              }
              this.userData.sort((a: any, b: any) => a.stName.localeCompare(b.stName, 'en-US', { caseFirst: 'upper' }));
              this.spinner.hide();
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          if (error != undefined) {
            if (error.status == 401) {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              this._Router.navigate(['login']);
            }
            else if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error');
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
          }
        }
      }
    );
  }

  onChangeExaminer(event: any) {
    this.selectedTeamAvailableReports = "";
    this.spinner.show();
    this.formSubmission.get('stUserTeam')?.setValue('');
    this.userteams = [];
    this.reportTypeId = this.clientsData.find((o: { uiClientId: any; })=>o.uiClientId==this.listingUserBodyParameter.uiCLientId)?.inReportType;
    this.reportTypeIdXls = this.reportTypeId;
    const selectedClient = this.clientsData.find((o: { uiClientId: any; }) => o.uiClientId == this.listingUserBodyParameter.uiCLientId)?.stReportTypes;
    this.availableReportTypesData = selectedClient || ""; // e.g., "1,2,3"
    this.setReportFlags(selectedClient);
    this.isFileExist = true;

    /* if(this.getBatchDataResponse.length == 0 && this.isBatch){
      this.isFileExist = false;
      event.target.value = "";
      this.spinner.hide();
      return;
    } */
    if(this.getBatchDataResponse.length > 0){
      this.setReportFlags(selectedClient);
      this.checkAvailableReportType();
    }
    this._userService.GetUserTeamByUserId(event.target.value).subscribe({
      next: (response) => {
        if (!!response) {
          if (response.userTeams != null && response.userTeams.length > 0) {
            this.userteams = response.userTeams;
          }
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
        if (error != undefined) {
          if (error.status == 401) {
            this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            this._Router.navigate(['login']);
          }
          else if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error');
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      }
    });
  }

  onChangeTeam(event: any): void {
  const selectedTeamId = event?.target?.value;

  const selectedTeam = this.userteams.find((o: { uiTeamId: any }) => o.uiTeamId == selectedTeamId);
  this.reportTypeId = selectedTeam?.inReportType;
  this.reportTypeIdXls = this.reportTypeId;
  const selectedTeamReports = this.userteams.find((o: { uiTeamId: any; }) => o.uiTeamId == event.target.value)?.stReportTypes;
  this.selectedTeamAvailableReports = selectedTeamReports || ""; // e.g., "1,2,3"
  this.setReportFlags(selectedTeamReports);
  /*if(this.getBatchDataResponse.length == 0 && this.isBatch){
    this.isFileExist = false;
    event.target.value = "";
    this.spinner.hide();
    return;
  } */
  if(this.getBatchDataResponse.length > 0){
    this.setReportFlags(selectedTeamReports);
    this.checkAvailableReportType();
  }

  if (this.reportTypeId == 0 || this.reportTypeId == null) {
    const selectedClient = this.clientsData.find((o: { uiClientId: any }) => o.uiClientId == this.listingUserBodyParameter.uiCLientId);
    this.reportTypeId = selectedClient?.inReportType;
    this.reportTypeIdXls = this.reportTypeId;
    const selectedTeamReports = this.clientsData.find((o: { uiTeamId: any; }) => o.uiTeamId == event.target.value)?.stReportTypes;
    this.selectedTeamAvailableReports = selectedTeamReports || ""; // e.g., "1,2,3"
    this.setReportFlags(selectedTeamReports);
    if(this.getBatchDataResponse.length > 0){
      this.setReportFlags(selectedTeamReports);
      this.checkAvailableReportType();
    }
  }
}

  // Calculate age by date
  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

   onDatepickerClosed(id: number, property: string, value: any): void {  
    if (!this.isManuallyDateChange) {
        this.changeClaimRequestValues(id, property, value, 'oncloseDatePicker');
    }
  }
 
  fetchSuggestions(value: string): void {
    this._claimMonitorService.getAddressSuggestions(value).subscribe({
      next: (data) => {
        this.addressSuggestions = data || [];
        this.showSuggestions = true;
      },
      error: (err) => {
        console.error('API error:', err);
        this.addressSuggestions = [];
        this.showSuggestions = false;
      }
    });
  }

  selectSuggestion(suggestion: string): void {
    this.suppressNextSuggestions = true;
    this.formSubmission.get('stAddress')?.setValue(suggestion, { emitEvent: true });
    this.showSuggestions = false;
    this.addressSelected =true;
    this.zipValidation();
    this.addressSuggestions=[];
  }

   addressOnFocus(): void {
    if (this.addressSuggestions.length) {
      this.showSuggestions = true;
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInsideInput = target.closest('#txtAddress');
    const clickedInsideList = target.closest('.suggestion-box');
    if (!clickedInsideInput && clickedInsideList) {
      this.showSuggestions = false;
    }
  }

  onScroll(event:any) {
    const scrollDiv = event?.target as HTMLElement;
    const el = document.getElementById("addressColumn");
    if (el) {
      this.scrollPosition = scrollDiv ? scrollDiv.scrollLeft : this.scrollPosition;
      const rect = el.offsetLeft - this.scrollPosition;
      this.addressColumnPos.left = (rect);
    }
    // Update dropdown position if visible
    if (this.activeDropdownId !== null) {
      this.updateDropdownPosition(this.activeDropdownId);
    }
  }

  onAddressInputFocus(id: number, event: any) {
    // Do NOT open dropdown on focus
    this.activeDropdownId = id;
  }

  updateDropdownPosition(id: number) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
  
        const input = document.getElementById(`${id}Address`) as HTMLElement;
        const modalBody = document.querySelector('.modal-body-census') as HTMLElement;
  
        if (!input || !modalBody) return;
  
        // 🔹 Always anchor to the INPUT (not td)
        const anchorRect = input.getBoundingClientRect();
        const modalRect = modalBody.getBoundingClientRect();
  
        const dropdownDiv = document.querySelector(
          `.addr-dd-root[data-batch-id="${id}"]`
        ) as HTMLElement;
  
        if (!dropdownDiv) return;
  
        const dropdownHeight = Math.min(dropdownDiv.scrollHeight || 200, 200);
  
        const GAP = 6;
  
        // Space check
        const spaceBelow = window.innerHeight - anchorRect.bottom;
        const spaceAbove = anchorRect.top;
  
        let viewportTop: number;
  
        // ✅ Prefer opening BELOW always
        if (spaceBelow >= dropdownHeight + GAP) {
          viewportTop = anchorRect.bottom + GAP;
        } else {
          viewportTop = anchorRect.top - dropdownHeight - GAP;
        }
  
        // Horizontal anchor
        const viewportLeft = anchorRect.left;
  
        // Convert viewport → modal coords
        let top = viewportTop - modalRect.top + 93;
        const left = viewportLeft - modalRect.left - 10;
  
        // 🚨 HARD SAFETY: never allow dropdown above modal
        if (top < 0) {
          top = anchorRect.bottom - modalRect.top + 93 + GAP;
        }
  
        // Apply styles
        dropdownDiv.style.top = `${top}px`;
        dropdownDiv.style.left = `${left}px`;
        dropdownDiv.style.width = `${anchorRect.width}px`;
  
        this.cdr.detectChanges();
  
      });
    });
  }

  onAddressInputKeydown(event: KeyboardEvent) {
    if (!this.showSuggestions || !this.addressSuggestions.length) return;
  
    if (event.key === 'ArrowDown') {
      this.highlightedAddressSuggestionIndex =
        (this.highlightedAddressSuggestionIndex + 1) % this.addressSuggestions.length;
      this.scrollAddressView();
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.highlightedAddressSuggestionIndex =
        (this.highlightedAddressSuggestionIndex - 1 + this.addressSuggestions.length) % this.addressSuggestions.length;
      this.scrollAddressView();
      event.preventDefault();
    } else if (event.key === 'Enter') {
      if (
        this.highlightedAddressSuggestionIndex >= 0 &&
        this.highlightedAddressSuggestionIndex < this.addressSuggestions.length
      ) {
        this.selectSuggestion(this.addressSuggestions[this.highlightedAddressSuggestionIndex]);
        this.addressValidate();
        this.showSuggestions = false;
        event.preventDefault();
      }
    } else if (event.key === 'Escape') {
      this.showSuggestions = false;
      event.preventDefault();
    }
    else if (event.key === 'Tab') {
      this.showSuggestions = false;
      event.preventDefault();
    }
  }
  
  scrollAddressView() {
    setTimeout(() => {
      const listItems = document.querySelectorAll('.suggestion-box .list-group-item');
      if (
        this.highlightedAddressSuggestionIndex >= 0 &&
        this.highlightedAddressSuggestionIndex < listItems.length
      ) {
        const element = listItems[this.highlightedAddressSuggestionIndex] as HTMLElement;
        element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }
  

  onBatchAddressInputKeydown(event: KeyboardEvent, id: number) {
    const suggestions = this.addressSuggestionsMap[id] || [];
    if (!this.showSuggestionsMap[id] || !suggestions.length) return;
  
    if (!(id in this.highlightedBatchAddressSuggestionIndex)) {
      this.highlightedBatchAddressSuggestionIndex[id] = -1;
    }
  
    if (event.key === 'ArrowDown') {
      this.highlightedBatchAddressSuggestionIndex[id] =
        (this.highlightedBatchAddressSuggestionIndex[id] + 1) % suggestions.length;
      this.scrollBatchAddress(id);
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.highlightedBatchAddressSuggestionIndex[id] =
        (this.highlightedBatchAddressSuggestionIndex[id] - 1 + suggestions.length) % suggestions.length;
      this.scrollBatchAddress(id);
      event.preventDefault();
    } else if (event.key === 'Enter') {
      const idx = this.highlightedBatchAddressSuggestionIndex[id];
      if (idx >= 0 && idx < suggestions.length) {
        this.isAddressEnterSelection = true;
        this.selectBatchSuggestion(id, suggestions[idx]);
        this.showSuggestionsMap[id] = false;
        if (this.activeDropdownId === id) {
          this.activeDropdownId = null;
        }
        event.preventDefault();
      }
    } else if (event.key === 'Escape') {
      this.showSuggestionsMap[id] = false;
      if (this.activeDropdownId === id) {
        this.activeDropdownId = null;
      }
      event.preventDefault();
    }
     else if (event.key === 'Tab') {
      this.showSuggestionsMap[id] = false;
      if (this.activeDropdownId === id) {
        this.activeDropdownId = null;
      }
      event.preventDefault();
    }
  }

  scrollBatchAddress(id: number) {
    setTimeout(() => {
      const listGroup = document.querySelector(`.suggestion-box[data-batch-id="${id}"]`);
      if (!listGroup) return;
  
      const listItems = listGroup.querySelectorAll('.list-group-item');
      const index = this.highlightedBatchAddressSuggestionIndex[id];
  
      if (index >= 0 && index < listItems.length) {
        const element = listItems[index] as HTMLElement;
        element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }  
  @HostListener('document:mousedown', ['$event'])
onClickOutside(event: MouseEvent) {
  const target = event.target as HTMLElement;

  const clickedInsideInput =
    target.closest('.address-input') || target.closest('.additional-address-input');

  const clickedInsideDropdown =
    target.closest('.addr-dd-root') || target.closest('.additional-address-suggestions');

  if (!clickedInsideInput && !clickedInsideDropdown) {
    this.closeAddressDropdown();
  }
}


}

export function genderValidaton(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^[MF]$/.test(control.value);
    return valid ? null : { 'invalidGender': { value: control.value } };
  };
}